// import Quagga, { QuaggaJSResultObject } from "@ericblade/quagga2";
import * as _ from "lodash-es";
import moment from "moment";
import React, { ChangeEvent, Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { FormattedMessage, FormattedNumber } from "react-intl";
import ReactModal from "react-modal";
import { NumericFormat } from "react-number-format";
import { DragEndEvent, DragStartEvent } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";

import { SidebarProps } from "react-sidebar";
import quickBooksIcon from "../../../assets/images/quickbooks/QB_16x16.png";
import IConvertQuoteToOrderDTO from "../../../models/DTO/IConvertQuoteToOrderDTO";
import ICreateBackorderDTO from "../../../models/DTO/ICreateBackorderDTO";
import ICreatePickListDTO from "../../../models/DTO/ICreatePickListDTO";
import ICreatePurchaseOrdersFromOrderDTO from "../../../models/DTO/ICreatePurchaseOrdersFromOrderDTO";
import IDeleteOrderEntryItemDTO from "../../../models/DTO/IDeleteOrderEntryItemDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetOrderDTO from "../../../models/DTO/IGetOrderDTO";
import IGetPriceGroupsDTO from "../../../models/DTO/IGetPriceGroupsDTO";
import IGetPurchaseOrderDetailForOrderDTO from "../../../models/DTO/IGetPurchaseOrderDetailForOrderDTO";
import IInsufficientInventoryDTO from "../../../models/DTO/IInsufficientInventoryDTO";
import IBackorderLimitExceededResponseDTO from "@models/DTO/IBackorderLimitExceededResponseDTO";
import IBackorderLimitExceededItem from "@models/DTO/IBackorderLimitExceededItem";
import IOnConvertQuoteToOrderDTO from "../../../models/DTO/IOnConvertQuoteToOrderDTO";
import IOnCreateBackorderDTO from "../../../models/DTO/IOnCreateBackorderDTO";
import IOnCreateFileUploadDTO from "../../../models/DTO/IOnCreateFileUploadDTO";
import IOnCreateOrderEntryItemDTO from "../../../models/DTO/IOnCreateOrderEntryItemDTO";
import IOnCreateOrderEntryItemsDTO from "../../../models/DTO/IOnCreateOrderEntryItemsDTO";
import IOnCreatePickListDTO from "../../../models/DTO/IOnCreatePickListDTO";
import IOnCreatePurchaseOrdersFromOrderDTO from "../../../models/DTO/IOnCreatePurchaseOrdersFromOrderDTO";
import IOnDeleteOrderEntryItemDTO from "../../../models/DTO/IOnDeleteOrderEntryItemDTO";
import IOnGetOrderDTO from "../../../models/DTO/IOnGetOrderDTO";
import IOnGetOrderEntryDetailDTO from "../../../models/DTO/IOnGetOrderEntryDetailDTO";
import IOnGetPriceGroupsDTO from "../../../models/DTO/IOnGetPriceGroupsDTO";
import IOnGetPurchaseOrderDetailForOrderDTO from "../../../models/DTO/IOnGetPurchaseOrderDetailForOrderDTO";
import IOnPerformOrderInventoryCheckDTO from "../../../models/DTO/IOnPerformOrderInventoryCheckDTO";
import IOnProcessOrderEntryItemsDTO from "../../../models/DTO/IOnProcessOrderEntryItemsDTO";
import IOnQBOCreateEstimateDTO from "../../../models/DTO/IOnQBOCreateEstimateDTO";
import IOnReconcileOfflineOrderEntryItemsDTO from "../../../models/DTO/IOnReconcileOfflineOrderEntryItemsDTO";
import IOnRenumberOrderItemsDTO from "../../../models/DTO/IOnRenumberOrderItemsDTO";
import IOnResendEmailDTO from "../../../models/DTO/IOnResendEmailDTO";
import IUpdateOrderItemsSortOrderDTO from "../../../models/DTO/IUpdateOrderItemsSortOrderDTO";
import IOnUpdateOrderItemsSortOrderDTO from "../../../models/DTO/IOnUpdateOrderItemsSortOrderDTO";
import IOnResendOrderAutomationDTO from "../../../models/DTO/IOnResendOrderAutomationDTO";
import IOnTaxJarCalculateSalesTaxDTO from "../../../models/DTO/IOnTaxJarCalculateSalesTaxDTO";
import IOnUpdateOrderEntryDetailDTO from "../../../models/DTO/IOnUpdateOrderEntryDetailDTO";
import IOnUpdateOrderEntryFineDetailsDTO from "../../../models/DTO/IOnUpdateOrderEntryFineDetailsDTO";
import IOnUpdateOrderEntryItemDTO from "../../../models/DTO/IOnUpdateOrderEntryItemDTO";
import IOrderRowConfig from "../../../models/DTO/IOrderRowConfig";
import IPerformOrderInventoryCheckDTO from "../../../models/DTO/IPerformOrderInventoryCheckDTO";
import IProcessOrderEntryItemsDTO from "../../../models/DTO/IProcessOrderEntryItemsDTO";
import IQBOCreateEstimateDTO from "../../../models/DTO/IQBOCreateEstimateDTO";
import IQBOCreateInvoiceDTO from "../../../models/DTO/IQBOCreateInvoiceDTO";
import IQBODeleteEstimateDTO from "../../../models/DTO/IQBODeleteEstimateDTO";
import IQBODeleteInvoiceDTO from "../../../models/DTO/IQBODeleteInvoiceDTO";
import IQBOGetPDFInvoiceDTO from "../../../models/DTO/IQBOGetPDFInvoiceDTO";
import IQBOOnDeleteEstimateDTO from "../../../models/DTO/IQBOOnDeleteEstimateDTO";
import IQBOSendEstimateDTO from "../../../models/DTO/IQBOSendEstimateDTO";
import IQBOVoidInvoiceDTO from "../../../models/DTO/IQBOVoidInvoiceDTO";
import IResendEmailDTO from "../../../models/DTO/IResendEmailDTO";
import IUpdateOrderEntryDetailDTO from "../../../models/DTO/IUpdateOrderEntryDetailDTO";
import IUpdateOrderEntryFineDetailsDTO from "../../../models/DTO/IUpdateOrderEntryFineDetailsDTO";
import IUpdateOrderEntryItemDTO from "../../../models/DTO/IUpdateOrderEntryItemDTO";
import IGetDiscountsTypeaheadDTO from "../../../models/DTO/IGetDiscountsTypeaheadDTO";
import IOnGetDiscountsTypeaheadDTO from "../../../models/DTO/IOnGetDiscountsTypeaheadDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IAttachment from "../../../models/IAttachment";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ICatalog_Item from "../../../models/ICatalog_Item";
import IDiscount from "../../../models/IDiscount";
import IDraftOrderItem from "../../../models/IDraftOrderItem";
import IImageSizeEnum from "../../../models/IImageSizeEnum";
import IKitDetails from "../../../models/IKitDetails";
import INewOrder_Details from "../../../models/INewOrder_Details";
import INewOrder_Item from "../../../models/INewOrder_Item";
import INotification from "../../../models/INotification";
import IOfflineCreateOrderItem from "../../../models/IOfflineCreateOrderItem";
import IOrder from "../../../models/IOrder";
import IOrder_Item from "../../../models/IOrder_Item";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import IOrder_Progress_State from "../../../models/IOrder_Progress_State";
import IOrderUI from "../../../models/IOrderUI";
import IOwTableCols from "../../../models/IOwTableCols";
import IPurchaseOrderOrderItemDetail from "../../../models/IPurchaseOrderOrderItemDetail";
import IReadOnlyOrderStateDetail from "../../../models/IReadOnlyOrderStateDetail";
import IReconciledOfflineOrderEntryItem from "../../../models/IReconciledOfflineOrderEntryItem";
import ISupplierModel from "../../../models/ISupplierModel";
import ITotalsDetails from "../../../models/ITotalsDetails";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OrderRowColPropertyEnum from "../../../models/OrderRowColPropertyEnum";
import PriceUpchargeTypeEnum from "../../../models/PriceUpchargeTypeEnum";
import OrderSourceEnum from "../../../models/OrderSourceEnum";
import OrderStatesEnum from "../../../models/OrderStatesEnum";
import ResendEmailTypeEnum from "../../../models/ResendEmailTypeEnum";
import SortOrderEnum from "../../../models/SortOrderEnum";
import TableTypeEnum from "../../../models/TableTypeEnum";
import UserTypesEnum from "../../../models/UserTypesEnum";
import CatalogItemService from "../../../services/CatalogItemService";
import IdbService from "../../../services/IdbService";
import InventoryService from "../../../services/InventoryService";
import OrderEntryService from "../../../services/OrderEntryService";
import UIService from "../../../services/UIService";

import UserService from "../../../services/UserService";

import ViewAccessService from "../../../services/ViewAccessService";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OrderPayment from "../../shared/OrderPayment/OrderPayment";
import OrderProgressTracker from "../../shared/OrderProgressTracker/OrderProgressTracker";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwPrintButton from "../../shared/OwPrintButton/OwPrintButton";
import OwS3DownloadLink from "../../shared/OwS3DownloadLink/OwS3DownloadLink";
import OwS3ImageViewer from "../../shared/OwS3ImageViewer/OwS3ImageViewer";
import OwTable from "../../shared/OwTable/OwTable";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import OwToggle from "../../shared/OwToggle/OwToggle";
import Typeahead from "../../shared/Typeahead/Typeahead";
import { PackQtyReverseViewer } from "../../shared/PackQtyReverseViewer/PackQtyReverseViewer";
import PdfSidebarViewer from "../../shared/PdfSidebarViewer/PdfSidebarViewer";
import CommonItemsModal from "../CommonItemsModal/CommonItemsModal";
import ConfirmShipToModal from "../ConfirmShipToModal/ConfirmShipToModal";
import { ConvertQuoteToOrderModal } from "../ConvertQuoteToOrderModal/ConvertQuoteToOrderModal";
import EcommerceView from "../EcommerceView/EcommerceView";
import EmailQuoteModal from "../EmailQuoteModal/EmailQuoteModal";
import OrderActionColumn from "../OrderActionColumn/OrderActionColumn";
import { OrderCreateQBOInvoice } from "../OrderCreateQBOInvoice/OrderCreateQBOInvoice";
import OrderEntryDetailsPanel from "../OrderEntryDetailsPanel/OrderEntryDetailsPanel";
import { OrderEntryFloatingSubmit } from "../OrderEntryFloatingSubmit/OrderEntryFloatingSubmit";
import OrderInputPanel from "../OrderInputPanel/OrderInputPanel";
import OrderStepButtons from "../OrderStepButtons/OrderStepButtons";
import { OrderTimelineSidebar } from "../OrderTimelineSidebar/OrderTimelineSidebar";
import { OrderTitle } from "../OrderTitle/OrderTitle";
import { OrderTotalsPanel } from "../OrderTotalsPanel/OrderTotalsPanel";
import { OrderXeroInvoice } from "../OrderXeroInvoice/OrderXeroInvoice";
import OwToggleOrderEntryTableView from "../OwToggleOrderEntryTableView/OwToggleOrderEntryTableView";
import { QBOEstimatePdfSidebarViewer } from "../QBOEstimatePdfSidebarViewer/QBOEstimatePdfSidebarViewer";
import { QuoteCreateQBOEstimate } from "../QuoteCreateQBOEstimate/QuoteCreateQBOEstimate";
import "./OrderEntry.scss";
import IWayfairAcknowledgePoDTO from "../../../models/DTO/IWayfairAcknowledgePoDTO";
import IWayfairOnAcknowledgePoDTO from "../../../models/DTO/IWayfairOnAcknowledgePoDTO";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import ISubmitOrderDTO from "../../../models/DTO/ISubmitOrderDTO";
import IOnSubmitOrderDTO from "../../../models/DTO/IOnSubmitOrderDTO";
import CatalogViewerSidebar from "../CatalogViewerSidebar/CatalogViewerSidebar";
import IGetVendorSourcesForOrderItemsDTO from "../../../models/DTO/IGetVendorSourcesForOrderItemsDTO";
import IOnGetVendorSourcesForOrderItemsDTO from "../../../models/DTO/IOnGetVendorSourcesForOrderItemsDTO";
import IVendor_Source from "../../../models/IVendor_Source";
import { StartPurchaseOrderModal } from "../StartPurchaseOrderModal/StartPurchaseOrderModal";
import IWarehouse from "../../../models/IWarehouse";
import { DraggableOrderItem } from "../DraggableOrderItem/DraggableOrderItem";
import { DraggableSortableTable } from "../DraggableSortableTable/DraggableSortableTable";
import IOnGetWarehousesDTO from "../../../models/DTO/IOnGetWarehousesDTO";
import { Socket } from "socket.io-client";
import { OrderOnHoldModal } from "../OrderOnHoldModal/OrderOnHoldModal";
import IOrderEntryHoldOrderDTO from "../../../models/DTO/IOrderEntryHoldOrderDTO";
import SupplierGuidEnum from "../../../models/SupplierGuidEnum";
import { OrderCancelledModal } from "../OrderCancelledModal/OrderCancelledModal";
import IOrderEntryCancelOrderDTO from "../../../models/DTO/IOrderEntryCancelOrderDTO";
import IOrderEntryProcessSerialDTO from "../../../models/DTO/IOrderEntryProcessSerialDTO";
import IOrderEntryOnProcessSerialDTO from "../../../models/DTO/IOrderEntryOnProcessSerialDTO";
import ISerial from "../../../models/ISerial";
import { OrderEntryEditSerial } from "../OrderEntryEditSerial/OrderEntryEditSerial";
import IUnit_Of_Measurement_Set from "../../../models/IUnit_Of_Measurement_Set";
import { QtyDetail } from "../../shared/QtyDetail/QtyDetail";
import { UomSetSelectOption } from "../../shared/UomSetSelectOption/UomSetSelectOption";
import { LineItemQtyEdit } from "../LineItemQtyEdit/LineItemQtyEdit";
import { LineItemQtyInventoryDetail } from "../LineItemQtyInventoryDetail/LineItemQtyInventoryDetail";
import { LineItemQtyFulfillmentDetail } from "../LineItemQtyFulfillmentDetail/LineItemQtyFulfillmentDetail";
import { LineItemQtyDeliveryEtaDetail } from "../LineItemQtyDeliveryEtaDetail/LineItemQtyDeliveryEtaDetail";
import { OrderItemPriceGroupSelect } from "../OrderItemPriceGroupSelect/OrderItemPriceGroupSelect";
import { DescriptionExpander } from "../../shared/DescriptionExpander/DescriptionExpander";
import { datadogLogs } from "@datadog/browser-logs";
import SocketService from "../../../services/SocketService";
import { FilesDownloadSection } from "../../shared/FilesDownloadSection/FilesDownloadSection";
import OwPill from "../../shared/OwPill/OwPill";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { OrderMetadataSidebar } from "../../orders/OrderMetadataSidebar/OrderMetadataSidebar";
import SupplierService from "../../../services/SupplierService";
import IQBOOnGetPDFInvoiceDTO from "../../../models/DTO/IQBOOnGetPDFInvoiceDTO";
import PaymentServiceTypeEnum from "../../../models/PaymentServiceTypeEnum";
import { OrderPaymentStripe } from "../../shared/OrderPaymentStripe/OrderPaymentStripe";
import { StripePaymentCapture } from "../../shared/StripePaymentCapture/StripePaymentCapture";
import IQBOGetEstimateDataFromQboDTO from "../../../models/DTO/IQBOGetEstimateDataFromQboDTO";
import IQBOOnGetEstimateDataFromQboDataDTO from "../../../models/DTO/IQBOOnGetEstimateDataFromQboDataDTO";
import { LogService } from "../../../services/LogService";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { ProcessOrderEntryItemFn } from "../../../models/OrderEntryTypes";
import { KitItemsDisplay } from "../../shared/KitItemsDisplay/KitItemsDisplay";
import { OrderActionColVendorSource } from "../OrderActionColVendorSource/OrderActionColVendorSource";
import { OrderActionColRma } from "../OrderActionColRma/OrderActionColRma";
import { OrderEntryPurchaseOrderButtons } from "../OrderEntryPurchaseOrderButtons/OrderEntryPurchaseOrderButtons";
import { OrderEntryRmaButtons } from "../OrderEntryRmaButtons/OrderEntryRmaButtons";
import OrderEntryViewStateOptionsEnum from "../../../models/OrderEntryViewStateOptionsEnum";
import AccessTypesEnum from "../../../models/AccessTypesEnum";
import ky from "ky";
import { QuickBooksPaymentModal } from "../../shared/QuickBooksPaymentModal/QuickBooksPaymentModal";
import { ShipmentGroupSidebarFn } from "../../shipments/ShipmentGroupSidebarFn/ShipmentGroupSidebarFn";
import IShipment_GroupUI from "../../../models/IShipment_GroupUI";
import { OrderStepButtonsFn } from "../OrderStepButtonsFn/OrderStepButtonsFn";
import { IOrderStepButtonsFnCallbacks } from "../OrderStepButtonsFn/IOrderStepButtonsFnCallbacks";
import IRemakeOrderDTO from "../../../models/DTO/IRemakeOrderDTO";
import IOnRemakeOrderDTO from "../../../models/DTO/IOnRemakeOrderDTO";
import { OrderOtherSectionsButtons } from "../OrderOtherSectionsButtons/OrderOtherSectionsButtons";
import { IOrderOtherSectionsButtonsCallbacks } from "../OrderOtherSectionsButtons/IOrderOtherSectionsButtonsCallbacks";
import IGenerateQuotePdfDTO from "../../../models/DTO/IGenerateQuotePdfDTO";
import IOnGenerateQuotePdfDTO from "../../../models/DTO/IOnGenerateQuotePdfDTO";
import IGenerateOrderPdfDTO from "../../../models/DTO/IGenerateOrderPdfDTO";
import IOnGenerateOrderPdfDTO from "../../../models/DTO/IOnGenerateOrderPdfDTO";
import { OrderPaymentAuthorizeNet } from "@components/shared/OrderPaymentAuthorizeNet/OrderPaymentAuthorizeNet";
import SquarePaymentForm from "@components/shared/SquarePaymentForm/SquarePaymentForm";
import { OrderPaymentSquare } from "@components/shared/OrderPaymentSquare/OrderPaymentSquare";
import { OrdersService } from "@components/orders/Orders/OrdersService";
import INewOrder_ItemUI from "@models/INewOrder_ItemUI";
import { IAddBulkItems } from "@models/IAddBulkItems";
import { IUpdateBulkItems } from "@models/IUpdateBulkItems";
import IOrderRecalculateTotalsDTO from "@models/DTO/IOrderRecalculateTotalsDTO";
import IGenerateOrderPackingListPdfDTO from "@models/DTO/IGenerateOrderPackingListPdfDTO";
import IOnGenerateOrderPackingListPdfDTO from "@models/DTO/IOnGenerateOrderPackingListPdfDTO";
import { DimensionWidget } from "@components/shared/DimensionWidget/DimensionWidget";
import { formatDimensionDisplay } from "@utils/DimensionConversion";
import { CategoryTallyWidget } from "../CategoryTallyWidget/CategoryTallyWidget";
import { ControlBar } from "@components/shared/ControlBar/ControlBar";
import { ClickToCopy } from "@components/shared/ClickToCopy/ClickToCopy";
import { OrderEntryLineItemAdminActions } from "../OrderEntryLineItemAdminActions/OrderEntryLineItemAdminActions";
import { OrderEntryBackorderSelectionModal } from "../OrderEntryBackorderSelectionModal/OrderEntryBackorderSelectionModal";
import { BackorderLimitExceededModal } from "../BackorderLimitExceededModal/BackorderLimitExceededModal";
import BackorderModalVisibilityEnum from "@models/BackorderModalVisibilityEnum";
import BackorderBehaviorEnum from "@models/BackorderBehaviorEnum";
import IRelatedOrder from "@models/IRelatedOrder";
import { OwIconTooltip } from "@components/shared/OwIconTooltip/OwIconTooltip";
import OrderService from "@services/OrderService";
import { FulfillBackordersModal } from "@components/shared/FulfillBackordersModal/FulfillBackordersModal";
import { FulfillBackorderModal } from "../FulfillBackorderModal/FulfillBackorderModal";
import { IFulfillBackordersByOrderDTO } from "@models/DTO/IFulfillBackordersByOrderDTO";
import InventoryAllocationStrategyEnum from "@models/DTO/InventoryAllocationStrategyEnum";
import { IUiContextModel } from "@contexts/UiContext";
import { get } from "lodash-es";
import { OrderEntrySerialDetail } from "../OrderEntrySerialDetail/OrderEntrySerialDetail";

type Props = {
    isOnline: boolean;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    toggleSidebar: (shouldBeVisible?: boolean, sidebarProps?: SidebarProps) => void;
    toggleRightSide: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setRightSideComponent: (component: any) => void;
    setSubHeaderComponent: (component: any) => void;
    setRightSideHeaderComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    match: any;
    history: any;
    location: any;
    userModel: IUserUI;
    vendorModel: IVendorModel;
    supplierModel: ISupplierModel;
    /**
     * @deprecated
     */
    toggleMenu: () => void;
    showHiddenFeatures: boolean;
    uiContext: IUiContextModel;
    hasEditMode: boolean;
};

type State = {
    response: boolean;
    editMode: boolean;
    showCustom: boolean;
    currentItemNo: number;
    tableClass: string;
    supplier: {
        has_catalog: boolean;
    };
    orderGuid?: string;
    showQuickBooksNotConnected?: boolean;
    confirmOrderBtnActive?: boolean;
    completeOrderBtnActive?: boolean;
    createShipmentBtnActive?: boolean;
    confirmLocalDeliveryBtnActive?: boolean;
    readyForPickupBtnActive?: boolean;
    preliminaryBtnActive?: boolean;
    resendSubmitEmailActive?: boolean;
    resendOrderAutomationActive?: boolean;
    priceGroups?: any[];
    order?: IOrderUI;
    relatedOrders?: IRelatedOrder[];
    navItems?: IBreadcrumbs[];
    orderItemType?: any;
    orderVendorModel?: any;
    shippingEditMode?: boolean;
    isSupplierUser?: boolean;
    otherEditMode?: boolean;
    convertQuoteToOrderActive: boolean;
    modalIsOpen: boolean;
    showImages: boolean;
    tableType: TableTypeEnum;
    sortCol: string;
    sortDir: SortOrderEnum;
    showCommonItemsModal?: boolean;
    hasShownCommonItemsModal: boolean;
    hasPendingDetailChanges: boolean;
    showModalSubmit: boolean;
    isOnline: boolean;
    isOfflineOrder: boolean;
    reconcileData: any[];
    hasRowsInEditMode: boolean;
    customerApprovalPaymentBtnActive: boolean;
    selectedRowId?: any;
    selectedRowRef?: any;
    hasEditMode: boolean;
    columns: IOwTableCols[];
    detailTableCols: IOwTableCols[];
    isInitialData: boolean;
    isDataFetching: boolean;
    detailColSpan?: number;
    ship_to_confirmed?: boolean;
    modalComponent?: any;
    tempUpdateOrderEntryDetail?: Partial<IUpdateOrderEntryDetailDTO> | null;
    orderItemIssues: { catalogItem: ICatalog_Item; qtyOnHand: number }[];
    backorderLimitItems: IBackorderLimitExceededItem[];
    showRowDetailInfo: boolean;
    hasCollectedPaymentAuth: boolean;
    modalStyle: ReactModal.Styles;
    stepBtnActive: boolean;
    // purchaseOrderView: boolean;
    purchaseOrderRows: { minQty: number; qty: number; orderItemGuid: string; isChecked: boolean; vendorSourceId?: number }[];
    // backOrderView: boolean;
    // acknowledgeView: boolean;
    acknowledgeRows: { qty: number; orderItemGuid: string; isChecked: boolean }[];
    backOrderRows: { qty: number; orderItemGuid: string; isChecked: boolean }[];
    rmaRows: {
        qty: number;
        orderItemGuid: string;
        isChecked: boolean;
        order_line_item_id: number;
        catalog_item_id: number;
        maxQty: number;
    }[];
    isCreatingRma: boolean;
    // isEcommerceView: boolean;
    hasPendingFineDetailChanges: boolean;
    hasPendingCustomScheduleDetailChanges: boolean;
    tempOrderFineDetails?: Partial<INewOrder_Details> | null;
    tempCustomScheduleDetails?: any;
    isFineDetailsValid: boolean;
    closeModalOnOverlayClick: boolean;
    closeModalOnEsc: boolean;
    enableDeviceScan: boolean;
    currentScanCode: string;
    activeQboInvoice: boolean;
    showQBOInvoice: boolean;
    offlineReconciledItems: IReconciledOfflineOrderEntryItem[];
    tempSubmitOrderPayload?: ISubmitOrderDTO;
    vendorSourcesForCatalogItems?: { [key: string]: IVendor_Source[] };
    showStartPurchaseOrderModal: boolean;
    warehouses: IWarehouse[];
    doCurrencyConversion: boolean;
    currentView: OrderEntryViewStateOptionsEnum;
    discountTypeaheadItems: IDiscount[];
    editingDiscountRowGuid: string | null;
    orderStepBtnsActive: {
        remakeBtnActive: boolean;
        reorderBtnActive: boolean;
    };
    isDragMode: boolean;
    activeOrderItemId: string | null;
};

export class OrderEntry extends Component<Props, State> {
    overlayRow: any;
    deleteIndex?: number;

    idbService: IdbService = new IdbService();

    orderEntryRef: any;

    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        const currentView: OrderEntryViewStateOptionsEnum = OrderEntryViewStateOptionsEnum.ORDER_ENTRY;

        this.sockets = [
            { endpoint: EndpointsEnum.OrderOnGetOrder, fn: this.onGetOrder },
            { endpoint: EndpointsEnum.OrderEntryOnCreateOrderEntryItem, fn: this.onCreateOrderEntryItem },
            { endpoint: EndpointsEnum.OrderEntryOnUpdateOrderEntryItem, fn: this.onUpdateOrderEntryItem },
            { endpoint: EndpointsEnum.OrderEntryOnDeleteOrderEntryItem, fn: this.onDeleteOrderEntryItem },
            { endpoint: EndpointsEnum.OrderEntryOnUpdateOrderEntryDetail, fn: this.onUpdateOrderEntryDetail },
            { endpoint: EndpointsEnum.OrderEntryOnGetOrderEntryDetail, fn: this.onGetOrderDetails }, // Delete?
            { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: this.onGetPriceGroups },
            { endpoint: EndpointsEnum.OrderOnResendEmail, fn: this.onResendEmail },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.OrderOnConvertQuoteToOrder, fn: this.onConvertQuoteToOrder },
            { endpoint: EndpointsEnum.FileUploadOnCreateFileUpload, fn: this.onCreateFileUpload },
            { endpoint: EndpointsEnum.FileUploadOnDeleteFileUpload, fn: this.onDeleteFileUpload },
            { endpoint: EndpointsEnum.OrderEntryOnRenumberOrderItems, fn: this.onRenumberOrderItems },
            { endpoint: EndpointsEnum.OrderEntryOnUpdateSortOrder, fn: this.onUpdateOrderItemsSortOrder },
            { endpoint: EndpointsEnum.OrderEntryOnProcessOrderEntryItems, fn: this.onProcessOrderEntryItems },
            { endpoint: EndpointsEnum.OrderEntryOnCreateOrderEntryItems, fn: this.onCreateOrderEntryItems },
            { endpoint: EndpointsEnum.OrderEntryOnResendOrderAutomation, fn: this.onResendOrderAutomation },
            { endpoint: EndpointsEnum.OrderEntryInsufficientInventory, fn: this.insufficientInventory },
            { endpoint: EndpointsEnum.OrderEntryBackorderLimitExceeded, fn: this.backorderLimitExceeded },
            { endpoint: EndpointsEnum.OrderEntryOnPerformInventoryCheck, fn: this.onPerformInventoryCheck },
            { endpoint: EndpointsEnum.OrderOnCreateBackorder, fn: this.onCreateBackorder },
            { endpoint: EndpointsEnum.OrderEntryOnUpdateOrderFineDetails, fn: this.onUpdateFineDetails },
            { endpoint: EndpointsEnum.TaxJarOnCalculateSalesTax, fn: this.onCalculateSalesTax },
            { endpoint: EndpointsEnum.PurchaseOrderOnGetPurchaseOrderDetailForOrder, fn: this.onGetPurchaseOrderOrderDetail },
            { endpoint: EndpointsEnum.PurchaseOrderOnCreatePurchaseOrdersFromOrder, fn: this.onCreatePurchaseOrdersFromOrder },
            { endpoint: EndpointsEnum.QBOOnGetPDFInvoice, fn: this.onQBOGetInvoice },
            { endpoint: EndpointsEnum.QBOOnDeleteInvoice, fn: this.onQBODeleteInvoice },
            { endpoint: EndpointsEnum.QBOOnVoidInvoice, fn: this.onQBOVoidInvoice },
            { endpoint: EndpointsEnum.QBOOnCreateInvoice, fn: this.onQBOCreateInvoice },
            { endpoint: EndpointsEnum.OrderEntryOnReconcileOfflineOrderEntryItems, fn: this.onReconcileOfflineOrderEntryItems },
            { endpoint: EndpointsEnum.OrderOnCreatePickList, fn: this.onCreatePickList },
            { endpoint: EndpointsEnum.XeroOnCreateInvoice, fn: this.onXeroCreateInvoice },
            { endpoint: EndpointsEnum.XeroOnVoidInvoice, fn: this.onXeroVoidInvoice },
            { endpoint: EndpointsEnum.XeroOnDeleteInvoice, fn: this.onXeroDeleteInvoice },
            { endpoint: EndpointsEnum.XeroOnEmailInvoice, fn: this.onXeroEmailInvoice },
            { endpoint: EndpointsEnum.QBOOnCreateEstimate, fn: this.onCreateQBOEstimate },
            { endpoint: EndpointsEnum.QBOOnDeleteEstimate, fn: this.onDeleteQBOEstimate },
            { endpoint: EndpointsEnum.QBOOnSendEstimate, fn: this.onEmailQBOEstimate },
            { endpoint: EndpointsEnum.WayfairOnAcknowledgePurchaseOrder, fn: this.onWayfairAcknowledgePO },
            { endpoint: EndpointsEnum.OrderEntryOnSubmitOrder, fn: this.onSubmitOrder },
            { endpoint: EndpointsEnum.PurchaseOrderOnGetVendorSourcesForOrderItems, fn: this.onGetVendorSourcesForOrderItems },
            { endpoint: EndpointsEnum.WarehouseOnGetWarehouses, fn: this.onGetWarehouses },
            { endpoint: EndpointsEnum.OrderEntryOnHoldOrder, fn: this.onHoldOrder },
            { endpoint: EndpointsEnum.OrderEntryOnProcessSerial, fn: this.onProcessSerial },
            { endpoint: EndpointsEnum.OrderOnCancelOrder, fn: this.onCancelOrder }, // should this be removed?
            { endpoint: EndpointsEnum.ChRobinsonOnSaveRatingRequest, fn: this.onSaveRatingRequest },
            { endpoint: EndpointsEnum.QBOOnGetEstimateDataFromQbo, fn: this.onGetEstimateDataFromQbo },
            { endpoint: EndpointsEnum.OrderEntryOnCancelOrder, fn: this.onCancelOrder },
            { endpoint: EndpointsEnum.OrderOnGenerateQuotePDF, fn: this.onDownloadQuotePdf },
            { endpoint: EndpointsEnum.OrderOnGenerateOrderPDF, fn: this.onDownloadOrderPdf },
            { endpoint: EndpointsEnum.OrderOnRecalculateTotals, fn: this.onRecalculateTotals },
            { endpoint: EndpointsEnum.OrderOnGenerateOrderPackingListPDF, fn: this.onDownloadOrderPackingListPdf },
            { endpoint: EndpointsEnum.DiscountOnGetDiscountsTypeahead, fn: this.onGetDiscountsTypeahead },
            { endpoint: EndpointsEnum.OrderOnRemake, fn: this.onRemakeOrder },
        ];

        this.state = {
            orderItemIssues: [],
            backorderLimitItems: [],
            response: false,
            hasEditMode: this.props.hasEditMode,
            editMode: false,
            showCustom: false,
            currentItemNo: 0,
            tableClass: "",
            supplier: {
                has_catalog: false,
            },
            orderGuid: this.props.match.params.order_guid,
            convertQuoteToOrderActive: false,
            showImages: true,
            tableType: TableTypeEnum.PHOTOS,
            sortCol: "item_no",
            sortDir: SortOrderEnum.ASC,
            modalIsOpen: false,
            showCommonItemsModal: false,
            hasPendingDetailChanges: false,
            isOnline: this.props.isOnline,
            isOfflineOrder: this.props.match.params.order_guid.indexOf("offline") >= 0,
            reconcileData: [],
            hasRowsInEditMode: false,
            customerApprovalPaymentBtnActive: false,
            selectedRowRef: null,
            // @ts-expect-error
            columns: [],
            detailTableCols: [],
            isInitialData: true,
            isDataFetching: false,
            showRowDetailInfo: !this.props.supplierModel.hide_order_detail_info,
            hasCollectedPaymentAuth: false,
            modalStyle: {},
            stepBtnActive: false,
            // backOrderView: false,
            // acknowledgeView: false,
            hasPendingFineDetailChanges: false,
            hasPendingCustomScheduleDetailChanges: false,
            backOrderRows: [],
            acknowledgeRows: [],
            // isEcommerceView,
            isFineDetailsValid: true,
            // offlineMode$,
            purchaseOrderRows: [],
            rmaRows: [],
            isCreatingRma: false,
            // purchaseOrderView: false,
            closeModalOnOverlayClick: true,
            enableDeviceScan: false,
            currentScanCode: "",
            activeQboInvoice: false,
            showQBOInvoice: false,
            hasShownCommonItemsModal: false,
            showModalSubmit: false,
            offlineReconciledItems: [],
            showStartPurchaseOrderModal: false,
            warehouses: [],
            doCurrencyConversion: !!this.props.supplierModel.has_currencies,
            currentView,
            closeModalOnEsc: true,
            discountTypeaheadItems: [],
            editingDiscountRowGuid: null,
            orderStepBtnsActive: {
                remakeBtnActive: false,
                reorderBtnActive: false,
            },
            isDragMode: false,
            activeOrderItemId: null,
        };

        window.addEventListener("online", this.setOnlineStatus);
        window.addEventListener("offline", this.setOnlineStatus);

        // UIService.ecommerceView$().next(true);

        // console.log("Is Offline Order: ", this.state.isOfflineOrder);
    }

    async componentDidMount() {
        this.setupSockets();

        this.performInitialSetup();
    }

    componentWillUnmount() {
        window.removeEventListener("online", this.setOnlineStatus);
        window.removeEventListener("offline", this.setOnlineStatus);

        this.props.setSubHeaderComponent(null);

        this.removeSockets();
    }

    performInitialSetup = () => {
        let showCustom = false;
        let showQuickBooksNotConnected = false;

        if (!_.isNil(this.props.supplierModel)) {
            if (this.props.supplierModel.allow_custom_items) {
                showCustom = true;
            }

            if (this.props.supplierModel.Supplier_Integration.has_qbo) {
                if (this.props.userModel?.isSupplierUser) {
                    showQuickBooksNotConnected = true;
                }
            }
        }

        let showCommonItemsModal = false;

        if (this.props.supplierModel.show_common_items_modal && !this.props.supplierModel.show_common_items_on_submit) {
            showCommonItemsModal = true;
        }

        this.setState({
            showCustom,
            showQuickBooksNotConnected,
            showCommonItemsModal,
        });

        this.getOrder("performInitialSetup", "order_entry");
    };

    setupSockets = () => {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }
    };

    removeSockets = () => {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    };

    downloadQuotePdf = () => {
        if (this.state.order) {
            const payload: IGenerateQuotePdfDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                orderGuid: this.state.order.guid,
            };

            this.props.socket.emit(EndpointsEnum.OrderGenerateQuotePDF, payload);
        }
    };

    onDownloadQuotePdf = (data: IOnGenerateQuotePdfDTO) => {
        UIService.downloadDataFile(data.pdf, data.filename, "application/pdf");
    };

    downloadOrderPdf = () => {
        if (this.state.order) {
            const payload: IGenerateOrderPdfDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                orderGuid: this.state.order.guid,
            };

            this.props.socket.emit(EndpointsEnum.OrderGenerateOrderPDF, payload);
        }
    };

    downloadOrderPackingListPdf = () => {
        if (this.state.order) {
            const payload: IGenerateOrderPackingListPdfDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                orderGuid: this.state.order.guid,
            };

            this.props.socket.emit(EndpointsEnum.OrderGenerateOrderPackingListPDF, payload);
        }
    };

    onDownloadOrderPackingListPdf = (data: IOnGenerateOrderPackingListPdfDTO) => {
        UIService.downloadDataFile(data.pdf, data.filename, "application/pdf");
    };

    onRecalculateTotals = (data: IOrderRecalculateTotalsDTO) => {
        this.getOrder("onRecalculateTotals", "order_entry");
    };

    onDownloadOrderPdf = (data: IOnGenerateOrderPdfDTO) => {
        UIService.downloadDataFile(data.pdf, data.filename, "application/pdf");
    };

    onXeroEmailInvoice = () => {
        this.getOrder("onXeroEmailInvoice", "order_entry");
    };

    onXeroVoidInvoice = () => {
        this.getOrder("onXeroVoidInvoice", "order_entry");
    };

    onXeroDeleteInvoice = () => {
        this.getOrder("onXeroDeleteInvoice", "order_entry");
    };

    onXeroCreateInvoice = () => {
        this.getOrder("onXeroCreateInvoice", "order_entry");
    };

    onCalculateSalesTax = (data: IOnTaxJarCalculateSalesTaxDTO) => {
        this.getOrder("onCalculateSalesTax", "order_entry");
    };

    onUpdateFineDetails = (data: IOnUpdateOrderEntryFineDetailsDTO) => {
        const notification: INotification = {
            message: "successfully_saved_details",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            tempOrderFineDetails: null,
            hasPendingFineDetailChanges: false,
        });
    };

    onGetWarehouses = (data: IOnGetWarehousesDTO) => {
        this.setState({
            warehouses: data.warehouses,
        });
    };

    onGetDiscountsTypeahead = (data: IOnGetDiscountsTypeaheadDTO) => {
        this.setState({
            discountTypeaheadItems: data.discounts,
        });
    };

    searchDiscounts = (searchString: string) => {
        if (this.state.order && this.state.order.Catalog) {
            const payload: IGetDiscountsTypeaheadDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid: this.state.order.Catalog.guid,
                queryString: searchString,
                limit: 50,
                checkAllDiscounts: true,
            };
            this.props.socket.emit(EndpointsEnum.DiscountGetDiscountsTypeahead, payload);
        }
    };

    selectDiscount = (discount: IDiscount, row: IOrder_ItemUI) => {
        const updatedItem = {
            ...row,
            discount_id: discount.id,
            discount: discount.discount,
            discount_type_id: discount.discount_type_id,
            isDirty: true,
        };
        this.updateOrderEntryItem(updatedItem, { shouldAutoSave: true });
        this.setState({ editingDiscountRowGuid: null });
    };

    setOnlineStatus = () => {
        if (!navigator.onLine) {
            // Do nothing?
        } else {
            this.setupSockets();
        }

        this.setState(
            {
                isOnline: navigator.onLine,
            },
            () => {
                this.getOrder("setOnlineStatus", "order_entry");
            }
        );
    };

    notify = (data: IErrorDTO) => {
        this.setState(
            {
                confirmOrderBtnActive: false,
                completeOrderBtnActive: false,
                createShipmentBtnActive: false,
                confirmLocalDeliveryBtnActive: false,
                readyForPickupBtnActive: false,
                preliminaryBtnActive: false,
                resendSubmitEmailActive: false,
                resendOrderAutomationActive: false,
                stepBtnActive: false,
                activeQboInvoice: false,
            },
            () => {
                this.props.setActivityIndicator(false);
            }
        );
    };

    insufficientInventory = (data: IInsufficientInventoryDTO) => {
        const notification: INotification = {
            message: "line_item_with_insufficient_inventory",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.error,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            orderItemIssues: data.orderItemIssues,
            backorderLimitItems: [],
        });
    };

    backorderLimitExceeded = (data: IBackorderLimitExceededResponseDTO) => {
        const orderItemIssues: { catalogItem: ICatalog_Item; qtyOnHand: number }[] = [];

        if (data.items?.length && this.state.order) {
            for (const item of data.items) {
                let matchedOrderItem = this.state.order.Order_Items.find((oi) => oi.Catalog_Item?.sku === item.sku || oi.sku === item.sku);

                if (!matchedOrderItem) {
                    for (const oi of this.state.order.Order_Items) {
                        if (oi.Kit_Items?.some((ki) => ki.Catalog_Item?.sku === item.sku || ki.sku === item.sku)) {
                            matchedOrderItem = oi;
                            break;
                        }
                    }
                }

                if (matchedOrderItem) {
                    orderItemIssues.push({
                        // @ts-expect-error - partial ICatalog_Item, only id needed for row matching
                        catalogItem: { id: matchedOrderItem.catalog_item_id },
                        qtyOnHand: item.maxOrderQty,
                    });
                }
            }
        }

        const modalComponent = <BackorderLimitExceededModal items={data.items} message={data.message} closeFn={this.closeModal} />;

        this.setState({
            orderItemIssues,
            backorderLimitItems: data.items,
            modalComponent,
            modalIsOpen: true,
            modalStyle: {
                content: {
                    inset: "5vh auto auto 50%",
                    transform: "translateX(-50%)",
                    width: "50rem",
                    height: "auto",
                    minHeight: "auto",
                    maxHeight: "80vh",
                    overflow: "auto",
                },
            },
            confirmOrderBtnActive: false,
            preliminaryBtnActive: false,
            hasPendingDetailChanges: false,
            stepBtnActive: false,
        });
    };

    onCreateFileUpload = (data: IOnCreateFileUploadDTO): void => {
        this.getOrder("onCreateFileUpload", "order_entry");
    };

    onDeleteFileUpload = (data: IOnCreateFileUploadDTO): void => {
        this.getOrder("onDeleteFileUpload", "order_entry");
    };

    onRenumberOrderItems = (data: IOnRenumberOrderItemsDTO): void => {
        this.getOrder("onRenumberOrderItems", "order_entry");
    };

    onUpdateOrderItemsSortOrder = (data: IOnUpdateOrderItemsSortOrderDTO): void => {
        this.props.notifyFn(null, { message: data.message, level: NotificationLevelEnum.success, position: NotificationPositionEnum.bc });
        this.getOrder("onUpdateOrderItemsSortOrder", "order_entry");
    };

    toggleDragMode = () => {
        this.setState({ isDragMode: !this.state.isDragMode });
    };

    handleDragStart = (event: DragStartEvent) => {
        this.setState({ activeOrderItemId: event.active.id as string });
    };

    /**
     * Handles drag and drop reordering of order items
     *
     * IMPORTANT: Sort Order System
     *
     * The backend manages sort_order differently for different item types:
     *
     * Parent Items:
     * - sort_order is sequential: 1, 2, 3...
     * - Corresponds to item_no: "1", "2", "3"...
     *
     * Kit Items (in parent.Kit_Items array):
     * - sort_order is sequential within parent: 1, 2, 3...
     * - item_no is typically 0 or null (kit items are not numbered)
     * - NOT draggable - only shown for display
     *
     * Child Items (regular child items with is_child_item = true):
     * - sort_order continues AFTER kit items within the parent
     * - Example: If parent has 2 kit items (sort_order 1, 2), child items start at 3, 4, 5...
     * - item_no follows "parent.child" format: "1.1", "1.2", "2.1", etc.
     * - These ARE draggable within their parent's scope
     *
     * Example:
     * Parent 1 (sort_order: 1, item_no: "1")
     *   Kit Item A (sort_order: 1, item_no: 0) <- in Kit_Items array
     *   Kit Item B (sort_order: 2, item_no: 0) <- in Kit_Items array
     *   Child 1 (sort_order: 3, item_no: "1.1") <- in Order_Items array
     *   Child 2 (sort_order: 4, item_no: "1.2") <- in Order_Items array
     * Parent 2 (sort_order: 2, item_no: "2")
     */
    handleDragEnd = async (event: DragEndEvent) => {
        const { active, over } = event;

        if (!over || active.id === over.id) {
            this.setState({ activeOrderItemId: null });
            return;
        }

        const order = { ...this.state.order! };
        const oldIndex = order.Order_Items.findIndex((item) => item.guid === active.id);
        const newIndex = order.Order_Items.findIndex((item) => item.guid === over.id);

        if (oldIndex === -1 || newIndex === -1) {
            this.setState({ activeOrderItemId: null });
            return;
        }

        const draggedItem = order.Order_Items[oldIndex];
        const targetItem = order.Order_Items[newIndex];

        // Check if we're dragging a child item
        const isDraggingChild = !!draggedItem.parent_order_item_id;
        const isTargetChild = !!targetItem.parent_order_item_id;

        // Prevent dragging child to parent or vice versa
        if (isDraggingChild !== isTargetChild) {
            this.setState({ activeOrderItemId: null });
            return;
        }

        // If both are children, ensure they have the same parent
        if (isDraggingChild && draggedItem.parent_order_item_id !== targetItem.parent_order_item_id) {
            this.setState({ activeOrderItemId: null });
            return;
        }

        // Reorder locally
        order.Order_Items = arrayMove(order.Order_Items, oldIndex, newIndex);

        // Calculate new sort_order values
        let sortUpdates: Array<{ order_item_guid: string; sort_order: number }> = [];

        if (isDraggingChild) {
            // Reordering child items - update sort order for siblings
            const parentId = draggedItem.parent_order_item_id;
            const siblings = order.Order_Items.filter((item) => item.parent_order_item_id === parentId);

            // Find the parent to check for kit items
            const parent = order.Order_Items.find((item) => item.id === parentId);
            // Kit items occupy sort_order slots, so child items start after them
            // Example: 2 kit items means child items start at sort_order 3
            const kitItemCount = parent?.Kit_Items?.length ?? 0;

            sortUpdates = siblings.map((item, index) => ({
                order_item_guid: item.guid,
                // Child items' sort_order starts after kit items (kitItemCount + 1, kitItemCount + 2, ...)
                sort_order: kitItemCount + index + 1,
            }));
        } else {
            // Reordering parent items - update sort order for all parents
            const parents = order.Order_Items.filter((item) => !item.parent_order_item_id);

            sortUpdates = parents.map((item, index) => ({
                order_item_guid: item.guid,
                sort_order: index + 1,
            }));
        }

        this.setState({ order, activeOrderItemId: null });

        // Call API to persist the new sort order
        const payload: IUpdateOrderItemsSortOrderDTO = {
            orderGuid: order.guid,
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: order.Vendor!.guid,
            sortUpdates,
        };

        this.props.socket.emit(EndpointsEnum.OrderEntryUpdateSortOrder, payload);
    };

    onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        this.setState(
            {
                priceGroups: data.priceGroups,
            },
            () => {
                if (!_.isNil(this.state.order)) {
                    const { orderUpdated, pricing } = this.processTotals(this.state.order);

                    this.setState({
                        order: orderUpdated,
                    });
                }

                this.props.setActivityIndicator(false);
            }
        );
    };

    getOrderRestApi = async (callingFn: string, view: string) => {
        if (this.props.match.params.order_guid === this.state.orderGuid) {
            if (this.state.isOnline && !this.state.isOfflineOrder && this.state.orderGuid) {
                this.props.setActivityIndicator(true);

                this.setState(
                    {
                        isDataFetching: true,
                    },
                    async () => {
                        let orderUi: IOrderUI | null = null;

                        try {
                            const { order, relatedOrders } = await OrderService.getOrderRestAPI(
                                this.state.orderGuid!,
                                this.props.userModel,
                                this.props.supplierModel,
                                this.props.vendorModel
                            );

                            orderUi = {
                                ...order,
                                isSaved: true,
                                editMode: false,
                                rowEditMode: false,
                                Order_Items: order.Order_Items.map((item: IOrder_Item) => {
                                    return {
                                        ...item,
                                        rowEditMode: false,
                                        showDetailView: false,
                                        isDirty: false,
                                    } as IOrder_ItemUI;
                                }),
                            };

                            this.setupOrderEntryFromOrder(orderUi, relatedOrders);
                        } catch (error) {
                            console.error("Error getting order from rest api: ", error);
                        }

                        this.props.setActivityIndicator(false);
                    }
                );
            }
        }
    };

    getOrder = async (callingFn: string, view: string) => {
        // Adding this as a safety to be sure that the order that's being 'gotten' matches the url param guid
        if (this.props.match.params.order_guid === this.state.orderGuid) {
            if (this.state.isOnline && !this.state.isOfflineOrder && this.state.orderGuid) {
                this.getOrderRestApi(callingFn, view);
                // TO DELETE - Once we've confirmed things aren't broken with the rest api way.
                //     userGuid: this.props.userModel.guid,
                //     userToken: this.props.userModel.token,
                //     vendorGuid: this.props.vendorModel.guid,
                //     orderGuid: this.state.orderGuid,
                //     supplierGuid: this.props.supplierModel!.guid,
                //     callMeta: {
                //         callingFn,
                //         view,
                //         fn: "getOrder",
                //     },
                // };

                // this.props.socket.emit(EndpointsEnum.OrderGetOrder, data);

                // this.props.setActivityIndicator(true);

                // this.setState({
                //     isDataFetching: true,
                // });
            } else {
                // load the order from the local db
                if (this.state.orderGuid) {
                    const offlineOrder = await this.idbService.getOrderByLocalGuid(this.state.orderGuid);
                    offlineOrder.name = `Offline Order ${offlineOrder.id}`;
                    // this.setState({
                    //     order: offlineOrder,
                    //     offlineOrder: offlineOrder,
                    // } as any);
                    // console.log("offlineOrder", offlineOrder);
                    this.setupOrderEntryFromOrder(offlineOrder);
                }
            }
        } else {
            datadogLogs.logger.info("Order Guid Doesn't Match Url Param Guid", {
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                orderGuid: this.props.match.params.order_guid,
                urlGuid: this.props.match.params.order_guid,
                stateOrderGuid: this.state.orderGuid,
                callingFn,
                view,
                fn: "getOrder",
            });
        }
    };

    /**
     * Process the Order Items to calculates the totals in the order.
     *
     * @param order
     *
     * @return object
     */
    processTotals = (
        order: IOrderUI
    ): {
        orderUpdated: IOrderUI;
        pricing: {
            sub_total: number;
            tax: number;
            shipping: number;
            other: number;
            credit_card_surcharge_amount: number;
            grand_total: number;
        };
    } => {
        if (!this.state.isOnline) {
            return OrderEntryService.processTotals(order, this.props.supplierModel);
        } else {
            return {
                orderUpdated: order,
                pricing: {
                    sub_total: order.sub_total || 0,
                    tax: order.tax || 0,
                    shipping: order.shipping || 0,
                    other: order.other || 0,
                    credit_card_surcharge_amount: order.credit_card_surcharge_amount || 0,
                    grand_total: order.grand_total || 0,
                },
            };
        }
    };

    /**
     * Iterates through the Order Items to get the last item no.
     *
     * @param order
     * @return number
     */
    getLastItemNo = (order: IOrder): number => {
        let lastItemNo = 0;

        _.each(order.Order_Items, (item: IOrder_Item) => {
            // Skip child items (items with parent_order_item_id) as they use decimal numbering (e.g., 1.1, 1.2)
            // Only consider parent items when calculating the next item number
            if (item.parent_order_item_id) {
                return;
            }

            const itemNo = Number(item.item_no.toString());

            if (!_.isNaN(itemNo) && itemNo > lastItemNo) {
                lastItemNo = itemNo;
            }
        });

        return lastItemNo;
    };

    /**
     * Given the Order, Determine the Breadcrumbs and the Page Title
     *
     * @param order
     *
     */
    getNavItemsAndTitle = (order: IOrder): { orderEntryTitle: any; navItems: IBreadcrumbs[] } => {
        let orderEntryTitle = (
            <FormattedMessage
                id={SupplierService.updateStringWithOrderNameOverride("order_entry", this.props.supplierModel)}
                defaultMessage={`{order_name} ${_.startCase(
                    SupplierService.updateStringWithOrderNameOverride(`Order Entry`, this.props.supplierModel)
                )}`}
                description="Order Entry Label"
                values={{ order_name: order.name }}
            />
        );

        const navItems: IBreadcrumbs[] = [];

        if (order.is_quote) {
            orderEntryTitle = (
                <FormattedMessage
                    id="quote_order_entry"
                    defaultMessage={`Quote {order_name}`}
                    description="Quote Order Entry Label"
                    values={{ order_name: order.name }}
                />
            );

            navItems.push(
                { title: "quotes", url: "/quotes" },
                {
                    title: orderEntryTitle,
                    url: `/quotes/${order.guid}/entry`,
                }
            );
        } else if (order.is_template) {
            orderEntryTitle = (
                <FormattedMessage
                    id="template_order_entry"
                    defaultMessage={`Template {order_name}`}
                    description="Template Order Entry Label"
                    values={{ order_name: order.name }}
                />
            );

            navItems.push(
                { title: "templates", url: "/templates" },
                {
                    title: orderEntryTitle,
                    url: `/templates/${order.guid}/entry`,
                }
            );
        } else {
            navItems.push(
                {
                    title: SupplierService.updateStringWithOrderNameOverride("Orders", this.props.supplierModel),
                    url: SupplierService.updateStringWithOrderNameOverride("/orders", this.props.supplierModel),
                },
                {
                    title: orderEntryTitle,
                    url: `/orders/${order.guid}/entry`,
                }
            );
        }

        return { orderEntryTitle, navItems };
    };

    /**
     * Perform Setup of Order Entry for the UI from the Order
     *
     * @param order
     *
     * @return void
     */
    setupOrderEntryFromOrder = (order: IOrderUI, relatedOrders?: IRelatedOrder[]) => {
        const lastItemNo = this.getLastItemNo(order);

        const { orderUpdated, pricing } = this.processTotals(order);

        const { orderEntryTitle, navItems } = this.getNavItemsAndTitle(order);

        order = orderUpdated;

        let reconcileData = [];

        // TODO
        // @ts-expect-error
        if (order.reconcileData) {
            // @ts-expect-error
            reconcileData = order.reconcileData;
        }

        if (_.isNil(order.details)) {
            order.details = {};
        }

        const tableClass = "std-table-class";
        const orderItemType = "STANDARD";

        // Used to Setup the Orders Vendor Model
        const orderVendorModel = order.Vendor;

        const showQBOInvoice = this.state.showQBOInvoice;

        let editMode = this.state.editMode;

        if (this.props.supplierModel.orders_start_in_edit_mode) {
            if (order.order_state_id === OrderStatesEnum.PRELIMINARY) {
                editMode = true;
            }

            if (
                order.order_state_id === OrderStatesEnum.SUBMITTED &&
                this.props.supplierModel.guid === SupplierGuidEnum.FIRE_PIT_MEATS &&
                this.props.userModel.isSupplierUser
            ) {
                for (const orderItem of order.Order_Items) {
                    orderItem.rowEditMode = true;
                }
            }
        }

        let showStartPurchaseOrderModal = false;

        const orderStates = OrderEntryService.getOrderSteps(
            this.props.supplierModel,
            order.order_state_id || OrderStatesEnum.PRELIMINARY,
            order.Workflow?.detail,
            order
        );

        // console.log("orderStates: ", orderStates);

        const secondOrderState: IOrder_Progress_State =
            orderStates.length > 1 ? orderStates[1] : ({ order_state_id: OrderStatesEnum.PRELIMINARY } as IOrder_Progress_State);

        if (this.props.userModel.isSupplierUser) {
            if (this.props.supplierModel.has_purchase_orders && order.order_state_id === secondOrderState.order_state_id) {
                if (this.props.supplierModel.prompt_order_entry_create_po) {
                    if (!order.Purchase_Orders?.length) {
                        showStartPurchaseOrderModal = true;
                    }
                }
            }
        }

        this.setState(
            {
                editMode,
                order,
                currentItemNo: lastItemNo,
                navItems,
                tableClass,
                orderItemType,
                orderVendorModel,
                reconcileData,
                isDataFetching: false,
                isInitialData: false,
                showQBOInvoice: false,
                showStartPurchaseOrderModal,
                hasCollectedPaymentAuth: order.is_paid || false,
                relatedOrders,
            },
            () => {
                this.props.setActivityIndicator(false);
                this.setupTableColumns();
                this.getPriceGroups();

                if (showQBOInvoice) {
                    this.viewQBOInvoice();
                }

                if (this.state.showStartPurchaseOrderModal) {
                    this.showStartPurchaseOrderModal();
                }
            }
        );

        document.title = `Orderwerks >> ${order.name}`;
    };

    showStartPurchaseOrderModal = () => {
        const modalComponent = <StartPurchaseOrderModal closeModalFn={this.closePoModal} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
            modalStyle: {
                content: {
                    minHeight: "5rem",
                    maxHeight: "15rem",
                    height: "auto",
                },
            },
        });
    };

    closePoModal = (startPo: boolean) => {
        this.setState({
            modalComponent: null,
            modalIsOpen: false,
            currentView: startPo ? OrderEntryViewStateOptionsEnum.PURCHASE_ORDER : OrderEntryViewStateOptionsEnum.ORDER_ENTRY,
        });
    };

    // quaggaOnDetected = (data: QuaggaJSResultObject) => {
    //     // console.log("quaggaOnDetected", data);
    //     if (data.codeResult.code !== this.state.currentScanCode && data.codeResult.code) {
    //         this.setState({
    //             currentScanCode: data.codeResult.code,
    //         });
    //     } else {
    //         // ignore ?
    //     }
    // };

    // clearScanCode = () => {
    //     this.setState({
    //         currentScanCode: "",
    //     });
    // };

    /**
     * Sets up Quagga for using
     */
    // initQuagga = async () => {
    //     // console.log("initQuagga");
    //
    //     await Quagga.init(
    //         {
    //             debug: true,
    //             inputStream: {
    //                 name: "Live",
    //                 type: "LiveStream",
    //                 target: document.querySelector("#quaggaOutput")!,
    //                 constraints: {
    //                     width: 640,
    //                     height: 150,
    //                 },
    //             },
    //
    //             locator: {
    //                 patchSize: "medium",
    //                 halfSample: true,
    //             },
    //             decoder: {
    //                 readers: ["code_128_reader", "upc_reader"],
    //             },
    //             locate: true,
    //         },
    //         (err) => {
    //             if (err) {
    //                 // console.log(err);
    //                 return;
    //             }
    //
    //             // console.log("Initialization finished. Ready to start");
    //             Quagga.start();
    //         }
    //     );
    //
    //     Quagga.onDetected(this.quaggaOnDetected);
    // };

    /**
     * Retrieves the Price Groups for the Orders Catalog
     *
     * @return void
     */
    getPriceGroups = () => {
        const payload: IGetPriceGroupsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel!.guid,
            catalogGuid: _.get(this.state.order, "Catalog.guid", ""),
        };

        if (!this.props.userModel?.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        if (this.state.isOnline) {
            this.props.socket.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
        } else {
            // TODO get price groups from jsstore
        }
    };

    getFunctionLocation(func: any): string {
        const funcString = func.toString();
        const match = funcString.match(/(\w+:\/\/.*?):(\d+):(\d+)/);

        if (match) {
            const [, source, line, column] = match;
            return `${source}:${line}:${column}`;
        } else {
            return "Unknown location";
        }
    }

    /**
     * onGetOrder Receiver to Process for the Order Entry Screen
     *
     * @param data
     */
    onGetOrder = (data: IOnGetOrderDTO) => {
        if (data.order.guid === this.state.orderGuid) {
            const { order, resource, relatedOrders } = data;

            // Hierarchical sort: parents first (by sort_order), then their children (by sort_order)
            // This ensures parent-child relationships are preserved in the display order
            const parents = order.Order_Items.filter((item) => !item.parent_order_item_id).sort((a, b) => {
                const sortA = a.sort_order ?? a.item_no;
                const sortB = b.sort_order ?? b.item_no;
                return sortA - sortB;
            });

            const sortedOrderItems: IOrder_Item[] = [];
            for (const parent of parents) {
                sortedOrderItems.push(parent);

                // Add all children of this parent, sorted by sort_order
                const children = order.Order_Items.filter((item) => item.parent_order_item_id === parent.id).sort((a, b) => {
                    const sortA = (a.sort_order ?? Number(a.item_no)) || 0;
                    const sortB = (b.sort_order ?? Number(b.item_no)) || 0;
                    return sortA - sortB;
                });

                sortedOrderItems.push(...children);
            }

            const orderUI: IOrderUI = {
                ...order,
                isSaved: true,
                editMode: false,
                rowEditMode: false,
                Order_Items: sortedOrderItems.map((item) => {
                    return {
                        ...item,
                        rowEditMode: false,
                        showDetailView: false,
                        isDirty: false,
                    } as IOrder_ItemUI;
                }),
            };

            this.setupOrderEntryFromOrder(orderUI, relatedOrders);
        } else {
            // @ts-expect-error
            const callbacks = this.props.socket._callbacks;

            LogService.error("onGetOrder: guid mismatch: ", {
                dataOrderGuid: data.order.guid,
                stateOrderGuid: this.state.orderGuid,
                $onGetOrder: callbacks.$onGetOrder,
                userEmail: this.props.userModel.email,
                userId: this.props.userModel.id,
                userGuid: this.props.userModel.guid,
                supplierName: this.props.supplierModel.name,
                supplierGuid: this.props.supplierModel.guid,
            });
        }
    };

    /**
     * Calculate the Tax based on the Sub Total
     *
     * @param sub_total
     *
     * @return number
     */
    doTaxCalculation = (subTotal: number): number => {
        // consider only doing this for offline orders.
        if (!this.state.order?.tax) {
            return OrderEntryService.doTaxCalculation(this.props.supplierModel, subTotal);
        } else {
            return this.state.order?.tax || 0;
        }
    };

    getVendorPriceGroupDiscount = () => {
        return OrderEntryService.getVendorPriceGroupDiscount(this.state.order);
    };

    /**
     * Calculate the Totals for the Order
     * @param order
     */
    calculateTotals = (order: IOrder): ITotalsDetails => {
        return OrderEntryService.calculateTotals(order, this.props.supplierModel);
    };

    confirmShipTo = () => {
        this.setState(
            {
                ship_to_confirmed: true,
                modalIsOpen: false,
            },
            () => {
                if (this.state.tempUpdateOrderEntryDetail) {
                    this.updateOrderEntryDetail(this.state.tempUpdateOrderEntryDetail);
                }
            }
        );
    };

    getConfirmShipToModalComponent = () => {
        return (
            <ConfirmShipToModal
                order={this.state.order!}
                cancelFn={this.closeModal}
                confirmFn={this.confirmShipTo}
                socket={this.props.socket}
                supplierModel={this.props.supplierModel}
                userModel={this.props.userModel}
            />
        );
    };

    getOrderPaymentModalComponent = (nextStep: IOrder_Progress_State) => {
        if (this.state.order) {
            if (this.props.supplierModel.default_payment_service_id === PaymentServiceTypeEnum.QUICKBOOKS_ONLINE_PAYMENTS) {
                return (
                    <QuickBooksPaymentModal
                        orderModel={this.state.order}
                        cancelFn={this.closeModal}
                        confirmFn={this.confirmPayment}
                        nextStep={nextStep}
                    />
                );
            } else if (this.props.supplierModel.default_payment_service_id === PaymentServiceTypeEnum.STRIPE) {
                return (
                    <OrderPaymentStripe
                        orderModel={this.state.order!}
                        cancelFn={this.closeModal}
                        confirmFn={this.confirmPayment}
                        nextStep={nextStep}
                    />
                );
            } else if (this.props.supplierModel.default_payment_service_id === PaymentServiceTypeEnum.AUTHORIZE_NET) {
                return (
                    <OrderPaymentAuthorizeNet
                        orderModel={this.state.order!}
                        cancelFn={this.closeModal}
                        confirmFn={this.confirmPayment}
                        nextStep={nextStep}
                    />
                );
            } else if (this.props.supplierModel.default_payment_service_id === PaymentServiceTypeEnum.SQUARE) {
                return (
                    <OrderPaymentSquare
                        orderModel={this.state.order!}
                        cancelFn={this.closeModal}
                        confirmFn={this.confirmPayment}
                        nextStep={nextStep}
                    />
                );
            }
            /**
             * Add additional payment strategies and options here.
             */
        }
    };

    confirmPayment = () => {
        this.setState(
            {
                hasCollectedPaymentAuth: true,
                modalIsOpen: false,
                modalComponent: null,
            },
            () => {
                if (this.state.tempSubmitOrderPayload) {
                    this.submitOrder(this.state.tempSubmitOrderPayload);
                }
            }
        );
    };

    submitOrder = (payload: ISubmitOrderDTO) => {
        // If the backorder modal is open, close it.
        if (this.state.modalIsOpen) {
            this.setState({
                modalIsOpen: false,
                modalComponent: null,
            });
        }

        if (this.props.supplierModel.below_min_price_approval && this.state.order) {
            let hasPendingApprovals = false;
            // validate no items require approval still
            for (const orderItem of this.state.order.Order_Items) {
                if (orderItem.awaiting_price_approval) {
                    const notification: INotification = {
                        message: "awaiting_pricing_approvals_unable_to_submit",
                        level: NotificationLevelEnum.error,
                        position: NotificationPositionEnum.bc,
                    };

                    this.props.notifyFn(null, notification);

                    hasPendingApprovals = true;
                }
            }

            if (hasPendingApprovals) {
                this.setState({
                    confirmOrderBtnActive: false,
                    completeOrderBtnActive: false,
                    createShipmentBtnActive: false,
                    confirmLocalDeliveryBtnActive: false,
                    readyForPickupBtnActive: false,
                    preliminaryBtnActive: false,
                    hasPendingDetailChanges: false,
                    customerApprovalPaymentBtnActive: false,
                    stepBtnActive: false,
                });
                return;
            }
        }
        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        if (payload.order_state_id) {
            payload.order_state_id = Number(payload.order_state_id);
        }

        // console.log("Submit Order");

        this.setState(
            {
                confirmOrderBtnActive: true,
                preliminaryBtnActive: true,
                hasPendingDetailChanges: false,
                stepBtnActive: true,
            },
            () => {
                // we're stopping using this to prevent duplicate entries as a test.
                // this.props.socket.emit(EndpointsEnum.OrderEntrySubmitOrder, payload);
                const url = SocketService.getEndpointUrl() + "/v1/order/submit";
                const headers: HeadersInit = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                };

                if (!this.props.userModel.isSupplierUser) {
                    headers!.vendorGuid = this.props.vendorModel.guid;
                }

                ky.post(url, {
                    json: payload,
                    headers,
                })
                    .then(async (res) => {
                        // console.log("Submit Order Response", res.data);
                        const data = await res.json<IOnSubmitOrderDTO>();
                        this.onSubmitOrder(data);
                    })
                    .catch(async (err) => {
                        if (err.response?.status === 422) {
                            try {
                                const data = await err.response.json();
                                if (data.message) {
                                    const notification: INotification = {
                                        message: data.message,
                                        level: NotificationLevelEnum.error,
                                        position: NotificationPositionEnum.bc,
                                        skipMessageTranslate: true,
                                    };
                                    this.props.notifyFn(null, notification);

                                    // Build orderItemIssues to highlight affected rows
                                    const orderItemIssues: { catalogItem: ICatalog_Item; qtyOnHand: number }[] = [];
                                    if (data.items?.length && this.state.order) {
                                        for (const item of data.items) {
                                            // Match against top-level order items
                                            let matchedOrderItem = this.state.order.Order_Items.find(
                                                (oi) => oi.Catalog_Item?.sku === item.sku || oi.sku === item.sku
                                            );

                                            // If not found, check kit items and highlight the parent row
                                            if (!matchedOrderItem) {
                                                for (const oi of this.state.order.Order_Items) {
                                                    if (
                                                        oi.Kit_Items?.some((ki) => ki.Catalog_Item?.sku === item.sku || ki.sku === item.sku)
                                                    ) {
                                                        matchedOrderItem = oi;
                                                        break;
                                                    }
                                                }
                                            }

                                            if (matchedOrderItem) {
                                                const isBackorderLimitItem = item.backorderLimitRemaining !== undefined;
                                                orderItemIssues.push({
                                                    // @ts-expect-error - partial ICatalog_Item, only id needed for row matching
                                                    catalogItem: { id: matchedOrderItem.catalog_item_id },
                                                    qtyOnHand: isBackorderLimitItem ? item.maxOrderQty : item.qtyOnHand,
                                                });
                                            }
                                        }
                                    }

                                    // If items have backorderLimitRemaining, show the detail modal
                                    const hasBackorderLimitItems = data.items?.some(
                                        (item: IBackorderLimitExceededItem) => item.backorderLimitRemaining !== undefined
                                    );

                                    if (hasBackorderLimitItems && data.items?.length) {
                                        const modalComponent = (
                                            <BackorderLimitExceededModal
                                                items={data.items}
                                                message={data.message}
                                                closeFn={this.closeModal}
                                            />
                                        );

                                        this.setState({
                                            confirmOrderBtnActive: false,
                                            preliminaryBtnActive: false,
                                            hasPendingDetailChanges: false,
                                            stepBtnActive: false,
                                            orderItemIssues,
                                            backorderLimitItems: data.items,
                                            modalComponent,
                                            modalIsOpen: true,
                                            modalStyle: {
                                                content: {
                                                    inset: "5vh auto auto 50%",
                                                    transform: "translateX(-50%)",
                                                    width: "50rem",
                                                    height: "auto",
                                                    minHeight: "auto",
                                                    maxHeight: "80vh",
                                                    overflow: "auto",
                                                },
                                            },
                                        });
                                    } else {
                                        this.setState({
                                            confirmOrderBtnActive: false,
                                            preliminaryBtnActive: false,
                                            hasPendingDetailChanges: false,
                                            stepBtnActive: false,
                                            orderItemIssues,
                                            backorderLimitItems: [],
                                        });
                                    }
                                    return;
                                }
                            } catch {
                                // Fall through to generic error
                            }
                        }

                        const notification: INotification = {
                            message: "error_submitting_order",
                            level: NotificationLevelEnum.error,
                            position: NotificationPositionEnum.bc,
                        };

                        this.props.notifyFn(null, notification);

                        this.setState({
                            confirmOrderBtnActive: false,
                            preliminaryBtnActive: false,
                            hasPendingDetailChanges: false,
                            stepBtnActive: false,
                        });
                    });
            }
        );
    };

    onSubmitOrder = (data: IOnSubmitOrderDTO) => {
        this.setState(
            {
                confirmOrderBtnActive: false,
                completeOrderBtnActive: false,
                createShipmentBtnActive: false,
                confirmLocalDeliveryBtnActive: false,
                readyForPickupBtnActive: false,
                preliminaryBtnActive: false,
                hasPendingDetailChanges: false,
                customerApprovalPaymentBtnActive: false,
                stepBtnActive: false,
            },
            () => {
                if (this.props.supplierModel.redirect_on_submit) {
                    const notification: INotification = {
                        message: "successfully_advanced_order",
                        position: NotificationPositionEnum.bc,
                        level: NotificationLevelEnum.success,
                    };

                    this.props.notifyFn(null, notification);

                    this.props.history("/orders");
                } else {
                    this.getOrder("onSubmitOrder", "order_entry");
                }
            }
        );
    };

    submitOrderFn = (payload: ISubmitOrderDTO) => {
        if (this.state.order) {
            if (this.props.supplierModel.has_warehouses && !this.state.order.shipping_warehouse_id) {
                const notification: INotification = {
                    title: "missing_shipping_warehouse",
                    message: "select_shipping_warehouse_from_order_details",
                    level: NotificationLevelEnum.error,
                    position: NotificationPositionEnum.bc,
                };

                this.props.notifyFn(null, notification, false);

                return;
            }

            const { currentStep, nextStep } = OrderEntryService.getCurrentAndNextOrderSteps(this.state.order!, this.props.supplierModel);
            // perform an inventory check if attempting to 'submit'
            if (this.state.order.order_state_id === OrderStatesEnum.PRELIMINARY && payload.order_state_id !== OrderStatesEnum.PRELIMINARY) {
                const showCommonItemsModal =
                    !!this.props.supplierModel.show_common_items_modal &&
                    !!this.props.supplierModel.show_common_items_on_submit &&
                    !this.state.hasShownCommonItemsModal;

                const showPaymentModal =
                    this.props.supplierModel.has_payments &&
                    ((nextStep?.collectPayment && !this.state.hasCollectedPaymentAuth) ||
                        (!this.state.hasCollectedPaymentAuth && nextStep?.onlyCollectCcToUse)) &&
                    this.state.order!.Vendor?.require_payment;

                this.setState(
                    {
                        tempSubmitOrderPayload: payload,
                        stepBtnActive: true,
                        showCommonItemsModal,
                        showModalSubmit: true,
                    },
                    () => {
                        if (this.state.showCommonItemsModal) {
                            this.showCommonItemsModal();
                        } else if (showPaymentModal) {
                            if (nextStep) {
                                this.setState({
                                    modalComponent: this.getOrderPaymentModalComponent(nextStep),
                                    modalIsOpen: true,
                                    modalStyle: {
                                        content: {
                                            inset: "5vh auto auto 50%",
                                            transform: "translateX(-50%)",
                                            width: "30rem",
                                            height: "auto",
                                            minHeight: "auto",
                                            maxHeight: "none",
                                            overflow: "visible",
                                        },
                                    },
                                    closeModalOnEsc: false,
                                    closeModalOnOverlayClick: false,
                                });
                            }
                        } else {
                            // console.log("Submit Order Fn - Inventory Check");

                            const inventoryPayload: IPerformOrderInventoryCheckDTO = {
                                userGuid: this.props.userModel.guid,
                                userToken: this.props.userModel.token,
                                supplierGuid: this.props.supplierModel.guid,
                                orderGuid: this.state.order!.guid,
                            };

                            if (!this.props.userModel?.isSupplierUser) {
                                inventoryPayload.vendorGuid = this.props.vendorModel.guid;
                            }

                            this.props.socket.emit(EndpointsEnum.OrderEntryPerformInventoryCheck, inventoryPayload);
                        }
                    }
                );
            } else {
                // console.log("updateOrderEntryDetail", data);
                this.submitOrder(payload);
            }
        }
    };

    /**
     * @deprecated
     *
     * @param data
     */
    performInventoryCheck = (data: ISubmitOrderDTO) => {
        if (this.state.order && !this.state.order.is_noninventory_order) {
            // perform an inventory check if attempting to 'submit'
            if (this.state.order.order_state_id === OrderStatesEnum.PRELIMINARY && data.order_state_id !== OrderStatesEnum.PRELIMINARY) {
                const showCommonItemsModal =
                    !!this.props.supplierModel.show_common_items_modal &&
                    !!this.props.supplierModel.show_common_items_on_submit &&
                    !this.state.hasShownCommonItemsModal;

                this.setState(
                    {
                        tempSubmitOrderPayload: data,
                        stepBtnActive: true,
                        showCommonItemsModal,
                        showModalSubmit: true,
                    },
                    () => {
                        if (this.state.showCommonItemsModal) {
                            this.showCommonItemsModal();
                        } else {
                            const payload: IPerformOrderInventoryCheckDTO = {
                                userGuid: this.props.userModel.guid,
                                userToken: this.props.userModel.token,
                                supplierGuid: this.props.supplierModel.guid,
                                orderGuid: this.state.order!.guid,
                            };

                            if (!this.props.userModel?.isSupplierUser) {
                                payload.vendorGuid = this.props.vendorModel.guid;
                            }

                            this.props.socket.emit(EndpointsEnum.OrderEntryPerformInventoryCheck, payload);
                        }
                    }
                );
            } else {
                // console.log("updateOrderEntryDetail", data);
                // this.updateOrderEntryDetail(data);
                this.submitOrder(data);
            }
        }
    };

    /**
     * Validates if the order has items that can only be partially fulfilled or not.
     * If not, then we want to show a modal to the user to confirm if they want to backorder the
     * entire order, or just partially fulfill the order and backorder the rest.
     *
     * @returns boolean
     */
    validateItemsIfPartialOnly = () => {
        let hasPartialOnly = false;

        for (const item of this.state.order!.Order_Items) {
            if (item.Catalog_Item?.has_inventory) {
                if (item.qty > (item.Catalog_Item.qty_on_hand || 0)) {
                    hasPartialOnly = true;
                }
            }
        }

        return hasPartialOnly;
    };

    /**
     * Determines if the backorder modal should be shown to the user based on the supplier model
     * and the user's type
     *
     * @returns boolean
     */
    determineBackorderModalVisibility = () => {
        if (this.props.supplierModel.has_backorders && this.props.supplierModel.backorder_modal_visibility) {
            switch (this.props.supplierModel.backorder_modal_visibility) {
                case BackorderModalVisibilityEnum.ALL_USERS:
                    return true;
                case BackorderModalVisibilityEnum.INTERNAL_USERS:
                    return this.props.userModel.isSupplierUser;
                case BackorderModalVisibilityEnum.ADMIN_USERS:
                    return (
                        this.props.userModel.isSupplierUser && this.props.userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN
                    );
                default:
                    return false;
            }
        } else {
            return false;
        }
    };

    onPerformInventoryCheck = (data: IOnPerformOrderInventoryCheckDTO) => {
        const hasPartialOnly = this.validateItemsIfPartialOnly();

        if (this.state.tempSubmitOrderPayload) {
            if (hasPartialOnly) {
                const showBackorderModal = this.determineBackorderModalVisibility();

                if (showBackorderModal) {
                    const modalComponent = (
                        <OrderEntryBackorderSelectionModal
                            orderModel={this.state.order!}
                            cancelFn={this.closeModal}
                            tempSubmitOrderPayload={this.state.tempSubmitOrderPayload}
                            submitOrderFn={this.submitOrder}
                        />
                    );

                    this.setState({
                        modalComponent,
                        modalIsOpen: true,
                    });
                } else {
                    const payload = {
                        ...this.state.tempSubmitOrderPayload,
                    };

                    if (this.props.supplierModel.default_backorder_behavior) {
                        if (this.props.supplierModel.default_backorder_behavior === BackorderBehaviorEnum.PARTIAL_FILL) {
                            payload.allowPartialFulfillment = true;
                        } else if (this.props.supplierModel.default_backorder_behavior === BackorderBehaviorEnum.FULL) {
                            payload.allowPartialFulfillment = false;
                        } else if (this.props.supplierModel.default_backorder_behavior === BackorderBehaviorEnum.MANUAL) {
                            // if we don't set it at all, it takes the manual / previous behavior where
                            // it won't create a new backorder automatically, but will reserve what it can.
                            // this is also the default if the user hasn't set this setting yet.
                        }
                    }

                    this.submitOrder(payload);
                }
            } else {
                this.submitOrder(this.state.tempSubmitOrderPayload);
            }
        }
    };

    updateOrderEntryFineDetail = (details: Partial<INewOrder_Details>) => {
        if (this.state.order) {
            const payload: IUpdateOrderEntryFineDetailsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.state.order.Vendor!.guid,
                orderGuid: this.state.order.guid,
                details,
            };

            this.props.socket.emit(EndpointsEnum.OrderEntryUpdateOrderFineDetails, payload);
        }
    };

    updateOrderEntryFineDetailWithTempData = () => {
        if (this.state.order && this.state.tempOrderFineDetails) {
            this.updateOrderEntryFineDetail(this.state.tempOrderFineDetails);
        }

        if (this.state.order && !this.state.tempOrderFineDetails && !this.state.tempCustomScheduleDetails) {
            this.getOrder("updateOrderEntryFileDetailWithTempData", "order_entry");
        }
    };

    setTempUpdateOrderFineDetails = (details: Partial<INewOrder_Details> | null, isFineDetailsValid: boolean) => {
        if (this.state.order) {
            const state: any = {
                hasPendingFineDetailChanges: true,
                isFineDetailsValid,
            };

            if (details) {
                state.tempOrderFineDetails = details;
            }

            this.setState(state);
        }
    };

    setTempCustomSchedule = (customSchedule: any) => {
        if (this.state.order) {
            const state: any = {
                hasPendingCustomScheduleDetailChanges: true,
            };

            if (customSchedule) {
                state.tempCustomScheduleDetails = customSchedule;
            }

            this.setState(state);
        }
    };

    /**
     * Updates the Order Entry Detail
     *
     * @param data                  Data to send across
     * @param isDetailsSaveOnly     Specify if the details saves only
     *
     * @return void
     */
    updateOrderEntryDetail = async (data: Partial<IUpdateOrderEntryDetailDTO>, isDetailsSaveOnly?: boolean) => {
        // const { currentStep, nextStep } = OrderEntryService.getCurrentAndNextOrderSteps(this.state.order!, this.props.supplierModel);

        if (this.state.isOfflineOrder && this.state.order && data.offlineGuid) {
            // console.log("updateOrderEntryDetail", data);
            await this.idbService.updateOrderDetails(data.offlineGuid, data);
        } else {
            if (
                this.state.order?.order_state_id === OrderStatesEnum.PRELIMINARY &&
                this.props.supplierModel.has_confirm_ship_to &&
                this.state.order?.Vendor?.require_confirm_ship_to &&
                !this.state.ship_to_confirmed
            ) {
                // console.log("confirmShipToModal");
                this.setState({
                    modalComponent: this.getConfirmShipToModalComponent(),
                    modalIsOpen: true,
                    tempUpdateOrderEntryDetail: data,
                    modalStyle: {},
                });
            } else {
                // console.log("updateOrderEntryDetail: ", data);
                data.userGuid = this.props.userModel.guid;
                data.userToken = this.props.userModel.token;
                data.vendorGuid = this.state.orderVendorModel.guid;
                data.orderGuid = this.state.orderGuid!;
                data.supplierGuid = this.props.supplierModel.guid;

                // console.log("update order entry detail: ", data);

                this.props.socket.emit(EndpointsEnum.OrderEntryUpdateOrderEntryDetail, data);

                if (this.state.tempUpdateOrderEntryDetail) {
                    this.setState({
                        tempUpdateOrderEntryDetail: null,
                        stepBtnActive: true,
                    });
                } else {
                    this.setState({
                        stepBtnActive: true,
                    });
                }
            }
        }
    };

    /**
     * Resend the submitted order email to the applicable parties
     *
     * @return void
     */
    resendSubmitEmail = () => {
        const payload: IResendEmailDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: this.state.orderVendorModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            orderGuid: this.state.order!.guid,
            type: ResendEmailTypeEnum.SUBMITTED,
        };

        this.props.socket.emit(EndpointsEnum.OrderResendEmail, payload);

        this.setState({
            resendSubmitEmailActive: true,
            stepBtnActive: true,
        });
    };

    /**
     * Resend the order automation email to the applicable parties
     */
    resendOrderAutomation = () => {
        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: _.get(this.props.supplierModel, "guid", undefined),
            orderGuid: this.state.order!.guid,
        };

        this.props.socket.emit(EndpointsEnum.OrderEntryResendOrderAutomation, payload);

        this.setState({
            resendOrderAutomationActive: true,
            stepBtnActive: true,
        });
    };

    onResendEmail = (data: IOnResendEmailDTO) => {
        this.setState(
            {
                resendSubmitEmailActive: false,
                stepBtnActive: false,
            },
            () => {
                const notification: INotification = {
                    message: "SUCCESSFULLY_RESENT_EMAIL",
                    level: NotificationLevelEnum.success,
                    position: NotificationPositionEnum.bc,
                };

                this.props.notifyFn(null, notification);
            }
        );
    };

    onResendOrderAutomation = (data: IOnResendOrderAutomationDTO) => {
        this.setState(
            {
                stepBtnActive: false,
                resendOrderAutomationActive: false,
            },
            () => {
                const notification: INotification = {
                    title: "SUCCESSFULLY_RESENT_ORDER_AUTOMATION",
                    level: NotificationLevelEnum.success,
                    position: NotificationPositionEnum.br,
                };

                this.props.notifyFn(null, notification);
            }
        );
    };

    onCreateOrderEntryItem = (data: IOnCreateOrderEntryItemDTO) => {
        this.getOrder("onCreateOrderEntryItem", "order_entry");
    };

    onUpdateOrderEntryItem = (data: IOnUpdateOrderEntryItemDTO) => {
        // turn off rowEditMode

        const order = this.state.order!;
        const orderItems: IOrder_ItemUI[] = order.Order_Items.map((item) => {
            let newOrderItem: IOrder_ItemUI = {
                ...item,
            };

            if (item.guid === data.order_entry_item.guid) {
                newOrderItem = {
                    ...newOrderItem,
                    ...data.order_entry_item,
                };
                newOrderItem.rowEditMode = false;
                newOrderItem.isDirty = false;
            }

            return newOrderItem;
        });

        order.Order_Items = orderItems!;

        order.sub_total = data.order_totals.sub_total;
        order.tax = data.order_totals.tax;
        order.shipping = data.order_totals.shipping;
        order.labor = data.order_totals.labor;
        order.other = data.order_totals.other;
        order.discount_total = data.order_totals.discount_total;
        order.credit_card_surcharge_amount = data.order_totals.credit_card_surcharge_amount;
        order.grand_total = data.order_totals.grand_total;

        const totalsDetail = this.processTotals(order);

        const { sub_total, tax, shipping, other, grand_total } = totalsDetail.pricing;

        order.sub_total = sub_total;
        order.tax = tax;
        order.shipping = shipping;
        order.other = other;
        order.grand_total = grand_total;

        this.setState(
            {
                order,
            },
            () => {
                if (
                    this.props.supplierModel.Supplier_Integration.has_taxjar ||
                    this.props.supplierModel.has_shipping_by_weight ||
                    this.state.order?.Vendor?.item_sales_tax_id ||
                    data.order_entry_item.is_catch_weight_item
                ) {
                    this.getOrder("onUpdateOrderEntryItem", "order_entry");
                }

                if (data.doOrderRefresh) {
                    this.getOrder("onUpdateOrderEntryItem", "order_entry");
                }
            }
        );
    };

    onDeleteOrderEntryItem = (data: IOnDeleteOrderEntryItemDTO) => {
        this.getOrder("onDeleteOrderEntryItem", "order_entry");
    };

    // TODO What call is this?
    onGetOrderDetails = (data: IOnGetOrderEntryDetailDTO) => {
        this.getOrder("onGetOrderDetails", "order_entry");
    };

    onUpdateOrderEntryDetail = (data: IOnUpdateOrderEntryDetailDTO) => {
        this.setState(
            {
                confirmOrderBtnActive: false,
                completeOrderBtnActive: false,
                createShipmentBtnActive: false,
                confirmLocalDeliveryBtnActive: false,
                readyForPickupBtnActive: false,
                preliminaryBtnActive: false,
                hasPendingDetailChanges: false,
                customerApprovalPaymentBtnActive: false,
                stepBtnActive: false,
            },
            () => {
                this.getOrder("onUpdateOrderEntryDetail", "order_entry");
            }
        );
    };

    editMetaData = () => {
        if (this.state.order) {
            const component = <OrderMetadataSidebar cancelFn={this.closeSidebar} orderModel={this.state.order} />;
            this.props.setSidebarComponent(component);
            this.props.toggleSidebar(true);
        }
    };

    createPickList = () => {
        if (this.state.order) {
            const payload: ICreatePickListDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                orderGuids: [this.state.order.guid],
            };

            this.props.socket.emit(EndpointsEnum.OrderCreatePickList, payload);
        }
    };

    onCreatePickList = (data: IOnCreatePickListDTO) => {
        this.props.history(`/pick_lists/${data.pickList[0].guid}`);
    };

    /**
     * Get the next item number for the order item
     */
    getNextItemNo = () => {
        let currentItemNo = this.state.currentItemNo;

        return ++currentItemNo;
    };

    /**
     * Process the given item for the API
     *
     * TODO - This has a weird setup where we add a qty to the Catalog Item
     *
     * @param item
     * @param _item_no
     */
    processStandardItem: ProcessOrderEntryItemFn = (item, options) => {
        const priceGroupName = _.get(this.state, "order.Price_Group.value", "");

        let nextItemNo = this.getNextItemNo();

        if (!_.isNil(options?.itemNo) && options?.itemNo) {
            nextItemNo = options.itemNo;
        }

        let showDetailView = false;

        if ("require_addl_input" in item && item.require_addl_input) {
            showDetailView = true;
        }

        let listPriceFrozen;
        let costPriceFrozen;

        if ("pricing" in item && item.pricing) {
            listPriceFrozen = Number(item.pricing[`${priceGroupName}`]);
            costPriceFrozen = Number(item.pricing[`${priceGroupName}`]);
        }

        let discount_id: number | undefined;

        if (options?.discount) {
            discount_id = options?.discount.id;
            // @ts-expect-error
        } else if (item.discount_id) {
            // @ts-expect-error
            discount_id = item.discount_id;
        }

        return {
            item_no: nextItemNo,
            order_id: this.state.order!.id,
            parent_order_item_id: undefined,
            catalog_item_id: item.id,
            catalog_item_guid: item.guid,
            sku: item.sku,
            Catalog_Item: item,
            qty: "qty" in item ? item.qty : undefined,
            list_price_frozen: listPriceFrozen,
            cost_price_frozen: costPriceFrozen,
            note: "note" in item ? item.note : undefined,
            description: undefined,
            rowEditMode: true,
            showDetailView, // contains the notes section.
            discount_id,
            uom_set_id: options?.uomSet?.id,
            depth: item.depth ? item.depth : undefined,
        };
    };

    toggleConfirmDelete = (e: any, data: IOrder_ItemUI, index: number, ref: React.Ref<HTMLElement>) => {
        // console.log("toggleConfirmDelete", e, data, index, ref);
        if (!ref) {
            return;
        }

        this.deleteIndex = index;

        const elem = document.getElementById(`row-${index}`);

        this.setState({
            selectedRowId: `row-${index}`,
            selectedRowRef: elem,
        });
    };

    /**
     * This function is what either saves or updates a given order entry item when it's added or accepted
     *
     * @param rowData IOrder_ItemUI
     * @param options
     */
    updateOrderEntryItem: ProcessOrderEntryItemFn = async (rowData, options) => {
        // if (!("rowEditMode" in rowData)) {
        //     return;
        // } else {
        let rowEditMode = false;

        const order = this.state.order!;

        for (const item of order.Order_Items) {
            if (item.guid === rowData.guid) {
                item.rowEditMode = !item.rowEditMode;
                // rowEditMode = item.rowEditMode;
                if ("rowEditMode" in rowData) {
                    rowEditMode = rowData.rowEditMode;
                }
            }
        }

        // if (!_.isNil(index)) {
        //     this.state.order!.items[index].rowEditMode = !rowData.rowEditMode;
        //     rowEditMode = this.state.order!.items[index].rowEditMode;
        // }

        // console.log("updateOrderEntryItem", rowEditMode, rowData, options?.shouldAutoSave);

        // If Not in row Edit mode anymore. Have to think in reverse
        if (!rowEditMode) {
            if (rowData.guid) {
                if ("isDirty" in rowData && rowData.isDirty) {
                    if (options?.shouldAutoSave) {
                        const payload: IUpdateOrderEntryItemDTO = {
                            ...rowData!,
                            qty: Number(rowData.qty),
                            list_price_frozen: Number(rowData.list_price_frozen),
                            cost_price_frozen: Number(rowData.cost_price_frozen),
                            userToken: this.props.userModel.token,
                            userGuid: this.props.userModel.guid,
                            vendorGuid: this.state.orderVendorModel.guid,
                            supplierGuid: this.props.supplierModel.guid,
                            orderGuid: this.state.order!.guid,
                            orderEntryItemGuid: rowData.guid,
                            // guid: undefined,
                        };

                        if (rowData.is_manual_price) {
                            payload.cost_price_frozen = this.getDiscountedPrice(payload.list_price_frozen || 0);
                        }

                        // If for some reason the user doesn't set a discount type, we default to fixed
                        if (rowData.discount) {
                            if (!rowData.discount_type_id) {
                                rowData.discount_type_id = PriceUpchargeTypeEnum.FIXED;
                            }
                        }

                        if (this.state.isOnline && !this.state.isOfflineOrder) {
                            this.props.socket.emit(EndpointsEnum.OrderEntryUpdateOrderEntryItem, payload);
                        } else {
                            // TODO update in the jsstore
                            // console.log("Update in JSStore", rowData);
                            await this.idbService.updateOrderItem(payload);
                            this.forceUpdate();
                        }
                    } else {
                        const orderItems = this.state.order!.Order_Items.map((item) => {
                            if (item.guid === rowData.guid) {
                                item = {
                                    ...rowData,
                                };
                                item.rowEditMode = false;
                                item.isDirty = false;
                            }

                            return item;
                        });

                        this.setState({
                            order: {
                                ...this.state.order!,
                                Order_Items: orderItems,
                            },
                        });
                    }
                } else {
                    // If its not dirty, just toggle the row edit mode off
                    this.forceUpdate();
                }
            } else {
                if (options?.shouldAutoSave) {
                    if ("list_price_frozen" in rowData) {
                        const payload: IUpdateOrderEntryItemDTO = {
                            ...rowData!,
                            qty: Number(rowData.qty),
                            list_price_frozen: Number(rowData.list_price_frozen),
                            cost_price_frozen: Number(rowData.cost_price_frozen),
                            userToken: this.props.userModel.token,
                            userGuid: this.props.userModel.guid,
                            vendorGuid: this.state.orderVendorModel.guid,
                            supplierGuid: this.props.supplierModel.guid,
                            orderGuid: this.state.order!.guid,
                            orderEntryItemGuid: rowData.guid,
                            kitDetails: options?.kitDetails,
                            kitBuilderData: options?.kitBuilderOptions,
                            // guid: undefined,
                        };

                        if (payload.kitDetails?.length) {
                            payload.kitDetails = payload.kitDetails.map((kitDetail) => {
                                return {
                                    id: kitDetail.id,
                                    qty: Number(kitDetail.qty),
                                } as IKitDetails;
                            });
                        }

                        if (options?.itemOptions?.length) {
                            payload.itemOptionValues = options.itemOptions.map((option) => {
                                return {
                                    item_option_id: option.item_option_id!,
                                    value: option.value || "",
                                };
                            });
                        }

                        if (this.state.isOnline && !this.state.isOfflineOrder) {
                            this.props.socket.emit(EndpointsEnum.OrderEntryCreateOrderEntryItem, payload);
                        } else {
                            const offlinePayload: IOfflineCreateOrderItem = {
                                Catalog_Item: {
                                    ...rowData.Catalog_Item!,
                                },
                                orderId: this.state.order!.id,
                                order_id: this.state.order!.id,
                                catalog_item_id: rowData.Catalog_Item!.id,
                                item_no: rowData.item_no,
                                list_price_frozen: Number(rowData.list_price_frozen),
                                cost_price_frozen: Number(rowData.cost_price_frozen),
                                note: rowData.note,
                                qty: Number(rowData.qty),
                            };

                            await this.idbService.createOrderItem(offlinePayload);
                        }
                    }
                } else {
                    this.forceUpdate();
                }
            }
        } else {
            this.forceUpdate();
        }

        let hasRowsInEditMode = false;

        _.each(this.state.order!.Order_Items, (item: IOrder_ItemUI) => {
            if (item.rowEditMode) {
                hasRowsInEditMode = true;
            }
        });

        this.setState({
            hasRowsInEditMode,
        });
        // }
    };

    findExistingItem = (
        item: INewOrder_ItemUI,
        kitDetails?: IKitDetails[]
    ): { hasExistingItem: boolean; existingItem?: IOrder_ItemUI } => {};

    updateExistingItemQty = (existingItem: IOrder_ItemUI, item: IOrder_ItemUI | IDraftOrderItem | INewOrder_Item): IOrder_Item => {
        const orderItem = existingItem;

        orderItem.qty = Number(orderItem.qty) + Number(item.qty);
        orderItem.isDirty = true;

        return orderItem;
    };

    addOrderEntryItem: ProcessOrderEntryItemFn = (item, options) => {
        const order = this.state.order!;

        const { hasExistingItem, existingItem } = OrderEntryService.findExistingItemById(
            order,
            this.props.supplierModel,
            item.id,
            options?.kitDetails
        );

        let orderItem: any;

        if (!hasExistingItem) {
            orderItem = this.processStandardItem(item, {
                discount: options?.discount,
                uomSet: options?.uomSet,
                kitBuilderOptions: options?.kitBuilderOptions,
                kitDetails: options?.kitDetails,
                itemOptions: options?.itemOptions,
            });
        } else {
            orderItem = this.updateExistingItemQty(existingItem!, item);
        }

        if (options?.shouldAutoSave) {
            orderItem.rowEditMode = false;

            if (this.state.isOnline && !this.state.isOfflineOrder) {
                this.updateOrderEntryItem(orderItem, {
                    shouldAutoSave: true,
                    kitDetails: options?.kitDetails,
                    kitBuilderOptions: options?.kitBuilderOptions,
                    itemOptions: options?.itemOptions,
                });
            } else {
                orderItem.apiData = Object.assign({}, orderItem);
                orderItem.Catalog_Item = item;
                orderItem.catalogItemId = item.id;
                if ("pricing" in item) {
                    orderItem.listPriceFrozen = item.pricing[this.state.order!.Price_Group!.value];
                }

                this.updateOrderEntryItem(orderItem, { shouldAutoSave: true });

                order.Order_Items.push(orderItem);

                const { orderUpdated, pricing } = this.processTotals(order);

                this.setState(
                    {
                        order: orderUpdated,
                        currentItemNo: orderItem.item_no,
                    },
                    () => {
                        if (this.state.isOfflineOrder) {
                            this.getOrder("addOrderEntryItem", "order_entry");
                        }
                    }
                );
            }
        } else {
            order.Order_Items.push(orderItem);

            this.setState({
                order,
                currentItemNo: orderItem.item_no,
            });
        }
    };

    parseDate = (date: any) => {
        if (!_.isString(date) || !date.length) {
            return;
        }

        return UserService.parseLastUpdated(date);
    };

    commitDelete = async () => {
        if (!_.isNil(this.deleteIndex)) {
            const rowData = this.state.order!.Order_Items![this.deleteIndex];

            this.deleteIndex = undefined;

            if (rowData) {
                this.deleteOrderEntryItem(rowData);
            }

            this.setState({
                selectedRowId: undefined,
                selectedRowRef: null,
            });
        }
    };

    deleteOrderEntryItem = async (orderItem: IOrder_Item) => {
        if (this.state.orderGuid) {
            const payload: IDeleteOrderEntryItemDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.state.orderVendorModel.guid,
                orderGuid: this.state.order!.guid,
                orderEntryItemGuid: orderItem.guid,
            };

            if (!this.state.isOfflineOrder) {
                this.props.socket.emit(EndpointsEnum.OrderEntryDeleteOrderEntryItem, payload);
            } else {
                await this.idbService.deleteOrderItem(payload);

                this.getOrder("deleteOrderEntryItem", "order_entry");
            }
        }
    };

    cancelDelete = () => {
        this.deleteIndex = undefined;

        this.setState({
            selectedRowRef: null,
            selectedRowId: undefined,
        });
    };

    // TODO
    // toggleResetItemToCatalogDefault = (data: IOrder_ItemUI, index: number) => {
    //     // reset the given item index to its catalog default price value.
    //     data.is_manual_price = false;
    //
    //     const priceGroup = this.state.order!.Price_Group;
    //
    //     // @ts-expect-error
    //     data.list_price_frozen = data.Catalog_Item!.pricing[priceGroup.value];
    //     data.isDirty = true;
    //
    //     console.log("reset row item pricing", data);
    //
    //     this.toggleRowEditMode(data, undefined, true);
    // };

    /**
     * Update the Order Entry Row as Necessary
     *
     * @param e
     * @param data
     * @param index
     * @param prop
     */
    rowUpdate = (e: any, data: IOrder_ItemUI, index: number, prop: string) => {
        const value = e.target.value;
        const name = e.target.name;

        const order = this.state.order!;

        const orderItems = order.Order_Items;

        for (const item of orderItems) {
            if (item.guid === data.guid) {
                // @ts-expect-error
                item[prop] = value;
                item.isDirty = true;

                if (prop === "list_price_frozen") {
                    if (this.props.supplierModel!.allow_manual_pricing) {
                        item.is_manual_price = true;

                        if (Number(item.cost_price_frozen) === 0) {
                            item.cost_price_frozen = Number(item.list_price_frozen);
                        }
                    }
                }
            }
        }

        order.Order_Items = orderItems;

        this.setState({
            order,
        });
    };

    /**
     * Function to reset / resynchronize the numbers in the order, sorted and numbered by created_at property for
     * the order items.
     */
    renumberItemNumbers = async (e: any) => {
        if (this.state.order) {
            const { Order_Items } = this.state.order;

            if (Order_Items) {
                let currentNumber = 1;
                const renumberArr: any = [];

                for (const orderItem of Order_Items) {
                    renumberArr.push({ order_item_guid: orderItem.guid, item_no: currentNumber });
                    ++currentNumber;
                }

                const payload = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                    vendorGuid: this.props.vendorModel.guid,
                    orderGuid: this.state.order.guid,
                    renumberArr,
                };

                if (this.state.isOfflineOrder) {
                    await this.idbService.renumberOrderItems(payload);

                    this.getOrder("renumberItemNumber", "order_entry");
                } else {
                    this.props.socket.emit(EndpointsEnum.OrderEntryRenumberOrderItems, payload);
                }
            }
        }
    };

    /**
     * Toggle the Sort Direction
     *
     * @return void
     */
    toggleSortDir = (): void => {
        const currentSortDir = this.state.sortDir;
        let sortDir = SortOrderEnum.ASC;

        if (currentSortDir === SortOrderEnum.ASC) {
            sortDir = SortOrderEnum.DESC;
        }

        const order = this.state.order;
        let orderItems = order!.Order_Items;

        orderItems = _.orderBy(orderItems, ["item_no"], [sortDir]);

        order!.Order_Items = orderItems;

        this.setState({ sortDir, order });
    };

    /**
     * Checks to see if the current row numbering is out of sequence
     *
     * @return boolean
     */
    isNumberingOutOfSequence = (): boolean => {
        let outOfSequence = false;
        let currentNumber = 1;
        let currentChildNumber = 1;

        if (this.state.order && this.state.order.Order_Items) {
            // TODO only show this if its the default sort
            for (let i = 0; i < this.state.order.Order_Items.length; ++i) {
                const orderItem = this.state.order.Order_Items[i];

                if (orderItem.parent_order_item_id) {
                    if (Number(orderItem.item_no) === Number(`${currentNumber}.${currentChildNumber}`)) {
                        ++currentChildNumber;
                    } else {
                        outOfSequence = true;
                    }
                } else {
                    if (Number(orderItem.item_no) === currentNumber) {
                        ++currentNumber;
                    } else {
                        outOfSequence = true;
                    }
                }
            }
        }

        return outOfSequence;
    };

    /**
     * Retrieves the catalog item detail or, if the user
     * overrides the value, then show the users value.
     */
    getCatalogItemDetailOrOverride = (item: any, prop: any, catalogItemSubProp: any, onlyGetFromCatalogItem: boolean) => {
        let display;

        if (_.has(item, prop) && !onlyGetFromCatalogItem) {
            display = item[prop];
        } else {
            if (!_.isNil(item.Catalog_Item)) {
                if (_.isNil(catalogItemSubProp)) {
                    display = item.Catalog_Item[prop];
                } else {
                    display = item.Catalog_Item[prop][catalogItemSubProp];
                }
            } else {
                display = "";
            }
        }

        return display;
    };

    toggleShippingEditMode = () => {
        this.setState({
            shippingEditMode: !this.state.shippingEditMode,
        });
    };

    toggleOtherEditMode = () => {
        this.setState({
            otherEditMode: !this.state.otherEditMode,
        });
    };

    showConvertQuoteToOrderModal = () => {
        const modalComponent = (
            <ConvertQuoteToOrderModal
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                submitFn={this.convertQuoteToOrder}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    convertQuoteToOrder = (options?: { poNo?: string }) => {
        if (this.state.order) {
            const state: any = {
                convertQuoteToOrderActive: true,
                stepBtnActive: true,
                modalComponent: null,
                modalIsOpen: false,
            };

            this.setState(state, () => {
                const payload: IConvertQuoteToOrderDTO = {
                    quoteGuid: this.state.order!.guid,
                    duplicate: true, // Build Out for User Option - False will just toggle the is_quote flag
                    supplierGuid: this.props.supplierModel.guid,
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                };

                if (options?.poNo) {
                    payload.orderPo = options.poNo;
                }

                if (!this.props.userModel?.isSupplierUser) {
                    payload.vendorGuid = this.props.vendorModel.guid;
                }

                this.props.socket.emit(EndpointsEnum.OrderConvertQuoteToOrder, payload);
            });
        }
    };

    onConvertQuoteToOrder = (data: IOnConvertQuoteToOrderDTO) => {
        const state: any = {
            order: undefined,
            orderGuid: data.order.guid,
            stepBtnActive: false,
            convertQuoteToOrderActive: false,
        };

        this.setState(state, () => {
            const orderGuid = this.state.orderGuid;

            this.props.history(`/orders/change/${orderGuid}`);
        });
    };

    getNextOrderState = (defaultState: OrderStatesEnum): OrderStatesEnum => {
        let nextOrderState = defaultState;

        if (this.props.supplierModel && this.props.supplierModel.order_progress_states) {
            const { order_progress_states } = this.props.supplierModel;

            let currentStateIndex = 0;

            for (let i = 0; i < order_progress_states.length; ++i) {
                const state = order_progress_states[i];

                if (state.order_state_id === this.state.order!.order_state_id) {
                    currentStateIndex = i;
                    break;
                }
            }

            let nextState;

            if (currentStateIndex + 1 < order_progress_states.length) {
                nextState = order_progress_states[currentStateIndex + 1];
            }

            if (nextState) {
                nextOrderState = nextState.order_state_id;
            }
        }

        return nextOrderState;
    };

    confirmOrderLocalDelivery = () => {
        this.setState(
            {
                confirmLocalDeliveryBtnActive: true,
                stepBtnActive: true,
            },
            () => {
                const data = {
                    order_state_id: OrderStatesEnum.SHIPPED,
                    is_local_delivery: true,
                };

                this.updateOrderEntryDetail(data);
            }
        );
    };

    cancelOrderFn = (uncancel?: boolean) => {
        if (!this.state.order?.is_cancelled) {
            const modalComponent = <OrderCancelledModal closeModalFn={this.closeModal} onCancelFn={this.cancelOrderAPI} />;

            this.setState({
                modalComponent,
                modalIsOpen: true,
            });
        } else {
            this.cancelOrderAPI("", false, uncancel);

            // this.setState(
            //     {
            //         stepBtnActive: true,
            //     },
            //     () => {
            //         const data = {
            //             is_cancelled: !this.state.order?.is_cancelled,
            //         };
            //
            //         this.updateOrderEntryDetail(data);
            //     }
            // );
        }
    };

    cancelOrderAPI = (onCancelReason: string, sendEmail: boolean, uncancel?: boolean) => {
        const payload: IOrderEntryCancelOrderDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderGuid: this.state.order!.guid,
            onCancelReason,
            sendEmail,
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        if (uncancel) {
            payload.uncancel = uncancel;
        }

        this.props.socket.emit(EndpointsEnum.OrderEntryCancelOrder, payload);

        this.setState({
            stepBtnActive: true,
            modalComponent: null,
            modalIsOpen: false,
        });
    };

    onSaveRatingRequest = () => {
        this.getOrder("onSaveRatingRequest", "order_entry");
    };

    onCancelOrder = () => {
        const notification: INotification = {
            message: SupplierService.updateStringWithOrderNameOverride("successfully_cancelled_order", this.props.supplierModel),
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                stepBtnActive: false,
            },
            () => {
                this.getOrder("onCancelOrder", "order_entry");
            }
        );
    };

    toggleBackorder = () => {
        const data = {
            is_backorder: !this.state.order?.is_backorder,
        };

        this.updateOrderEntryDetail(data);
    };

    putOrderOnHold = () => {
        if (!this.state.order?.is_on_hold) {
            const modalComponent = <OrderOnHoldModal closeModalFn={this.closeModal} onHoldFn={this.putOrderOnHoldAPI} />;

            this.setState({
                modalComponent,
                modalIsOpen: true,
            });
        } else {
            this.setState(
                {
                    stepBtnActive: true,
                },
                () => {
                    const data = {
                        is_on_hold: !this.state.order?.is_on_hold,
                    };

                    this.updateOrderEntryDetail(data);
                }
            );
        }
    };

    putOrderOnHoldAPI = (onHoldReason: string, sendEmail: boolean) => {
        const payload: IOrderEntryHoldOrderDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderGuid: this.state.order!.guid,
            onHoldReason,
            sendEmail,
        };

        this.props.socket.emit(EndpointsEnum.OrderEntryHoldOrder, payload);

        this.setState({
            stepBtnActive: true,
            modalComponent: null,
            modalIsOpen: false,
        });
    };

    onHoldOrder = () => {
        const notification: INotification = {
            message: "successfully_put_order_on_hold",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                stepBtnActive: false,
            },
            () => {
                this.getOrder("onHoldOrder", "order_entry");
            }
        );
    };

    closeShipmentGroupSidebar = (refresh?: boolean, navToShipmentGroup?: boolean) => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);

        if (navToShipmentGroup) {
            if (this.state.order) {
                this.props.history(
                    `has_shipments=true&hide_signed=true&offset=0&limit=5&shipment_type=shipment&order_name=${this.state.order.name!}`
                );
            }
        }
    };

    /**
     * Brings the user to the Shipments Section with the Create Shipment Group Pre-Filled
     */
    createShipment = () => {
        this.setState(
            {
                createShipmentBtnActive: true,
                stepBtnActive: true,
            },
            () => {
                if (this.state.order) {
                    const vendorGuid = this.state.order.Vendor!.guid;
                    const vendorName = encodeURIComponent(this.state.order.Vendor!.name);
                    const orderName = encodeURIComponent(this.state.order.name!);
                    const orderGuid = this.state.order.guid!;
                    const isLocalPickup = this.state.order.is_local_pickup;
                    const isLocalDelivery = this.state.order.is_local_delivery;
                    const isDropshipment = this.state.order.is_dropship;

                    this.props.history(
                        `/shipments?action=new_shipment&vendor_guid=${vendorGuid}&vendor_name=${vendorName}&order_guid=${orderGuid}&order_name=${orderName}&is_local_pickup=${isLocalPickup}&is_local_delivery=${isLocalDelivery}&is_dropshipment=${isDropshipment}`
                    );
                }
            }
        );
    };

    shouldHidePricing = (): boolean => {
        return UserService.hidePricing(this.props.supplierModel, this.props.userModel, this.props.vendorModel);
    };

    getTotalOrderWeight = (): number => {
        let totalWeight = 0;

        if (this.state.order?.Order_Items) {
            for (const item of this.state.order.Order_Items) {
                totalWeight += Number(item.Catalog_Item?.item_weight || 0) * Number(item.qty);
            }
        }

        return totalWeight;
    };

    getTotalOrderWeightDiv = () => {
        if (this.props.supplierModel.show_total_order_weight) {
            const totalWeight = this.getTotalOrderWeight();

            return (
                <div className={"ms-2"}>
                    - <OwLabel title={"total_weight"} postText={":"} />{" "}
                    <FormattedNumber
                        value={totalWeight}
                        minimumFractionDigits={2}
                        maximumFractionDigits={2}
                        unit={"pound"}
                        unitDisplay={"short"}
                        style={"unit"}
                    />
                </div>
            );
        } else {
            return null;
        }
    };

    getCategoryTally = () => {
        if (!this.props.supplierModel.has_category_tally) {
            return null;
        }

        if (!this.state.order) {
            return null;
        }

        return <CategoryTallyWidget order={this.state.order} />;
    };

    getTotalItemCount = () => {
        let totalItems = 0;

        if (this.state.order?.Order_Items) {
            for (const item of this.state.order.Order_Items) {
                totalItems++;
            }
        }

        return (
            <ControlBar
                sections={[
                    {
                        name: "Total Items",
                        elements: [
                            <div key={totalItems} className="d-inline-block">
                                <OwLabel className="me-1" title={"total_items"} isBold={true} postText={":"} />
                                {totalItems}
                            </div>,
                        ],
                    },
                ]}
            />
        );
    };

    updateTableView = (tableType: any) => {
        // options
        // ---
        // standardTable
        // smallTable
        // photosTable
        this.setState({ tableType });
    };

    closeModal = () => {
        this.setState({
            tempSubmitOrderPayload: undefined,
            showCommonItemsModal: false,
            modalIsOpen: false,
            modalComponent: null,
            stepBtnActive: false,
        });
    };

    /**
     * Adds Items in a Bulk Manner to the Order
     */
    addBulkItems = (items: IAddBulkItems[]) => {
        const order = this.state.order!;
        const bulkAddItems: IAddBulkItems[] = [];
        const bulkUpdateItems: IUpdateBulkItems[] = [];

        let { currentItemNo } = this.state;

        // console.log("currentItemNo", currentItemNo);

        // This takes care of if there are NO Items currently, otherwise we get the current number and increment.
        if (_.isNil(currentItemNo) || !currentItemNo) {
            currentItemNo = 1;
        } else {
            currentItemNo++;
        }

        for (const item of items) {
            let findExistingItem: { hasExistingItem: boolean; existingItem?: IOrder_ItemUI } | undefined;

            if (item.item.catalog_item_id) {
                findExistingItem = OrderEntryService.findExistingItemById(
                    this.state.order!,
                    this.props.supplierModel,
                    item.item.catalog_item_id
                );
            } else if (item.item.catalog_item_guid) {
                findExistingItem = OrderEntryService.findExistingItemByGuid(
                    this.state.order!,
                    this.props.supplierModel,
                    item.item.catalog_item_guid
                );
            } else {
                throw new Error("No catalog item id or guid found");
            }

            if (!findExistingItem.hasExistingItem) {
                const nextItemNo = this.getNextItemNo();
                item.item.item_no = nextItemNo;

                // const uomSet = item.item.uomSet;
                // const orderItem = this.processStandardItem(item.item, { itemNo: nextItemNo, uomSet });
                bulkAddItems.push(item);

                ++currentItemNo;
            } else {
                // rethink this...
                // this.updateExistingItemQty(existingItem!, item.item);
                // bulkUpdateItems.push(item);
            }
        }

        const payload: IProcessOrderEntryItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            addItems: bulkAddItems,
            updateItems: bulkUpdateItems,
            orderGuid: order.guid,
        };

        if (!this.props.userModel?.isSupplierUser || this.state.order!.supplier_id !== this.props.supplierModel.id) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit(EndpointsEnum.OrderEntryProcessOrderEntryItems, payload);

        const state = {
            currentItemNo,
        };

        this.setState(state, () => {
            this.props.setActivityIndicator(true);
        });
    };

    onCreateOrderEntryItems = (data: IOnCreateOrderEntryItemsDTO) => {
        this.getOrder("onCreateOrderEntryItems", "order_entry");

        const notification: INotification = {
            title: "successfully_created_order_entry_items",
            autoDismiss: 3,
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.props.setActivityIndicator(false);
    };

    onProcessOrderEntryItems = (data: IOnProcessOrderEntryItemsDTO) => {
        this.getOrder("onProcessOrderEntryItems", "order_entry");

        const notification: INotification = {
            title: "successfully_processed_order_entry_items",
            autoDismiss: 3,
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.props.setActivityIndicator(false);

        // This occurs if the show submit modal is triggered and the temp order entry detail items are set.
        if (this.state.showModalSubmit && this.state.tempSubmitOrderPayload) {
            this.performInventoryCheck(this.state.tempSubmitOrderPayload);
        }
    };

    showCommonItemsModal = () => {
        if (
            this.props.supplierModel.show_common_items_modal &&
            !this.state.order!.Order_Items.length &&
            this.state.showCommonItemsModal &&
            !this.state.modalIsOpen
        ) {
            if (!this.state.order || !this.state.order.Catalog) {
                return null;
            }

            const modalComponent = (
                <CommonItemsModal
                    socket={this.props.socket}
                    catalogGuid={this.state.order.Catalog.guid}
                    addItemsFn={this.addBulkItems}
                    closeFn={this.closeModal}
                />
            );

            this.setState({
                modalComponent,
                modalIsOpen: true,
                showCommonItemsModal: false,
                hasShownCommonItemsModal: true,
            });
        }
    };

    pendingChangesFn = (hasPendingDetailChanges: boolean) => {
        this.setState({
            hasPendingDetailChanges,
        });
    };

    pendingFineDetailChangesFn = (hasPendingFineDetailChanges: boolean) => {
        this.setState({
            hasPendingFineDetailChanges,
        });
    };

    getOrderDetailsPanel = () => {
        if (this.state.order && this.state.order.details && this.props.socket && !this.state.isInitialData) {
            return (
                <OrderEntryDetailsPanel
                    socket={this.props.socket}
                    order={this.state.order}
                    updateOrderEntryDetail={this.updateOrderEntryDetail}
                    updateOrderEntryFineDetails={this.updateOrderEntryFineDetail}
                    setTempUpdateOrderFineDetails={this.setTempUpdateOrderFineDetails}
                    addBulkItems={this.addBulkItems}
                    priceGroups={this.state.priceGroups}
                    supplierModel={this.props.supplierModel}
                    userModel={this.props.userModel}
                    vendorModel={this.props.vendorModel}
                    pendingChangesFn={this.pendingChangesFn}
                    isReadOnly={this.isReadOnly("DETAILS_PANEL")}
                    notifyFn={this.props.notifyFn}
                    setSidebarComponent={this.props.setSidebarComponent}
                    toggleSidebar={this.props.toggleSidebar}
                    processCustomSchedule={this.setTempCustomSchedule}
                    history={this.props.history}
                    location={this.props.location}
                    match={this.props.match}
                    getOrder={() => {
                        this.getOrder("getOrderDetailsPanel", "order_entry");
                    }}
                    relatedOrders={this.state.relatedOrders}
                />
            );
        } else {
            return null;
        }
    };

    getOrderInputPanel = () => {
        if (this.state.order) {
            return (
                <OrderInputPanel
                    order={this.state.order!}
                    addBulkItemsFn={this.addBulkItems}
                    addOrderEntryItemFn={this.addOrderEntryItem}
                    getNextItemNoFn={this.getNextItemNo}
                    processStandardItemFn={this.processStandardItem}
                    showCustom={this.state.showCustom}
                    isReadOnly={this.isReadOnly()}
                    searchPhrase={this.state.currentScanCode}
                    clearScanCodeFn={() => {}}
                />
            );
        } else {
            return null;
        }
    };

    isReadOnly = (section?: "DETAILS_PANEL"): boolean => {
        const readOnly = OrdersService.isReadOnly({
            order: this.state.order!,
            isOfflineOrder: this.state.isOfflineOrder,
            hasEditMode: this.state.hasEditMode,
            supplierModel: this.props.supplierModel,
            userModel: this.props.userModel,
            section,
        });

        return readOnly;
    };

    stickyChangedState = (e: any) => {
        // console.log("stickyChangedState: ", e);
    };

    renderOrderTotalProfitAndMargin = (profitClassName: string, profit: number, profitMargin: number) => {
        if (this.props.userModel?.isSupplierUser) {
            if (!this.props.supplierModel.has_cost_pricing) {
                return null;
            }

            if (
                this.props.userModel.supplierUserToken?.user_type_id !== UserTypesEnum.ADMIN &&
                this.props.supplierModel.cost_pricing_admin_only
            ) {
                return null;
            }

            return (
                <div className={"me-5"}>
                    <div>
                        <OwLabel title={"profit"} noBottomMargin={true} className={"me-2"} />
                        <span className={profitClassName}>
                            <FormattedNumber value={profit} maximumFractionDigits={2} minimumFractionDigits={2} />
                        </span>
                        <OwLabel title={"avg_profit_margin"} noBottomMargin={true} className={"ms-5 me-2"} />
                        <span className={profitClassName}>
                            <FormattedNumber value={profitMargin} maximumFractionDigits={2} minimumFractionDigits={2} />%
                        </span>
                    </div>
                </div>
            );
        }

        return null;
    };

    getProfitAndMargin = (): { profit: number; profitMargin: number; profitClassName: string } => {
        return OrderEntryService.getProfitAndMargin(this.state.order!, this.props.userModel);
    };

    resetItemToCatalogDefault = (row: IOrder_ItemUI) => {
        // reset the given item index to its catalog default price value.
        row.is_manual_price = false;
        const priceGroup = this.state.order!.Price_Group;

        // @ts-expect-error
        row.list_price_frozen = row.Catalog_Item!.pricing[priceGroup.value];
        // should the cost price be set if the order isn't preliminary?
        row.isDirty = true;

        this.updateOrderEntryItem(row, { shouldAutoSave: true });
    };

    checkRowForPurchaseOrder = (orderItemGuid: string, isChecked: boolean, qty: number, vendorSourceId?: number) => {
        const purchaseOrderRows = this.state.purchaseOrderRows || [];

        let found = false;

        for (const row of purchaseOrderRows) {
            if (row.orderItemGuid === orderItemGuid) {
                row.isChecked = isChecked;
                row.qty = qty;
                row.vendorSourceId = vendorSourceId;
                found = true;
            }
        }

        if (!found) {
            purchaseOrderRows.push({ qty, isChecked, orderItemGuid, minQty: 0, vendorSourceId });
        }

        this.setState({
            purchaseOrderRows,
        });
    };

    checkRowForRma = (orderItemGuid: string, isChecked: boolean, qty: number) => {
        const rmaRows = this.state.rmaRows || [];

        let found = false;

        for (const row of rmaRows) {
            if (row.orderItemGuid === orderItemGuid) {
                row.isChecked = isChecked;
                row.qty = qty;
                found = true;
            }
        }

        if (!found) {
            // Find the order item to get the order_line_item_id, catalog_item_id, and maxQty
            const orderItem = this.state.order?.Order_Items?.find((item) => item.guid === orderItemGuid);
            if (orderItem) {
                rmaRows.push({
                    qty,
                    isChecked,
                    orderItemGuid,
                    order_line_item_id: orderItem.id,
                    catalog_item_id: orderItem.catalog_item_id,
                    maxQty: orderItem.qty_ordered || 0,
                });
            }
        }

        this.setState({
            rmaRows,
        });
    };

    checkRowForAcknowledge = (orderItemGuid: string, isChecked: boolean, qty: number) => {
        const ackRows = this.state.acknowledgeRows || [];

        let found = false;

        for (const row of ackRows) {
            if (row.orderItemGuid === orderItemGuid) {
                row.isChecked = isChecked;
                row.qty = qty;
                found = true;
            }
        }

        if (!found) {
            ackRows.push({ qty, isChecked, orderItemGuid });
        }

        this.setState({
            acknowledgeRows: ackRows,
        });
    };

    checkRowForBackorder = (orderItemGuid: string, isChecked: boolean, qty: number) => {
        const backOrderRows = this.state.backOrderRows || [];

        let found = false;

        for (const row of backOrderRows) {
            if (row.orderItemGuid === orderItemGuid) {
                row.isChecked = isChecked;
                row.qty = qty;
                found = true;
            }
        }

        if (!found) {
            backOrderRows.push({ qty, isChecked, orderItemGuid });
        }

        this.setState({
            backOrderRows,
        });
    };

    hasOneAcknowledgeRowChecked = (): boolean => {
        const ackRows = this.state.acknowledgeRows;

        let hasOneRowChecked = false;

        for (const row of ackRows) {
            if (row.isChecked) {
                hasOneRowChecked = true;
            }
        }

        return hasOneRowChecked;
    };

    hasOneBackorderRowChecked = (): boolean => {
        const backOrderRows = this.state.backOrderRows;

        let hasOneRowChecked = false;

        for (const row of backOrderRows) {
            if (row.isChecked) {
                hasOneRowChecked = true;
            }
        }

        return hasOneRowChecked;
    };

    hasOnePurchaseOrderRowChecked = (): boolean => {
        const purchaseOrderRows = this.state.purchaseOrderRows;

        let hasOneRowChecked = false;

        for (const row of purchaseOrderRows) {
            if (row.isChecked) {
                hasOneRowChecked = true;
            }
        }

        return hasOneRowChecked;
    };

    addChildItems = (items: IAddBulkItems[], parentOrderItemId: number) => {
        if (this.state.order) {
            // const addItems = items.map((item) => {
            //     return {
            //         qty: item.qty,
            //         item_no: 1,
            //         parent_order_item_id: parentOrderItemId,
            //         catalog_item_id: item.catalog_item_id,
            //         uom_set_id: item.uom_set_id,
            //     } as IAddBulkItems;
            // });
            const payload: IProcessOrderEntryItemsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.state.order.Vendor!.guid,
                isChildItems: true,
                addItems: items,
                updateItems: [],
                orderGuid: this.state.order.guid,
                parentOrderItemId,
            };
            this.props.socket.emit(EndpointsEnum.OrderEntryProcessOrderEntryItems, payload);
        }
    };

    viewChildItems = (row: IOrder_ItemUI, index: number) => {
        if (this.state.order) {
            const sidebarComponent = (
                <CatalogViewerSidebar
                    cancel={this.cancel}
                    label={"child_items"}
                    addToOrder={(items) => {
                        // const newItems = items.map((details) => {
                        //     return {
                        //         item: details.item,
                        //         Catalog_Item: details.item.Catalog_Item,
                        //         catalog_item_id: details.item.catalog_item_id,
                        //         item_no: details.item.item_no,
                        //         qty: details.item.qty,
                        //     };
                        // });
                        this.addChildItems(items, row.id);
                    }}
                    order={this.state.order}
                    isOnline={this.state.isOnline}
                    isOfflineOrder={this.state.isOfflineOrder}
                    isChildItemsOnly={true}
                    parentCatalogItemId={row.Catalog_Item!.id}
                    warehouses={this.state.warehouses}
                />
            );

            this.props.setSidebarComponent(sidebarComponent);
            this.props.toggleSidebar(true);
        }
    };

    /**
     *
     *
     * @param row
     * @param index
     */
    renderActionsCol = (row: IOrder_ItemUI, index: number) => {
        if (row.guid) {
            row.isSaved = true;
        }

        if (row.isDirty) {
            row.isSaved = false;
        }

        if (row.is_catch_weight_item) {
            if (!this.props.userModel.isSupplierUser) {
                return null;
            }
        }

        return (
            <div className={"d-flex align-items-center"}>
                {this.state.currentView === OrderEntryViewStateOptionsEnum.RMA ||
                this.state.currentView === OrderEntryViewStateOptionsEnum.PURCHASE_ORDER ? null : (
                    <OrderActionColumn
                        data={row}
                        index={index}
                        isManualPrice={row.is_manual_price || false}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        toggleResetItemToCatalogDefaultFn={this.resetItemToCatalogDefault}
                        toggleRowDetailViewFn={() => {}}
                        toggleRowEditModeFn={this.updateOrderEntryItem}
                        toggleConfirmDeleteFn={this.toggleConfirmDelete}
                        rowRef={React.createRef()}
                        isReadOnly={this.isReadOnly()}
                        order={this.state.order}
                        isBackorderView={this.state.currentView === OrderEntryViewStateOptionsEnum.BACKORDER}
                        checkRowForBackorder={this.checkRowForBackorder}
                        isAcknowledgeView={this.state.currentView === OrderEntryViewStateOptionsEnum.ACKNOWLEDGE}
                        acknowledgeRows={this.state.acknowledgeRows}
                        checkRowForAcknowledge={this.checkRowForAcknowledge}
                        viewChildItems={this.viewChildItems}
                    />
                )}
                {this.state.currentView === OrderEntryViewStateOptionsEnum.PURCHASE_ORDER ? (
                    <OrderActionColVendorSource
                        data={row}
                        purchaseOrderRows={this.state.purchaseOrderRows}
                        checkRowForPurchaseOrder={this.checkRowForPurchaseOrder}
                        vendorSourcesForCatalogItems={this.state.vendorSourcesForCatalogItems}
                    />
                ) : null}
                {this.state.currentView === OrderEntryViewStateOptionsEnum.RMA ? (
                    <OrderActionColRma data={row} rmaRows={this.state.rmaRows} checkRowForRma={this.checkRowForRma} />
                ) : null}
                <div>
                    {row.awaiting_price_approval && this.props.userModel.isSupplierUser ? (
                        <OwLabel className={"ms-3 text-danger text-small"} title={"awaiting_price_approval"} />
                    ) : null}
                </div>
            </div>
        );
    };

    /**
     * Get the Price for the Order Item based on if it's the stored, manual or catalog item price
     *
     * @param orderItem
     */
    getPricingValue = (orderItem: IOrder_ItemUI): number => {
        // console.log("order: ", this.state.order);
        return OrderEntryService.getPricingValue(orderItem, this.props.supplierModel, this.state.order);
    };

    handlePricePerUnitChange = (e: any, row: IOrder_ItemUI) => {
        const value = Number(e.target.value);

        const order = this.state.order!;

        const orderItems = order.Order_Items;

        for (const item of orderItems) {
            if (item.guid === row.guid) {
                item.cost_price_frozen = value;
                item.list_price_frozen = value;
                item.isDirty = true;
                item.is_manual_price = true;
            }
        }

        order.Order_Items = orderItems;

        this.setState({
            order,
        });
    };

    /**
     * Render the Price Per Unit
     *
     * @param row
     */
    renderPricePerUnit = (row: IOrder_ItemUI) => {
        if (row.is_catch_weight_item) {
            return null;
        }

        let edit: any;
        let display: any;

        let value: any = 1;

        // console.log("Cost Price Frozen:", row.cost_price_frozen);

        if (this.state.isOfflineOrder) {
            value = this.getPricingValue(row);
        } else {
            value = row.cost_price_frozen;
        }

        if (row.Kit_Items && row.Catalog_Item!.kit_add_each_item) {
            let kitItemValue = 0;

            for (const kitItem of row.Kit_Items) {
                kitItemValue += Number(this.getPricingValue(kitItem as IOrder_ItemUI));
            }

            value = kitItemValue;
        }

        if (this.props.supplierModel.allow_manual_pricing) {
            edit = (
                <OwFnInput
                    fn={(e: any) => {
                        this.handlePricePerUnitChange(e, row);
                    }}
                    type={"number"}
                    name={"cost_price_frozen"}
                    value={value}
                    enableDebounce={false}
                    onWheelFn={UIService.stopScrollWheel}
                    selectOnFocus={true}
                />
            );
            // edit = (
            //     <OwInputWrapper
            //         type={"text"}
            //         name={"cost_price_frozen"}
            //         value={value}
            //         step={this.props.supplierModel.qty_precision}
            //         enableDebounce={true}
            //         fn={(e: any) => {
            //             this.handlePricePerUnitChange(e, row);
            //         }}
            //     />
            // );
        }

        if (
            row.rowEditMode &&
            this.props.supplierModel.allow_manual_pricing &&
            this.props.userModel?.isSupplierUser &&
            (this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN ||
                this.props.supplierModel.allow_non_admin_manual_pricing)
        ) {
            return edit;
        } else {
            let prefix = "$";

            if (this.state.doCurrencyConversion) {
                let currency = this.state.order?.Catalog?.Currency ? this.state.order.Catalog.Currency : undefined;

                if (this.state.order?.Currency) {
                    currency = this.state.order.Currency;
                }

                prefix = currency ? OrderEntryService.getCurrencySymbol(currency.name) : "$";

                if (!row.is_manual_price && currency && this.state.order?.Catalog?.Currency) {
                    value = OrderEntryService.convertCurrency(
                        value,
                        this.state.order?.Catalog?.Currency,
                        currency,
                        this.state.order?.exchange_rate
                    );
                }
            }

            display = (
                <NumericFormat
                    value={value}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={prefix}
                    decimalScale={this.props.supplierModel.pricing_precision || 2}
                    fixedDecimalScale={true}
                />
            );

            return display;
        }
    };

    renderUomBaseQtyCol = (row: IOrder_ItemUI, index: number) => {
        if (row.uom_set_id) {
            if (row.rowEditMode) {
                return (
                    <div className={"w-7r"}>
                        <OwFnInput
                            fn={(e: ChangeEvent<any>) => {
                                this.rowUpdate(e, row, index, "qty");

                                const _e: any = {
                                    target: {
                                        value: true,
                                    },
                                };

                                this.rowUpdate(_e, row, index, "is_manual_base_qty");
                            }}
                            name={"qty"}
                            value={row.qty}
                        />
                    </div>
                );
            } else {
                return row.qty;
            }
        } else {
            return row.qty;
        }
    };

    renderNameCol = (row: IOrder_ItemUI) => {
        const edit: any = null;
        let display: any;

        const allowEditable = false;

        const value = row.Catalog_Item?.name;

        if (row.Kit_Items) {
            return (
                <React.Fragment>
                    {value}{" "}
                    <div className={"mt-3"}>
                        <KitItemsDisplay orderItem={row} />
                        {/*<div>*/}
                        {/*    <OwLabel title={"kit_items"} postText={":"} isBold={true} />*/}
                        {/*</div>*/}
                        {/*{row.Kit_Items.map((kitItem) => {*/}
                        {/*    return (*/}
                        {/*        <div className={"mb-2 " + (kitItem.parent_order_item_id !== row.id ? "ms-4" : "")}>*/}
                        {/*            [{kitItem.qty}] {kitItem.Catalog_Item!.name}*/}
                        {/*        </div>*/}
                        {/*    );*/}
                        {/*})}*/}
                    </div>
                </React.Fragment>
            );
        } else {
            let alertIcon = false;
            let alertTitle: any;

            if (
                !row.Catalog_Item?.qbd_ListID?.length &&
                this.props.supplierModel.Supplier_Integration.has_qbd &&
                this.props.userModel.isSupplierUser
            ) {
                alertIcon = true;
                alertTitle = "Not Connected To QuickBooks Desktop";
            }

            display = (
                <div>
                    {value}
                    {alertIcon ? (
                        <span className={"d-inline-flex align-items-center justify-content-center"}>
                            <i className={"fas fa-exclamation-triangle text-warning ms-2"} title={alertTitle}></i>
                            <img alt={"QuickBooks Desktop"} src={quickBooksIcon} height={16} title={alertTitle} />
                        </span>
                    ) : null}
                </div>
            );

            return display;
        }
    };

    updateRowUom = (row: IOrder_ItemUI, set: IUnit_Of_Measurement_Set) => {
        const order = this.state.order!;

        const orderItems = order.Order_Items;

        for (const item of orderItems) {
            if (item.guid === row.guid && row.uom_set_id !== set.id) {
                // const qtyDetail = OrderService.doInventoryValidation(
                //     row.Catalog_Item,
                //     row.qty,
                //     order.Order_Items,
                //     this.props.supplierModel,
                //     order,
                //     set
                // );

                // This is causing issues where it changes the qty to the uom_set_qty of 0
                item.qty = 1;

                if (set) {
                    item.Selected_Unit = set;
                    item.uom_set_qty = 1;
                    item.uom_set_id = set.id;
                }

                item.isDirty = true;
            }
        }

        order.Order_Items = orderItems;

        this.setState({
            order,
        });
    };

    renderUomCol = (row: IOrder_ItemUI) => {
        if (row.uom_set_id) {
            if (row.rowEditMode && row.Catalog_Item) {
                return (
                    <div className={"w-7r"}>
                        <UomSetSelectOption
                            item={row.Catalog_Item}
                            selectedOption={(set) => {
                                this.updateRowUom(row, set);
                            }}
                            currentOption={row.Selected_Unit}
                        />
                    </div>
                );
            } else {
                return row.Selected_Unit?.unit_abbr;
            }
        } else {
            return row.Catalog_Item?.Unit_Of_Measurement?.abbreviation;
        }
    };

    renderShortDescCol = (row: IOrder_ItemUI) => {
        return row.Catalog_Item?.short_description;
    };

    renderDescCol = (row: IOrder_ItemUI) => {
        let edit: any;
        let display: any;

        let allowEditable = false;

        if (row.is_catch_weight_item) {
            if (!this.props.userModel.isSupplierUser) {
                return null;
            }
        }

        if (this.props.userModel.isSupplierUser) {
            if (this.state.order?.Catalog?.order_row_config) {
                for (const rowConfigCol of this.state.order!.Catalog!.order_row_config) {
                    if (rowConfigCol.property === "description" && rowConfigCol.isSupplierUserEditable) {
                        allowEditable = true;
                    }
                }
            }
        }

        const value = row.Catalog_Item ? (
            <DescriptionExpander catalogItem={row.Catalog_Item} priceGroup={this.state.order?.Price_Group} orderItem={row} />
        ) : (
            ""
        );

        let equalDescriptions = false;

        if (row.Catalog_Item?.short_description?.trim() === row.Catalog_Item?.description?.trim()) {
            equalDescriptions = true;
        }

        if (allowEditable) {
            let editValue = row.Catalog_Item
                ? CatalogItemService.getCatalogItemDescription(this.props.supplierModel, row.Catalog_Item, this.state.order?.Price_Group)
                : "";

            if (row.description) {
                editValue = row.description;
            }

            edit = (
                <OwTextArea
                    className={"w-25r"}
                    name={"description"}
                    value={editValue}
                    fn={(e: any) => {
                        this.handleRowDescription(e, row);
                    }}
                />
            );
        }

        if (row.rowEditMode && allowEditable) {
            return edit;
        } else {
            display = value;

            if (row.Catalog_Item?.short_description && !equalDescriptions) {
                display = (
                    <div>
                        <div className={"mb-2"}>{row.Catalog_Item?.short_description}</div>
                        <div>{value}</div>
                    </div>
                );
            }

            return display;
        }
    };

    /**
     * Render the List Price Column
     *
     * @param row
     * @param index
     */
    renderListPrice = (row: IOrder_ItemUI, index: number) => {
        if (row.is_catch_weight_item) {
            return null;
        }

        const pricingValue = OrderEntryService.getListPrice(row, this.state.order!, this.props.supplierModel);

        const prefix = "$";

        const display = (
            <NumericFormat
                value={pricingValue}
                displayType={"text"}
                thousandSeparator={true}
                prefix={prefix}
                decimalScale={this.props.supplierModel.pricing_precision || 2}
                fixedDecimalScale={true}
            />
        );

        if (row.rowEditMode) {
            if (
                this.props.userModel?.isSupplierUser &&
                (this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN ||
                    this.props.supplierModel.allow_non_admin_manual_pricing) &&
                this.props.supplierModel.allow_manual_pricing
            ) {
                return (
                    <div>
                        <OwFnInput
                            name={"list_price_frozen"}
                            value={pricingValue}
                            type={"number"}
                            fn={(e: any) => {
                                this.rowUpdate(e, row, index, "list_price_frozen");
                            }}
                            enableDebounce={true}
                            onWheelFn={UIService.stopScrollWheel}
                        />
                        {row.Catalog_Item?.min_price && this.props.supplierModel.below_min_price_approval ? (
                            <div>
                                <OwLabel title={"min_price_without_approval"} postText={":"} />
                                <NumericFormat
                                    value={row.Catalog_Item?.min_price || 0}
                                    prefix={"$"}
                                    displayType={"text"}
                                    fixedDecimalScale={true}
                                    decimalScale={this.props.supplierModel.pricing_precision || 2}
                                />
                            </div>
                        ) : null}
                    </div>
                );
            } else {
                return display;
            }
        } else {
            return display;
        }
    };

    /**
     * Provided the given price, will discount using the Vendors Set Discount Amount.
     * @param price
     */
    getDiscountedPrice = (price: number, catalogItem?: ICatalog_Item): number => {
        return OrderEntryService.getDiscountedPrice(price, this.state.order!, this.props.supplierModel, catalogItem);
    };

    /**
     * Render the Catalog Item Cost Price
     *
     * This is the cost price per uom of the catalog item.
     *
     * @param row - the order item
     * @returns the display value for the catalog item cost price
     */
    renderCatalogItemCostPrice = (row: IOrder_ItemUI) => {
        const pricingValue = row.Catalog_Item?.cost_per_uom || 0;

        // TODO - do we need to update this if there is uom sets?

        const prefix = "$";

        const display = (
            <NumericFormat
                value={pricingValue}
                displayType={"text"}
                thousandSeparator={true}
                prefix={prefix}
                decimalScale={this.props.supplierModel.pricing_precision || 2}
                fixedDecimalScale={true}
            />
        );

        return display;
    };

    /**
     * Renders The Cost Price Value
     *
     * @param row
     * @param index
     */
    renderCostPrice = (row: IOrder_ItemUI, index: number) => {
        let pricingValue = 0;

        if (this.state.isOfflineOrder) {
            pricingValue = OrderEntryService.getCostPrice(row, this.state.order!, this.props.supplierModel);
        } else {
            pricingValue = row.cost_price_frozen || 0;
        }

        const prefix = "$";

        const display = (
            <NumericFormat
                value={pricingValue}
                displayType={"text"}
                thousandSeparator={true}
                prefix={prefix}
                decimalScale={this.props.supplierModel.pricing_precision || 2}
                fixedDecimalScale={true}
            />
        );

        return display;
    };

    getPriceGroupPriceDiscount = (orderItem: IOrder_ItemUI | IOrder_Item): number => {
        return OrderEntryService.getPriceGroupPriceDiscount(orderItem, this.props.supplierModel, this.state.order!);
    };

    /**
     * Calculate the Row Total Value
     *
     * @param orderItem
     */
    // @ts-expect-error
    calculateRowTotal = (orderItem: IOrder_ItemUI, returnValue?: boolean): Partial<NumericFormat<string>> | number => {
        let rowTotalPrice = OrderEntryService.calculateRowTotal(this.state.order!, orderItem, this.props.supplierModel);

        let prefix = "$";

        if (this.state.doCurrencyConversion) {
            let currency = this.state.order?.Catalog?.Currency ? this.state.order.Catalog.Currency : undefined;

            if (this.state.order?.Currency) {
                currency = this.state.order.Currency;
            }

            prefix = currency ? OrderEntryService.getCurrencySymbol(currency.name) : "$";

            if (!orderItem.is_manual_price && currency && this.state.order?.Catalog?.Currency) {
                rowTotalPrice = OrderEntryService.convertCurrency(
                    rowTotalPrice,
                    this.state.order?.Catalog?.Currency,
                    currency,
                    this.state.order?.exchange_rate
                );
            }
        }

        if (returnValue) {
            return rowTotalPrice;
        } else {
            let pricingFormulaTooltip: any = "";

            if (orderItem.Catalog_Item?.Pricing_Formula) {
                let expressionTemplate = orderItem.Catalog_Item?.Pricing_Formula?.expression_template;

                if (this.props.supplierModel.length_for_depth) {
                    expressionTemplate = expressionTemplate.replace("depth", "length");
                }

                pricingFormulaTooltip = <div>{expressionTemplate}</div>;
            }

            return (
                <div className={"text-end"}>
                    {orderItem.Catalog_Item?.pricing_formula_id && (
                        <OwIconTooltip iconClassName="fas fa-info-circle text-muted me-2" tooltipContent={pricingFormulaTooltip} />
                    )}
                    <NumericFormat
                        className={"text-end p-0"}
                        value={rowTotalPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={prefix}
                        decimalScale={this.props.supplierModel.pricing_precision || 2}
                        fixedDecimalScale={true}
                    />
                    {this.state.order?.Vendor?.sales_tax_id && this.props.userModel.isSupplierUser && this.state.showRowDetailInfo ? (
                        <div className={"text-small text-muted"}>{orderItem.Catalog_Item?.is_taxable ? "Taxable" : "Not Taxable"}</div>
                    ) : null}
                </div>
            );
        }
    };

    /**
     * Render the Total Column
     *
     * @param row
     */
    renderTotal = (row: IOrder_ItemUI) => {
        if (row.is_catch_weight_item) {
            return null;
        }

        const rowTotal = this.calculateRowTotal(row);

        let profitMarginDetail: any = <></>;
        let taxableDetail = <></>;

        if (this.props.userModel?.isSupplierUser) {
            if (!this.props.supplierModel.has_cost_pricing) {
                profitMarginDetail = null;
            }

            if (
                this.props.userModel.supplierUserToken?.user_type_id !== UserTypesEnum.ADMIN &&
                this.props.supplierModel.cost_pricing_admin_only
            ) {
                profitMarginDetail = null;
            }

            if (profitMarginDetail !== null && this.state.showRowDetailInfo) {
                // let's see if there's a po selected row for this order item, and if so, get the vendor source if set and use that to get the profit margin.
                const poSelectedRow = this.state.purchaseOrderRows?.find((poItem) => poItem.orderItemGuid === row.guid);

                let vendorSource: IVendor_Source | undefined;

                if (poSelectedRow?.vendorSourceId) {
                    for (const _vendorSource of row.Catalog_Item?.Vendor_Sources || []) {
                        if (_vendorSource.id === poSelectedRow.vendorSourceId) {
                            vendorSource = _vendorSource;
                            break;
                        }
                    }
                }

                const { profit, profitMargin, profitClassName } = OrderEntryService.getProfitAndMarginForItem(
                    this.state.order!,
                    row,
                    vendorSource
                );

                profitMarginDetail = (
                    <div className={"d-flex flex-column text-small no-wrap"}>
                        <div className={"d-flex w-100"}>
                            <OwLabel title={"profit"} noBottomMargin={true} className={"me-2 text-end flex-grow"} />
                            <div className={profitClassName + " w-4r"}>
                                <FormattedNumber value={profit} maximumFractionDigits={2} minimumFractionDigits={2} />
                            </div>
                        </div>
                        <div className={"d-flex w-100"}>
                            <OwLabel title={"profit_margin"} noBottomMargin={true} className={"me-2 text-end flex-grow"} />
                            <div className={profitClassName + " w-4r"}>
                                <FormattedNumber value={profitMargin} maximumFractionDigits={2} minimumFractionDigits={2} />%
                            </div>
                        </div>
                    </div>
                );
            }

            if (this.state.showRowDetailInfo) {
                taxableDetail = <div className={"text-small text-muted"}>{row.Catalog_Item?.is_taxable ? "Taxable" : null}</div>;
            }
        }

        return (
            <>
                {rowTotal}
                {profitMarginDetail}
                {taxableDetail}
            </>
        );
    };

    /**
     * Handle the Description Change by a User
     *
     * @param e
     * @param row
     */
    handleRowDescription = (e: ChangeEvent<any>, row: IOrder_ItemUI) => {
        e.stopPropagation();
        e.preventDefault();

        const value = e.target.value;

        const order = this.state.order!;

        const orderItems = [...order.Order_Items];

        for (const item of orderItems) {
            if (item.guid === row.guid) {
                item.description = value;
                item.isDirty = true;
            }
        }

        order.Order_Items = orderItems;

        this.updateOrder(order);
    };

    updateOrder = (order: IOrderUI) => {
        this.setState({
            order,
        });
    };

    /**
     * Render The Qty Column
     */
    renderQtyFn = (row: IOrder_ItemUI, index: number) => {
        let availableQoh = Number(row.Catalog_Item?.qty_on_hand);

        if (row.Catalog_Item?.Material_Catalog_Item_Maps?.length) {
            availableQoh = CatalogItemService.getItemQtyOnHandBasedOnMaterials(row.Catalog_Item);
        }

        if (this.state.isOfflineOrder) {
            if (this.state.offlineReconciledItems.length) {
                for (const offlineReconciledItem of this.state.offlineReconciledItems) {
                    if (offlineReconciledItem.catalog_item_id === row.catalog_item_id) {
                        availableQoh = Number(offlineReconciledItem.qty_on_hand);
                    }
                }
            }
        }

        if (row.rowEditMode) {
            return <LineItemQtyEdit row={row} order={this.state.order!} updateOrderFn={this.updateOrder} />;
        } else {
            let detail = (
                <div>
                    <div className="mb-2">
                        <QtyDetail item={row} />
                    </div>
                    {row.is_backordered ? (
                        <div className={"mt-3 text-small"}>
                            <div className={"backordered-badge border border-danger rounded"}>
                                <OwLabel title={"backordered"} className={"bg-danger"} />
                                <span className={"ms-2 me-2"}>+{row.qty_backordered}</span>
                            </div>
                        </div>
                    ) : null}
                    {this.state.showRowDetailInfo ? <LineItemQtyInventoryDetail row={row} /> : null}
                    {this.state.showRowDetailInfo ? <LineItemQtyFulfillmentDetail row={row} /> : null}
                    {this.state.showRowDetailInfo ? <LineItemQtyDeliveryEtaDetail row={row} /> : null}
                    {this.state.showRowDetailInfo && row.Catalog_Item?.has_pack_qty ? (
                        <PackQtyReverseViewer orderItem={row} catalogItem={row.Catalog_Item} />
                    ) : null}
                    {row.Catalog_Item?.is_ordered_on_demand ? (
                        <div className="no-wrap">
                            <OwPill title={"ordered_on_demand"} className={"text-small"} />
                        </div>
                    ) : null}
                    {row.qty_returned && row.qty_returned > 0 ? (
                        <div className="mt-2 bg-success text-small text-white px-2 rounded">
                            <OwLabel className="me-2" title="qty_returned" postText=":" />
                            {row.qty_returned}
                        </div>
                    ) : null}
                </div>
            );

            if (this.state.orderItemIssues.length) {
                let rowHasInsufficientInventory = false;
                let maxQty = 0;

                const rowElem = document.getElementById(`row-${index}`);

                for (const orderItem of this.state.orderItemIssues) {
                    if (orderItem.catalogItem.id === row.Catalog_Item?.id) {
                        rowHasInsufficientInventory = true;
                        maxQty = orderItem.qtyOnHand;
                    }
                }

                if (rowHasInsufficientInventory) {
                    const isBackorderLimitItem = this.state.backorderLimitItems.some(
                        (bli) => bli.sku === row.Catalog_Item?.sku || bli.sku === row.sku
                    );
                    const labelKey = isBackorderLimitItem ? "max_order_qty" : "max_qty_on_hand";

                    detail = (
                        <div className={"d-flex flex-column"}>
                            <div>{detail}</div>
                            <div>
                                <OwLabel title={labelKey} className={"text-small text-warning me-2"} noBottomMargin={true} postText={":"} />
                                {maxQty}
                            </div>
                        </div>
                    );

                    if (rowElem) {
                        rowElem.classList.add("insufficient-inventory");
                    }
                } else {
                    if (rowElem) {
                        rowElem.classList.remove("insufficient-inventory");
                    }
                }
            }

            return detail;
        }
    };

    renderQtyShippedFn = (row: IOrder_ItemUI, index: number) => {
        const detail = (
            <div>
                <FormattedNumber value={Number(row.qty_shipped || 0)} minimumFractionDigits={this.props.supplierModel.qty_precision} />
            </div>
        );

        if (row.rowEditMode) {
            return <div>{detail}</div>;
        } else {
            return detail;
        }
    };

    renderMsrpCol = (row: IOrder_ItemUI, index: number) => {
        const prefix = "$";

        // if (this.state.doCurrencyConversion) {
        //     let currency = this.state.order?.Catalog?.Currency ? this.state.order.Catalog.Currency : undefined;
        //
        //     if (this.state.order?.Currency) {
        //         currency = this.state.order.Currency;
        //     }
        //
        //     prefix = currency ? OrderService.getCurrencySymbol(currency.name) : "$";
        //
        //     if (!row.is_manual_price && currency && this.state.order?.Catalog?.Currency) {
        //         value = OrderService.convertCurrency(
        //             value,
        //             this.state.order?.Catalog?.Currency,
        //             currency,
        //             this.state.order?.exchange_rate
        //         );
        //     }
        // }

        const value = row.msrp || row.Catalog_Item?.msrp || 0;

        const display = (
            <NumericFormat
                value={value}
                displayType={"text"}
                thousandSeparator={true}
                prefix={prefix}
                decimalScale={this.props.supplierModel.pricing_precision || 2}
                fixedDecimalScale={true}
            />
        );

        return display;
    };

    getAttachmentDownloadLink = (catalogItem: ICatalog_Item) => {
        if (catalogItem && catalogItem.Attachments && catalogItem.file_attachment_one_id) {
            let attachmentItem: IAttachment | null = null;

            for (const attachment of catalogItem.Attachments) {
                if (attachment.id === catalogItem.file_attachment_one_id) {
                    attachmentItem = attachment;
                }
            }

            if (attachmentItem) {
                return (
                    <div className={"d-flex"}>
                        <OwS3DownloadLink
                            attachment={attachmentItem}
                            leftIconName={"fad fa-download"}
                            title={"download"}
                            isReadOnly={true}
                        />
                    </div>
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    };

    getPhotos = (row: IOrder_ItemUI) => {
        let catalogImages: any = null;

        const catalogItem = row.Catalog_Item;

        if (this.state.tableType === TableTypeEnum.PHOTOS && catalogItem && catalogItem.Attachments && catalogItem.Attachments.length) {
            catalogImages = (
                <div>
                    <OwS3ImageViewer
                        catalogItem={catalogItem}
                        isMicroView={true}
                        attachmentIndex={0}
                        imageIndex={IImageSizeEnum.THUMB}
                        className={"me-2 mb-2 mb-md-0"}
                        includeAllImages={true}
                        hideEmptyImage={true}
                        modalIndex={IImageSizeEnum.LARGE}
                    />
                </div>
            );
        }

        return catalogImages;
    };

    getSpecFile = (row: IOrder_ItemUI) => {
        if (this.state.tableType !== TableTypeEnum.SMALL) {
            return row.Catalog_Item ? (
                <FilesDownloadSection catalogItem={row.Catalog_Item} readOnly={true} className={"text-small me-2"} />
            ) : null;
        }
    };

    handleRowNote = (e: any, row: IOrder_ItemUI) => {
        const value = e.target.value;

        const order = this.state.order!;

        const orderItems = order.Order_Items;

        for (const item of orderItems) {
            if (item.guid === row.guid) {
                item.note = value;
                item.isDirty = true;
            }
        }

        order.Order_Items = orderItems;

        this.setState({
            order,
        });
    };

    onProcessSerial = (data: IOrderEntryOnProcessSerialDTO) => {
        const notification: INotification = {
            message: "successfully_processed_serial",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.getOrder("onProcessSerial", "order_entry");
    };

    handleRowSerial = (e: any, row: IOrder_ItemUI) => {
        const value = e.target.value;

        const order = this.state.order!;

        const orderItems = order.Order_Items;

        for (const item of orderItems) {
            if (item.guid === row.guid) {
                item.serial = value;
                item.isDirty = true;
            }
        }

        order.Order_Items = orderItems;

        this.setState({
            order,
        });
    };

    copyItemDescription = (row: IOrder_ItemUI) => {
        const order = this.state.order!;

        const orderItems = order.Order_Items;

        for (const item of orderItems) {
            if (item.guid === row.guid) {
                item.note = row.Catalog_Item!.description;
                item.isDirty = true;
            }
        }

        order.Order_Items = orderItems;

        this.setState({
            order,
        });
    };

    getNotesDetail = (row: IOrder_ItemUI) => {
        if (row.Catalog_Item?.require_addl_input || !!row.note) {
            if (row.rowEditMode) {
                return (
                    <div>
                        <div className={"mb-2"}>
                            <OwButton
                                title={"copy_item_description"}
                                fn={() => {
                                    this.copyItemDescription(row);
                                }}
                            />
                        </div>
                        <div>
                            <OwTextArea
                                name={"note"}
                                value={row.note}
                                fn={(e: any) => {
                                    this.handleRowNote(e, row);
                                }}
                            />
                        </div>
                    </div>
                );
            } else {
                return (
                    <div>
                        <b>
                            <OwLabel title={"note"} />:
                        </b>{" "}
                        {row.note}
                    </div>
                );
            }
        }
    };

    deleteSerial = (orderItem: IOrder_ItemUI, serial: ISerial) => {};

    editSerial = (orderItem: IOrder_ItemUI, serial: ISerial) => {
        const orderItems = this.state.order!.Order_Items;

        for (const item of orderItems) {
            if (item.guid === orderItem.guid) {
                item.Serials = (item.Serials || []) as ISerialUI[];

                for (const serialItem of item.Serials as ISerialUI[]) {
                    if (serialItem.id === serial.id) {
                        serialItem.editMode = !serialItem.editMode;
                    }
                }
            }
        }

        const order = this.state.order!;
        order.Order_Items = orderItems;

        this.setState({
            order,
        });
    };

    getSerialsDetail = (row: IOrder_ItemUI) => {
        if (!row.Catalog_Item?.has_serials) {
            return null;
        }

        return (
            <OrderEntrySerialDetail
                row={row}
                isReadOnly={this.isReadOnly()}
                handleRowSerial={this.handleRowSerial}
                refreshOrder={() => this.getOrder("bulkAssignSerials", "order_entry")}
            />
        );
    };

    renderSkuCol = (row: IOrder_ItemUI) => {
        let showAlertIcon = false;
        let alertTitle: any = null;

        if (
            this.props.supplierModel?.Supplier_Integration?.has_qbd &&
            !row.Catalog_Item?.qbd_ListID &&
            this.props.userModel?.isSupplierUser
        ) {
            showAlertIcon = true;
            alertTitle = "Not Connected To QuickBooks Desktop";
        }

        if (
            this.props.supplierModel?.Supplier_Integration?.has_qbo &&
            !row.Catalog_Item?.qbo_item_id &&
            this.props.userModel?.isSupplierUser
        ) {
            showAlertIcon = true;
            alertTitle = "Not Connected To QuickBooks Online";
        }

        return (
            <div>
                <div>
                    {row.Catalog_Item?.sku}
                    {showAlertIcon ? (
                        <span className={"d-inline-flex align-items-center justify-content-center"}>
                            <i className={"fas fa-exclamation-triangle text-warning ms-2"} title={alertTitle}></i>
                            <img src={quickBooksIcon} height={16} title={alertTitle} />
                        </span>
                    ) : null}
                    {row.Catalog_Item?.deleted_at ? (
                        <div>
                            <OwLabel
                                leftIconClass={"fas fa-exclamation-triangle text-warning"}
                                className={"text-small"}
                                title={"discontinued"}
                            />
                        </div>
                    ) : null}
                    {this.props.showHiddenFeatures && (
                        <div>
                            <OrderEntryLineItemAdminActions catalogModel={this.state.order!.Catalog!} item={row} />
                        </div>
                    )}
                </div>
            </div>
        );
    };

    handleRowPriceGroupChange = (priceGroupId: number, row: IOrder_ItemUI) => {
        const order = this.state.order!;

        const orderItems = order.Order_Items;

        for (const item of orderItems) {
            if (item.guid === row.guid) {
                item.price_group_id = priceGroupId;

                item.isDirty = true;
            }
        }

        order.Order_Items = orderItems;

        this.updateOrder(order);
    };

    renderItemPriceGroupCol = (row: IOrder_ItemUI) => {
        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        if (row.is_catch_weight_item) {
            return null;
        }

        if (row.rowEditMode) {
            return (
                <OrderItemPriceGroupSelect
                    priceGroups={this.state.priceGroups || []}
                    updatePriceGroupRowFn={this.handleRowPriceGroupChange}
                    row={row}
                />
            );
        } else {
            return row.Price_Group?.value;
        }
    };

    renderBonusQtyFn = (row: IOrder_ItemUI) => {
        if (this.state.order!.order_state_id === OrderStatesEnum.PRELIMINARY) {
            let bonusPerc = Number(this.state.order!.Vendor!.order_bonus_perc);

            if (bonusPerc > 1) {
                bonusPerc = bonusPerc / 100;
            }

            if (row.Catalog_Item?.exclude_bonus_qty) {
                bonusPerc = 0;
            }

            let bonusQty = Number(row.qty) * bonusPerc;

            bonusQty = Math.round(bonusQty);

            return <FormattedNumber value={bonusQty} />;
        } else {
            const bonusQty = Number(row.bonus_qty_frozen);

            return (
                <div>
                    <FormattedNumber value={bonusQty} minimumFractionDigits={this.props.supplierModel.qty_precision} />
                </div>
            );
        }
    };

    getOptionsDetail = (row: IOrder_ItemUI) => {
        if (row.Order_Item_Options?.length) {
            return (
                <div>
                    <OwLabel title={"options"} isUnderline={true} />
                    {row.Order_Item_Options.map((option) => {
                        return (
                            <div key={option.guid}>
                                <b className={"me-2"}>{option.Item_Option?.name}:</b>
                                {_.startCase(option.value)}
                            </div>
                        );
                    })}
                </div>
            );
        }
    };

    renderDetailView = (row: IOrder_ItemUI) => {
        if (this.rowHasDetailView(row)) {
            return (
                <div className="offset-2">
                    {this.getPhotos(row)}
                    {this.getSpecFile(row)}
                    {this.getNotesDetail(row)}
                    {this.getSerialsDetail(row)}
                    {this.getOptionsDetail(row)}
                    {this.props.showHiddenFeatures ? (
                        <div>
                            <div>
                                <u>Order Item</u>
                            </div>
                            <div className="d-flex align-items-center">
                                Order Item ID: <ClickToCopy text={row.id?.toString() || ""} noFlexGrow={true} className="ms-2" />
                            </div>
                            <div>Order Item Reserved: {row.qty_reserved}</div>
                            <div>Order Item Pending: {row.qty_pending}</div>
                            <div>Order Item Backordered: {row.qty_backordered}</div>
                            <div>Order Item Picked: {row.qty_picked}</div>
                            <div>Order Item Shipped: {row.qty_shipped}</div>
                            <div>Order Item Qty On RMA: {row.qty_on_rma}</div>
                            <div>Order Item Qty Returned: {row.qty_returned}</div>
                            <div className="mt-2">
                                <u>Catalog Item</u>
                            </div>
                            <div className="d-flex align-items-center">
                                Catalog Item ID:{" "}
                                <ClickToCopy text={row.Catalog_Item?.id?.toString() || ""} noFlexGrow={true} className="ms-2" />
                            </div>
                            <div>QoH: {row.Catalog_Item?.qty_on_hand}</div>
                            <div>Reserved: {row.Catalog_Item?.reserved_qty_on_hand}</div>
                            <div>Backordered: {row.Catalog_Item?.qty_backordered}</div>
                            <div>Qty Held: {row.Catalog_Item?.qty_held_for_backorders}</div>
                            <div className="mt-2">Allow Backorder: {row.Catalog_Item?.allow_backorder ? "Yes" : "No"}</div>
                            <div>Max Backorder Limit: {row.Catalog_Item?.backorder_limit}</div>
                        </div>
                    ) : null}
                </div>
            );
        } else {
            return null;
        }
    };

    handleDimensionChange = (e: any, row: IOrder_ItemUI, prop: "width" | "height" | "depth") => {
        const order = this.state.order!;
        const orderItems = order.Order_Items;

        for (const item of orderItems) {
            if (item.guid === row.guid) {
                item[prop] = Number(e.target.value);
                item.isDirty = true;
            }
        }

        order.Order_Items = orderItems;

        this.setState({
            order,
        });
    };

    handleRowDiscount = (e: any, row: IOrder_ItemUI) => {
        const order = this.state.order!;
        const orderItems = order.Order_Items;

        for (const item of orderItems) {
            if (item.guid === row.guid) {
                item.discount = Number(e.target.value);
                item.isDirty = true;
            }
        }

        order.Order_Items = orderItems;

        this.setState({
            order,
        });
    };

    toggleBtn = (activeType: PriceUpchargeTypeEnum, row: IOrder_ItemUI) => {
        // this.setState({
        //     discount_type_id: activeType,
        // });

        const order = this.state.order!;
        const orderItems = order.Order_Items;

        for (const item of orderItems) {
            if (item.guid === row.guid) {
                item.discount_type_id = activeType;
                item.isDirty = true;
            }
        }

        order.Order_Items = orderItems;

        this.setState({
            order,
        });
    };

    renderAddlDiscount = (row: IOrder_ItemUI) => {
        if (row.rowEditMode && this.props.userModel.isSupplierUser) {
            const activeClassName = "active btn-primary btn";

            return (
                <div>
                    <div className={"input-group min-w-6r"}>
                        <OwInputWrapper name={"discount"} fn={(e: any) => this.handleRowDiscount(e, row)} value={row.discount} />
                        <div className={"input-group-append"}>
                            <OwButton
                                hoverTitle={"Discount Percent"}
                                className={row.discount_type_id === PriceUpchargeTypeEnum.PERCENT ? activeClassName : ""}
                                centerIconClass={"fas fa-percent"}
                                fn={() => {
                                    this.toggleBtn(PriceUpchargeTypeEnum.PERCENT, row);
                                }}
                            />

                            <OwButton
                                hoverTitle={"Discount Amount"}
                                className={row.discount_type_id === PriceUpchargeTypeEnum.FIXED ? activeClassName : ""}
                                centerIconClass={"fas fa-minus"}
                                fn={() => {
                                    this.toggleBtn(PriceUpchargeTypeEnum.FIXED, row);
                                }}
                            />
                        </div>
                    </div>
                </div>
            );
        } else {
            const prefix = "$";

            return (
                <div className={"text-end"}>
                    {row.discount_type_id === PriceUpchargeTypeEnum.PERCENT ? (
                        <div>
                            <FormattedNumber value={row.discount || 0} />%
                        </div>
                    ) : null}
                    {row.discount_type_id === PriceUpchargeTypeEnum.FIXED ? (
                        <div>
                            <NumericFormat
                                value={row.discount || 0}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={prefix}
                                decimalScale={this.props.supplierModel.pricing_precision || 2}
                                fixedDecimalScale={true}
                            />
                        </div>
                    ) : null}
                </div>
            );
        }
    };

    renderNetPrice = (row: IOrder_ItemUI) => {
        const netPrice = row.net_price || 0;

        const prefix = "$";

        return (
            <div>
                <NumericFormat
                    value={netPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={prefix}
                    decimalScale={this.props.supplierModel.pricing_precision || 2}
                    fixedDecimalScale={true}
                />
            </div>
        );
    };

    renderLocation = (row: IOrder_ItemUI) => {
        if (row.Catalog_Item?.has_inventory) {
            let _row = ``;
            let _bin = ``;

            if (this.props.supplierModel.has_warehouses) {
                if (this.state.order?.Shipping_Warehouse) {
                    row.Catalog_Item?.Warehouse_Catalog_Items_Maps?.forEach((map) => {
                        if (map.warehouse_id === this.state.order?.Shipping_Warehouse?.id) {
                            _row = map.row || "";
                            _bin = map.bin || "";
                        }
                    });
                }
            } else {
                if (row.Catalog_Item?.row) {
                    _row = row.Catalog_Item?.row;
                }

                if (row.Catalog_Item?.bin) {
                    _bin = row.Catalog_Item?.bin;
                }
            }

            let location = _row;

            if (location.length) {
                location += ` - ${_bin}`;
            } else {
                location += `${_bin}`;
            }

            return <div>{location}</div>;
        }
    };

    formatDiscountDisplay = (discount: IDiscount) => {
        if (discount.discount_type_id === PriceUpchargeTypeEnum.PERCENT) {
            return `${discount.discount}%`;
        }
        return `$${discount.discount.toFixed(2)}`;
    };

    renderDiscount = (row: IOrder_ItemUI) => {
        const discount = row.discount_total || 0;
        const isAdmin = this.props.userModel?.userType?.id === UserTypesEnum.ADMIN;
        const isEditing = this.state.editingDiscountRowGuid === row.guid;
        const prefix = "$";

        if (isAdmin && isEditing) {
            // Map discounts to include formatted display
            const discountsWithDisplay = this.state.discountTypeaheadItems.map((d) => ({
                ...d,
                discount_display: this.formatDiscountDisplay(d),
            }));

            return (
                <div className="discount-typeahead-container">
                    <Typeahead
                        typeaheadApiFn={this.searchDiscounts}
                        typeaheadItems={discountsWithDisplay}
                        selectedItemFn={(discount: IDiscount) => this.selectDiscount(discount, row)}
                        itemsRenderFn={(item: IDiscount) => {
                            return (
                                <div className="text-small pointer">
                                    {item.name}
                                    <div className="text-muted">
                                        {item.discount_type_id === PriceUpchargeTypeEnum.PERCENT
                                            ? `${item.discount}%`
                                            : `$${item.discount.toFixed(2)}`}
                                    </div>
                                </div>
                            );
                        }}
                        isSelectableFn={() => true}
                        titleProp="name"
                        subTitleProp="discount_display"
                        placeholder="search_discounts"
                        clearTypeahead={false}
                        maxResults={50}
                        scrollableList={true}
                    />
                    <OwButton
                        fn={() => this.setState({ editingDiscountRowGuid: null })}
                        btnSizeClass="btn-sm"
                        className="btn-link"
                        title="cancel"
                    />
                </div>
            );
        }

        return (
            <div className="discount-display-container d-flex justify-content-end align-items-center text-end">
                <NumericFormat
                    value={discount}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={row.Discount?.discount_type_id === PriceUpchargeTypeEnum.PERCENT ? "" : "$"}
                    suffix={row.Discount?.discount_type_id === PriceUpchargeTypeEnum.PERCENT ? "%" : ""}
                    decimalScale={this.props.supplierModel.pricing_precision || 2}
                    fixedDecimalScale={true}
                />
                {isAdmin && !isEditing && (
                    <OwButton
                        fn={() => this.setState({ editingDiscountRowGuid: row.guid })}
                        btnSizeClass="btn-sm"
                        className="btn-link ms-2"
                        leftIconClass="fa fa-pencil"
                        ariaLabel="Edit discount"
                    />
                )}
            </div>
        );
    };

    renderMap = (row: IOrder_ItemUI) => {
        const map = row.Catalog_Item?.map || 0;

        const prefix = "$";

        return (
            <div>
                <NumericFormat
                    value={map}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={prefix}
                    decimalScale={this.props.supplierModel.pricing_precision || 2}
                    fixedDecimalScale={true}
                />
            </div>
        );
    };

    renderTotalSqFt = (row: IOrder_ItemUI) => {
        const displayFields = row.Catalog_Item?.display_fields || [];

        let sqFt = 0;

        for (const field of displayFields) {
            if (field.name === "SQF PER BOX") {
                sqFt = Number(field.value);
            }
        }

        return row.qty * sqFt;
    };

    renderDimensionFn = (row: IOrder_ItemUI, prop: "width" | "height" | "depth") => {
        const dimensionUnit = row.Catalog_Item?.Dimension_Unit;
        const abbreviation = dimensionUnit?.abbreviation;
        const isCustomDim = !_.isNil(row[prop]) && row[prop] !== 0;
        const dimension = isCustomDim ? get(row, prop) : get(row.Catalog_Item, prop);

        if (row.rowEditMode) {
            return (
                <div className={"d-flex"}>
                    {this.props.supplierModel.show_dimension_widget ? (
                        <div>
                            <DimensionWidget
                                type={prop}
                                value={dimension || 0}
                                compact={true}
                                units="imperial"
                                fn={(value: number) => {
                                    console.log("value: ", value);
                                    const e = {
                                        target: { value: value },
                                    };
                                    this.handleDimensionChange(e, row, prop);
                                }}
                                targetUnitId={row.Catalog_Item?.dimension_unit_id}
                            />
                        </div>
                    ) : (
                        <div>
                            <OwInputWrapper
                                name={prop}
                                fn={(e: any) => {
                                    this.handleDimensionChange(e, row, prop);
                                }}
                                value={dimension}
                                type={"number"}
                                onWheelFn={UIService.stopScrollWheel}
                            />
                            {isCustomDim ? (
                                <span
                                    className={"pointer fad fa-redo ms-1"}
                                    title={"Reset"}
                                    onClick={() => {
                                        const e = {
                                            target: { value: 0 },
                                        };
                                        this.handleDimensionChange(e, row, prop);
                                    }}></span>
                            ) : null}
                        </div>
                    )}
                </div>
            );
        } else {
            if (dimension) {
                // Get the dimension unit ID from the catalog item
                const dimensionUnitId = row.Catalog_Item?.dimension_unit_id;

                // Format the dimension value based on the unit
                const formattedDimension = formatDimensionDisplay(dimension, dimensionUnitId);

                // If we have a formatted dimension, use it; otherwise fall back to old format
                const detail = formattedDimension || (abbreviation ? `${dimension}${abbreviation}` : `${dimension}`);

                return (
                    <div className="d-flex align-items-center">
                        {isCustomDim ? <h5 className={"d-inline-flex text-danger pe-0 mb-0"}>*</h5> : null}
                        {detail}
                    </div>
                );
            } else {
                return "";
            }
        }
    };

    getStandardTableLayout = (): Partial<IOrderRowConfig>[] => {
        const catalogOrderRowConfig: IOrderRowConfig[] = _.get(this.state, "order.Catalog.order_row_config", []) as IOrderRowConfig[];

        if (catalogOrderRowConfig && catalogOrderRowConfig.length) {
            return catalogOrderRowConfig;
        } else {
            const rowConfig: Partial<IOrderRowConfig>[] = [
                { property: OrderRowColPropertyEnum.ACTIONS },
                { property: OrderRowColPropertyEnum.ITEM_NO },
                { property: OrderRowColPropertyEnum.QTY },
                { property: OrderRowColPropertyEnum.SKU },
                { property: OrderRowColPropertyEnum.NAME },
                { property: OrderRowColPropertyEnum.DESCRIPTION },
                { property: OrderRowColPropertyEnum.PRICE_PER_UNIT },
                { property: OrderRowColPropertyEnum.ROW_TOTAL },
            ];

            if (this.props.supplierModel.has_order_bonus && this.state.order?.Vendor?.has_order_bonus) {
                rowConfig.splice(3, 0, { property: OrderRowColPropertyEnum.BONUS_QTY });
            }

            return rowConfig;
        }
    };

    /**
     * Setup the Table Columns with the Table Layout as necessary
     */
    setupTableColumns = () => {
        const headerOpts = this.getStandardTableLayout();
        // const headerOpts = _.orderBy(this.getStandardTableLayout(), 'sequence', 'asc');

        const columns: IOwTableCols[] = [];

        let detailColSpan: number | undefined;

        for (let i = 0; i < headerOpts.length; ++i) {
            if (headerOpts[i].property === OrderRowColPropertyEnum.SKU) {
                detailColSpan = headerOpts.length - i;
                // console.log("colSpan: ", detailColSpan);
            }
        }

        let hidePricingCol = false;

        const hidePricing = UserService.hidePricing(this.props.supplierModel, this.props.userModel, this.props.vendorModel);

        if (hidePricing) {
            hidePricingCol = true;
        }

        for (const opt of headerOpts) {
            switch (opt.property) {
                case OrderRowColPropertyEnum.ACTIONS:
                    columns.push({
                        isActionsCol: true,
                        title: "",
                        valueProp: "",
                        renderFn: this.renderActionsCol,
                        renderFnEmitsRow: true,
                        className: "w-17r d-print-none",
                    });
                    break;

                case OrderRowColPropertyEnum.ITEM_NO:
                    columns.push({
                        title: opt.title || "no",
                        valueProp: "item_no",
                        isSortable: true,
                        className: "w-6r",
                        sortOrderFn: () => {
                            return this.state.sortDir;
                        },
                        sortFn: this.toggleSortDir,
                        headerActionIcon: () => {
                            if (this.isNumberingOutOfSequence()) {
                                return "ms-2 fad fa-sync";
                            } else {
                                return "";
                            }
                        },
                        headerActionFn: this.renumberItemNumbers,
                    });
                    break;

                case OrderRowColPropertyEnum.BONUS_QTY:
                    columns.push({
                        title: opt.title || "bonus_qty",
                        valueProp: "bonus_qty",
                        renderFn: this.renderBonusQtyFn,
                        renderFnEmitsRow: true,
                    });
                    break;

                case OrderRowColPropertyEnum.ITEM_PRICE_GROUP:
                    columns.push({
                        title: opt.title || "price_group",
                        valueProp: "",
                        renderFn: this.renderItemPriceGroupCol,
                        renderFnEmitsRow: true,
                    });
                    break;

                case OrderRowColPropertyEnum.MSRP:
                    columns.push({
                        title: opt.title || "msrp",
                        valueProp: "",
                        renderFn: this.renderMsrpCol,
                        renderFnEmitsRow: true,
                    });
                    break;

                case OrderRowColPropertyEnum.QTY:
                    columns.push({
                        title: opt.title || "qty",
                        valueProp: "qty",
                        renderFn: this.renderQtyFn,
                        renderFnEmitsRow: true,
                        className: "text-end",
                    });

                    if (
                        this.props.supplierModel.has_pick_list_management &&
                        (this.state.order?.order_state_id === OrderStatesEnum.SHIPPED ||
                            this.state.order?.order_state_id === OrderStatesEnum.PARTIALLY_SHIPPED)
                    ) {
                        columns.push({
                            title: opt.title || "qty_shipped",
                            valueProp: "qty_shipped",
                            renderFn: this.renderQtyShippedFn,
                            renderFnEmitsRow: true,
                            className: "text-end max-w-7r",
                        });
                    }

                    break;

                case OrderRowColPropertyEnum.NAME:
                    columns.push({
                        title: opt.title || "name",
                        valueProp: "Catalog_Item",
                        valueSubProp: "name",
                        renderFnEmitsRow: true,
                        renderFn: this.renderNameCol,
                    });
                    break;

                case OrderRowColPropertyEnum.UOM_BASE_QTY:
                    columns.push({
                        title: opt.title || "base_qty",
                        valueProp: "qty",
                        renderFnEmitsRow: true,
                        renderFn: this.renderUomBaseQtyCol,
                    });
                    break;

                // case OrderRowColPropertyEnum.SHORT_DESCRIPTION:
                //     columns.push({
                //         title: "short_description",
                //         valueProp: "Catalog_Item",
                //         valueSubProp: "short_description",
                //         renderFnEmitsRow: true,
                //         renderFn: this.renderShortDescCol,
                //     });
                //     break;

                case OrderRowColPropertyEnum.DESCRIPTION:
                    columns.push({
                        title: opt.title || "description",
                        valueProp: "Catalog_Item",
                        valueSubProp: "description",
                        className: "pre-wrap",
                        renderFnEmitsRow: true,
                        renderFn: this.renderDescCol,
                    });
                    break;

                case OrderRowColPropertyEnum.UNIT_OF_MEASURE:
                    columns.push({
                        title: opt.title || "uom",
                        valueProp: "Unit_Of_Measure",
                        valueSubProp: "name",
                        className: "pre-wrap",
                        renderFnEmitsRow: true,
                        renderFn: this.renderUomCol,
                    });
                    break;

                case OrderRowColPropertyEnum.SKU:
                    columns.push({
                        title: opt.title || "sku",
                        valueProp: "Catalog_Item",
                        valueSubProp: "sku",
                        renderFnEmitsRow: true,
                        renderFn: this.renderSkuCol,
                    });
                    break;

                case OrderRowColPropertyEnum.COLOR:
                    columns.push({
                        title: opt.title || "color",
                        valueProp: "Catalog_Item",
                        valueSubProp: "color",
                    });
                    break;

                case OrderRowColPropertyEnum.STYLE:
                    columns.push({
                        title: opt.title || "style",
                        valueProp: "Catalog_Item",
                        valueSubProp: "style",
                    });
                    break;

                case OrderRowColPropertyEnum.PRICE_PER_UNIT:
                    if (!hidePricingCol) {
                        columns.push({
                            title: opt.title || "price_per_unit",
                            valueProp: "",
                            renderFn: this.renderPricePerUnit,
                            renderFnEmitsRow: true,
                            className: "text-end min-w-10r",
                        });
                    }
                    break;

                case OrderRowColPropertyEnum.NET_PRICE:
                    if (!hidePricingCol) {
                        columns.push({
                            title: opt.title || "net_price",
                            valueProp: "",
                            renderFn: this.renderNetPrice,
                            renderFnEmitsRow: true,
                            className: "text-end min-w-10r",
                        });
                    }
                    break;

                case OrderRowColPropertyEnum.DISCOUNT:
                    if (!hidePricingCol) {
                        columns.push({
                            title: opt.title || "discount",
                            valueProp: "",
                            renderFn: this.renderDiscount,
                            renderFnEmitsRow: true,
                            className: "text-end min-w-10r",
                        });
                    }
                    break;

                case OrderRowColPropertyEnum.MAP:
                    if (!hidePricingCol) {
                        columns.push({
                            title: opt.title || "MAP",
                            valueProp: "",
                            renderFn: this.renderMap,
                            renderFnEmitsRow: true,
                            className: "text-end min-w-10r",
                        });
                    }
                    break;

                case OrderRowColPropertyEnum.LOCATION:
                    columns.push({
                        title: opt.title || "location",
                        valueProp: "",
                        renderFn: this.renderLocation,
                        renderFnEmitsRow: true,
                    });
                    break;

                case OrderRowColPropertyEnum.LIST_PRICE:
                    if (!hidePricingCol) {
                        columns.push({
                            title: opt.title || "list_price",
                            valueProp: "",
                            renderFn: this.renderListPrice,
                            renderFnEmitsRow: true,
                            className: "text-end min-w-10r",
                        });
                    }
                    break;

                case OrderRowColPropertyEnum.COST_PRICE:
                    if (!hidePricingCol) {
                        columns.push({
                            title: opt.title || "cost_price",
                            valueProp: "",
                            renderFn: this.renderCostPrice,
                            renderFnEmitsRow: true,
                            className: "text-end",
                        });
                    }
                    break;

                case OrderRowColPropertyEnum.COST_PER_UOM:
                    if (!hidePricingCol) {
                        columns.push({
                            title: opt.title || "cost",
                            valueProp: "",
                            renderFn: this.renderCatalogItemCostPrice,
                            renderFnEmitsRow: true,
                            className: "text-end",
                        });
                    }
                    break;

                case OrderRowColPropertyEnum.ROW_TOTAL:
                    if (!hidePricingCol) {
                        columns.push({
                            title: opt.title || "total",
                            valueProp: "",
                            renderFn: this.renderTotal,
                            renderFnEmitsRow: true,
                            className: "text-end",
                        });
                    }
                    break;

                case OrderRowColPropertyEnum.WIDTH:
                    columns.push({
                        title: opt.title || "width",
                        valueProp: "Catalog_Item",
                        valueSubProp: "width",
                        renderFn: (row: IOrder_ItemUI) => {
                            return this.renderDimensionFn(row, "width");
                        },
                        renderFnEmitsRow: true,
                    });
                    break;

                case OrderRowColPropertyEnum.HEIGHT:
                    columns.push({
                        title: opt.title || "height",
                        valueProp: "Catalog_Item",
                        valueSubProp: "height",
                        renderFn: (row: IOrder_ItemUI) => {
                            return this.renderDimensionFn(row, "height");
                        },
                        renderFnEmitsRow: true,
                    });
                    break;

                case OrderRowColPropertyEnum.DEPTH:
                    columns.push({
                        title: opt.title || (this.props.supplierModel.length_for_depth ? "length" : "depth"),
                        valueProp: "Catalog_Item",
                        valueSubProp: "depth",
                        renderFn: (row: IOrder_ItemUI) => {
                            return this.renderDimensionFn(row, "depth");
                        },
                        renderFnEmitsRow: true,
                    });
                    break;

                case OrderRowColPropertyEnum.CUSTOM:
                    columns.push({
                        title: opt.title || "",
                        renderFnEmitsRow: true,
                        renderFn: (row: IOrder_ItemUI) => {
                            switch (opt.type) {
                                case "totalSqFt":
                                    return this.renderTotalSqFt(row);
                                    break;

                                case "addlDiscount":
                                    return this.renderAddlDiscount(row);
                                    break;

                                case "netPrice":
                                    return this.renderNetPrice(row);
                                    break;
                            }
                        },
                        valueProp: "",
                    });
                    break;
            }
        }

        const detailTableCols: IOwTableCols[] = [
            {
                title: "",
                valueProp: "",
                renderFn: this.renderDetailView,
                renderFnEmitsRow: true,
            },
        ];

        // console.log('columns', columns);

        this.setState({
            columns,
            detailTableCols,
            detailColSpan,
        });
    };

    rowHasDetailView = (row: IOrder_ItemUI): boolean => {
        if (row.is_catch_weight_item) {
            return false;
        } else {
            const hasPhotos = !!(row.Catalog_Item && row.Catalog_Item?.Attachments && row.Catalog_Item?.Attachments?.length);

            const hasNote = !!row.Catalog_Item?.require_addl_input || !!row.note;

            const hasSpecFile = false;

            const hasSerials = !!row.Catalog_Item?.has_serials;

            const hasItemOptions = !!row.Order_Item_Options?.length;

            return hasPhotos || hasSpecFile || hasNote || hasSerials || hasItemOptions || this.props.showHiddenFeatures;
        }
    };

    toggleDetailInfo = (e: ChangeEvent<any>) => {
        this.setState({
            showRowDetailInfo: !this.state.showRowDetailInfo,
        });
    };

    startAcknowledgeView = () => {
        this.setState({
            currentView: OrderEntryViewStateOptionsEnum.ACKNOWLEDGE,
        });
    };

    cancelAcknoledgeView = () => {
        this.setState({
            currentView: OrderEntryViewStateOptionsEnum.ORDER_ENTRY,
        });
    };

    startBackorder = () => {
        // toggle into the backorder view.
        this.setState({
            currentView: OrderEntryViewStateOptionsEnum.BACKORDER,
        });
    };

    closeFulfillBackorderModal = (refreshOrder?: boolean) => {
        this.props.uiContext.setModalComponent(null);
        this.props.uiContext.showModal(false);

        if (refreshOrder) {
            this.getOrder("closeFulfillBackorderModal", "order_entry");
        }
    };

    fulfillBackorder = () => {
        if (!this.state.order) {
            return;
        }

        const modalComponent = <FulfillBackorderModal order={this.state.order} closeFn={this.closeFulfillBackorderModal} />;

        this.props.uiContext.setModalComponent(modalComponent);
        this.props.uiContext.showModal(true);
    };

    cancelBackorder = () => {
        this.setState({
            currentView: OrderEntryViewStateOptionsEnum.ORDER_ENTRY,
        });
    };

    markSpecReceived = () => {
        if (this.state.order) {
            const payload: IUpdateOrderEntryDetailDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.state.order!.Vendor!.guid,
                orderGuid: this.state.order!.guid,
                details: {
                    spec_received_date: moment().format("YYYY-MM-DD"),
                    spec_received_by_user_id: this.props.userModel.id,
                },
            };

            this.props.socket.emit(EndpointsEnum.OrderEntryUpdateOrderEntryDetail, payload);
        }
    };

    createBackorder = () => {
        const orderItems = this.state.backOrderRows.filter((row) => {
            return row.isChecked;
        });

        const payload: ICreateBackorderDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderGuid: this.state.order!.guid,
            orderItems,
        };

        this.props.socket.emit(EndpointsEnum.OrderCreateBackorder, payload);
    };

    onCreateBackorder = (data: IOnCreateBackorderDTO) => {
        this.props.history(`/orders/change/${data.backorder.guid}`);

        this.setState({
            currentView: OrderEntryViewStateOptionsEnum.ORDER_ENTRY,
        });
    };

    getPurchaseOrderOrderDetail = () => {
        if (this.state.orderGuid) {
            const payload: IGetPurchaseOrderDetailForOrderDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                orderGuid: this.state.orderGuid,
            };

            this.props.socket.emit(EndpointsEnum.PurchaseOrderGetPurchaseOrderDetailForOrder, payload);

            const vendorSourcePayload: IGetVendorSourcesForOrderItemsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                orderGuid: this.state.orderGuid,
            };

            this.props.socket.emit(EndpointsEnum.PurchaseOrderGetVendorSourcesForOrderItems, vendorSourcePayload);

            this.props.setActivityIndicator(true);
        }
    };

    onGetPurchaseOrderOrderDetail = (data: IOnGetPurchaseOrderDetailForOrderDTO) => {
        const purchaseOrderRows = data.purchaseOrderOrderItemDetails.map((itemDetail) => {
            return {
                minQty: itemDetail.minQty,
                qty: itemDetail.qty,
                orderItemGuid: itemDetail.orderItemGuid,
                isChecked: true,
                vendorSourceId: undefined,
            };
        });

        this.setState({
            purchaseOrderRows,
        });
    };

    onGetVendorSourcesForOrderItems = (data: IOnGetVendorSourcesForOrderItemsDTO) => {
        this.setState(
            {
                vendorSourcesForCatalogItems: data,
            },
            () => {
                this.props.setActivityIndicator(false);
            }
        );
    };

    startPurchaseOrder = () => {
        this.setState(
            {
                currentView: OrderEntryViewStateOptionsEnum.PURCHASE_ORDER,
            },
            () => {
                // todo validate which order items can be made as purchase orders and details for each.
                this.getPurchaseOrderOrderDetail();
            }
        );
    };

    createPurchaseOrders = (options: {
        useOrderShipToForPoShipTo: boolean;
        autoSubmitPoOnCreate: boolean;
        autoSubmitOrderOnPoEmail: boolean;
        autoSendToQboOnCreate: boolean;
        autoEmailThruQboOnCreate: boolean;
    }) => {
        if (this.state.orderGuid) {
            const purchaseOrderItems: IPurchaseOrderOrderItemDetail[] = [];

            for (const orderRow of this.state.purchaseOrderRows) {
                if (orderRow.isChecked && orderRow.vendorSourceId) {
                    purchaseOrderItems.push({
                        qty: orderRow.qty,
                        orderItemGuid: orderRow.orderItemGuid,
                        minQty: orderRow.minQty,
                        vendorSourceId: orderRow.vendorSourceId,
                    });
                }
            }

            const payload: ICreatePurchaseOrdersFromOrderDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                orderGuid: this.state.orderGuid,
                purchaseOrderItems,
                useOrderShipToForPoShipTo: options.useOrderShipToForPoShipTo,
                autoSendToQboOnCreate: options.autoSendToQboOnCreate,
                autoSubmitPoOnCreate: options.autoSubmitPoOnCreate,
                autoSubmitOrderOnPoEmail: options.autoSubmitOrderOnPoEmail,
                autoEmailThruQboOnCreate: options.autoEmailThruQboOnCreate,
            };

            this.props.socket.emit(EndpointsEnum.PurchaseOrderCreatePurchaseOrdersFromOrder, payload);
        }
    };

    onCreatePurchaseOrdersFromOrder = (data: IOnCreatePurchaseOrdersFromOrderDTO) => {
        const notification: INotification = {
            message: "successfully_created_purchase_orders",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                currentView: OrderEntryViewStateOptionsEnum.ORDER_ENTRY,
            },
            () => {
                this.getOrder("onCreatePurchaseOrdersFromOrder", "order_entry");
            }
        );
    };

    cancelPurchaseOrders = () => {
        this.setState({
            currentView: OrderEntryViewStateOptionsEnum.ORDER_ENTRY,
        });
    };

    // RMA Methods
    startRma = () => {
        this.setState({
            currentView: OrderEntryViewStateOptionsEnum.RMA,
            rmaRows: [], // Reset RMA rows when starting
        });
    };

    hasOneRmaRowChecked = (): boolean => {
        if (this.state.rmaRows) {
            for (const row of this.state.rmaRows) {
                if (row.isChecked && row.qty > 0) {
                    return true;
                }
            }
        }
        return false;
    };

    createRma = async (options: { notes?: string; tracking_number?: string }) => {
        if (!this.state.orderGuid) {
            return;
        }

        this.setState({ isCreatingRma: true });

        try {
            // Collect line items from checked rows
            const lineItems = [];
            for (const row of this.state.rmaRows) {
                if (row.isChecked && row.qty > 0) {
                    lineItems.push({
                        order_line_item_id: row.order_line_item_id,
                        catalog_item_id: row.catalog_item_id,
                        qty_returned: row.qty,
                    });
                }
            }

            if (lineItems.length === 0) {
                throw new Error("No items selected for RMA");
            }

            // Build the payload
            const payload = {
                orderGuid: this.state.orderGuid,
                lineItems,
                ...(options.notes && { notes: options.notes }),
                ...(options.tracking_number && { tracking_number: options.tracking_number }),
            };

            // Import necessary functions for REST API
            const { buildAuthHeadersForFetch, buildRestUrl } = await import("../../../services/RestService");
            const RestEndpointsEnum = (await import("../../../models/RestEndpointsEnum")).default;

            // Build URL
            const url = buildRestUrl({
                endpoint: RestEndpointsEnum.CreateRma,
            });

            // Build headers
            const headers = buildAuthHeadersForFetch({
                userModel: this.props.userModel,
                supplierModel: this.props.supplierModel,
                vendorModel: this.props.vendorModel,
            });

            // Make REST call
            const response = await fetch(url, {
                method: "POST",
                headers,
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`Failed to create RMA: ${response.statusText}`);
            }

            const data = await response.json();

            // Show success notification
            const notification: INotification = {
                message: "rma_created_successfully",
                position: NotificationPositionEnum.bc,
                level: NotificationLevelEnum.success,
            };
            this.props.notifyFn(null, notification);

            // Reset to order entry view and refresh order
            this.setState(
                {
                    currentView: OrderEntryViewStateOptionsEnum.ORDER_ENTRY,
                    rmaRows: [],
                    isCreatingRma: false,
                },
                () => {
                    this.getOrder("createRma", "order_entry");
                }
            );
        } catch (error) {
            console.error("Error creating RMA:", error);
            const notification: INotification = {
                message: "error_creating_rma",
                position: NotificationPositionEnum.bc,
                level: NotificationLevelEnum.error,
            };
            this.props.notifyFn(null, notification);
            this.setState({ isCreatingRma: false });
        }
    };

    cancelRma = () => {
        this.setState({
            currentView: OrderEntryViewStateOptionsEnum.ORDER_ENTRY,
            rmaRows: [],
        });
    };

    getMarkSpecReceivedButton = () => {
        if (!this.props.supplierModel.has_spec_due_date || this.state.order?.Order_Detail?.spec_received_by_user_id) {
            return null;
        }

        return (
            <div>
                <OwButton title={"mark_spec_received"} fn={this.markSpecReceived} />
            </div>
        );
    };

    wayfairStartAcknowledgePO = () => {
        this.startAcknowledgeView();
    };

    wayfairAcknowledgePO = () => {
        const checkedItems = this.state.acknowledgeRows.filter((item) => item.isChecked);

        const items = checkedItems.map((item) => {
            return {
                qty: item.qty,
                orderItemGuid: item.orderItemGuid,
            };
        });

        const payload: IWayfairAcknowledgePoDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderGuid: this.state.order!.guid,
            items,
        };

        this.props.socket.emit(EndpointsEnum.WayfairAcknowledgePurchaseOrder, payload);
    };

    onWayfairAcknowledgePO = (data: IWayfairOnAcknowledgePoDTO) => {
        const notification: INotification = {
            message: "successfully_acknowledged_purchase_order",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.cancelAcknoledgeView();

        this.getOrder("onWayfairAcknowldgePO", "order_entry");
    };

    getAcknowledgeButtons = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_wayfair || this.state.order?.order_source_id !== OrderSourceEnum.WAYFAIR) {
            return null;
        }

        if (this.state.order.wayfair_ack_po) {
            return (
                <div className={"text-end ms-auto"}>
                    <OwLabel title={"wayfair_po_acknowledged"} className={"text-success"} />
                </div>
            );
        } else {
            return (
                <div className={"text-end ms-auto"}>
                    {this.state.currentView === OrderEntryViewStateOptionsEnum.ACKNOWLEDGE ? (
                        <div>
                            <OwButton
                                title={"confirm_acknowledge_po"}
                                fn={this.wayfairAcknowledgePO}
                                disabled={!this.hasOneAcknowledgeRowChecked()}
                            />
                            <OwButton title={"cancel_acknowledge_po"} fn={this.cancelAcknoledgeView} className={"ms-2 btn-danger"} />
                        </div>
                    ) : (
                        <OwButton title={"acknowledge_po"} fn={this.wayfairStartAcknowledgePO} />
                    )}
                </div>
            );
        }
    };

    getBackorderButtons = () => {
        if (!this.props.supplierModel.has_backorders || this.state.currentView === OrderEntryViewStateOptionsEnum.PURCHASE_ORDER) {
            return null;
        }

        return (
            <div className={"text-end ms-auto d-print-none"}>
                {this.state.currentView === OrderEntryViewStateOptionsEnum.BACKORDER ? (
                    <div>
                        <OwButton title={"create_backorder"} fn={this.createBackorder} disabled={!this.hasOneBackorderRowChecked()} />
                        <OwButton title={"cancel_backorder"} fn={this.cancelBackorder} className={"ms-2 btn-danger"} />
                    </div>
                ) : null}
            </div>
        );
    };

    toggleCurrencyConversion = () => {
        this.setState({
            doCurrencyConversion: !this.state.doCurrencyConversion,
        });
    };

    getCurrencyToggle = () => {
        if (!this.props.supplierModel.has_currencies || !this.props.userModel.isSupplierUser) {
            return null;
        }

        if (
            this.state.currentView === OrderEntryViewStateOptionsEnum.BACKORDER ||
            this.state.currentView === OrderEntryViewStateOptionsEnum.PURCHASE_ORDER ||
            this.props.userModel.supplierUserToken?.access_type_id === AccessTypesEnum.READ_ONLY ||
            this.state.order?.is_template
        ) {
            return null;
        }

        return (
            <div className={"d-flex mb-2 align-items-end justify-content-end"}>
                <OwToggle
                    fn={this.toggleCurrencyConversion}
                    name={"toggle_currency_conversion"}
                    label={"currency_conversions"}
                    active={this.state.doCurrencyConversion}
                />
            </div>
        );
    };

    quotePrintView = () => {
        if (this.state.order) {
            this.props.history(`/quotes/${this.state.order.guid}/print`);
        }
    };

    openEmailQuote = () => {
        if (this.state.order) {
            const component = (
                <EmailQuoteModal
                    closeModalFn={this.closeModal}
                    socket={this.props.socket}
                    notifyFn={this.props.notifyFn}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    quoteOrderModel={this.state.order}
                />
            );

            this.setState({
                modalComponent: component,
                modalIsOpen: true,
                closeModalOnOverlayClick: false,
            });
        }
    };

    // toggleDeviceScan = () => {
    //     this.setState(
    //         {
    //             enableDeviceScan: !this.state.enableDeviceScan,
    //         },
    //         () => {
    //             if (this.state.enableDeviceScan) {
    //                 this.initQuagga();
    //             } else {
    //                 Quagga.stop();
    //             }
    //         }
    //     );
    // };

    onQBOCreateInvoice = (data: any) => {
        this.getOrder("onQBOCreateInvoice", "order_entry");
    };

    onQBOVoidInvoice = (data: any) => {
        this.viewQBOInvoice();
    };

    onQBODeleteInvoice = (data: any) => {
        this.getOrder("onQBODeleteInvoice", "order_entry");

        this.setState({
            activeQboInvoice: false,
        });
    };

    onQBOGetInvoice = (data: IQBOOnGetPDFInvoiceDTO) => {
        this.openPdfInvoiceSidebar(data.data);
    };

    onReconcileOfflineOrderEntryItems = (data: IOnReconcileOfflineOrderEntryItemsDTO) => {
        // @ts-expect-error
        const orderItemIssues: { catalogItem: ICatalog_Item; qtyOnHand: number }[] = data.Order_Items.map((item) => {
            return {
                catalogItem: { id: item.catalog_item_id },
                qtyOnHand: item.qty_on_hand,
            };
        });

        if (data.Order_Items.length) {
            const notification: INotification = {
                message: "errors_reconciling_order_please_review",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            };

            this.props.notifyFn(null, notification);
        } else {
            const notification: INotification = {
                message: "successfully_reconciled_order",
                level: NotificationLevelEnum.success,
                position: NotificationPositionEnum.bc,
            };

            this.props.notifyFn(null, notification);
        }

        this.setState({
            offlineReconciledItems: data.Order_Items,
            orderItemIssues,
        });
    };

    openPdfInvoiceSidebar = (invoiceUInt8ArrayData: any) => {
        const sidebarComp = this.getPdfInvoiceSidebar(invoiceUInt8ArrayData);
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar();

        // set all to false...
        this.setState({
            activeQboInvoice: false,
        });
    };

    cancel = () => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);
    };

    getPdfInvoiceSidebar = (invoiceUInt8ArrayData: any) => {
        return (
            <PdfSidebarViewer
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                file={invoiceUInt8ArrayData}
                cancel={this.cancel}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                qboInvoiceId={this.state.order!.name!}
                qboEntityId={this.state.order!.qbo_EntityId!}
                orderGuid={this.state.order!.guid}
                qboInvoiceTotal={0}
                vendorEmail={this.state.order!.Vendor!.email}
                qboVendorEmail={"-"}
                vendorGuid={this.state.order!.Vendor!.guid}
            />
        );
    };

    viewQBOInvoice = () => {
        if (!this.props.userModel || !this.props.supplierModel) {
            return;
        }

        const payload: IQBOGetPDFInvoiceDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: this.state.order!.Vendor!.guid,
            supplierGuid: this.props.supplierModel.guid,
            orderGuid: this.state.order!.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetPDFInvoice, payload);

        this.setState({
            activeQboInvoice: true,
        });
    };

    voidQBOInvoice = () => {
        const payload: IQBOVoidInvoiceDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: this.state.order!.Vendor!.guid,
            supplierGuid: this.props.supplierModel.guid,
            qbo_EntityId: this.state.order!.qbo_EntityId!,
        };

        this.props.socket.emit(EndpointsEnum.QBOVoidInvoice, payload);

        this.setState({
            activeQboInvoice: true,
        });
    };

    deleteQBOInvoice = () => {
        if (!this.props.userModel || !this.props.supplierModel || !this.state.order!.qbo_EntityId) {
            return;
        }

        const payload: IQBODeleteInvoiceDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: this.state.order!.Vendor!.guid,
            supplierGuid: this.props.supplierModel.guid,
            qbo_EntityId: this.state.order!.qbo_EntityId,
        };

        this.props.socket.emit(EndpointsEnum.QBODeleteInvoice, payload);

        this.setState({
            activeQboInvoice: true,
        });
    };

    finalizeCaptureCharge = () => {
        this.setState(
            {
                hasCollectedPaymentAuth: true,
                modalIsOpen: false,
                modalComponent: null,
            },
            () => {
                this.getOrder("finalizeCaptureCharge", "order_entry");
            }
        );
    };

    captureChargeWithCardToUseDetail = () => {
        const component = (
            <OrderPayment
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                orderModel={this.state.order!}
                setActivityIndicator={this.props.setActivityIndicator}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                cancelFn={this.closeModal}
                confirmFn={this.finalizeCaptureCharge}
            />
        );

        this.setState({
            modalComponent: component,
            modalIsOpen: true,
            modalStyle: {
                content: {
                    minHeight: "32rem",
                    maxHeight: "33rem",
                    height: "auto",
                },
            },
        });
    };

    viewQBOEstimatePDF = () => {
        const estimateSidebarPdf = (
            <QBOEstimatePdfSidebarViewer
                cancel={this.closeSidebar}
                vendorGuid={this.state.order!.Vendor!.guid}
                vendorEmail={this.state.order!.Vendor!.email}
                qboEstimateId={this.state.order!.qbo_EstimateId!}
            />
        );

        this.props.setSidebarComponent(estimateSidebarPdf);
        this.props.toggleSidebar(true);
    };

    onViewQBOEstimatePDF = () => {};

    deleteQBOEstimate = () => {
        if (this.state.order?.qbo_EstimateId) {
            const payload: IQBODeleteEstimateDTO = {
                supplierGuid: this.props.supplierModel.guid,
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                entityId: this.state.order.qbo_EstimateId,
            };

            this.props.socket.emit(EndpointsEnum.QBODeleteEstimate, payload);

            this.setState({
                activeQboInvoice: true,
            });
        }
    };

    onDeleteQBOEstimate = (data: IQBOOnDeleteEstimateDTO) => {
        this.getOrder("onDeleteQBOEstimate", "order_entry");

        this.setState({
            activeQboInvoice: false,
        });
    };

    getEstimateDataFromQbo = () => {
        if (this.state.order?.guid) {
            const payload: IQBOGetEstimateDataFromQboDTO = {
                supplierGuid: this.props.supplierModel.guid,
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                orderGuid: this.state.order.guid,
            };

            this.props.socket.emit(EndpointsEnum.QBOGetEstimateDataFromQbo, payload);

            this.setState({
                activeQboInvoice: true,
            });
        }
    };

    onGetEstimateDataFromQbo = (data: IQBOOnGetEstimateDataFromQboDataDTO) => {
        this.setState({
            activeQboInvoice: false,
        });
    };

    emailQBOEstimate = (emailAddress?: string) => {
        if (this.state.order?.qbo_EstimateId) {
            const payload: IQBOSendEstimateDTO = {
                supplierGuid: this.props.supplierModel.guid,
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                estimateId: this.state.order.qbo_EstimateId,
            };

            if (emailAddress) {
                payload.emailAddress = emailAddress;
            }

            this.props.socket.emit(EndpointsEnum.QBOSendEstimate, payload);

            this.setState({
                activeQboInvoice: true,
            });
        }
    };

    onEmailQBOEstimate = () => {
        const notification: INotification = {
            message: "successfully_sent_estimate",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            activeQboInvoice: false,
        });
    };

    createQBOEstimate = () => {
        const payload: IQBOCreateEstimateDTO = {
            supplierGuid: this.props.supplierModel.guid,
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            quoteGuid: this.state.order!.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOCreateEstimate, payload);

        this.setState({
            activeQboInvoice: true,
        });
    };

    onCreateQBOEstimate = (data: IOnQBOCreateEstimateDTO) => {
        this.getOrder("onCreateQBOEstimate", "order_entry");

        this.setState({
            activeQboInvoice: false,
        });
    };

    createQBOInvoice = (shippingCost: number, invoiceDate: string, shipVia: string, trackingNo: string, shipDate: string) => {
        const payload: IQBOCreateInvoiceDTO = {
            invoiceDate,
            supplierGuid: this.props.supplierModel.guid,
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            shippingCost,
            orderGuid: this.state.order!.guid,
            vendorGuid: this.state.order!.Vendor!.guid,
        };

        if (shipVia.length) {
            payload.shipMethodRef = shipVia;
        }

        if (trackingNo.length) {
            payload.trackingNo = trackingNo;
        }

        if (shipDate.length) {
            payload.shipDate = shipDate;
        }

        this.props.socket.emit(EndpointsEnum.QBOCreateInvoice, payload);

        this.setState(
            {
                activeQboInvoice: true,
                showQBOInvoice: true,
            },
            () => {
                this.props.setSidebarComponent(null);
                this.props.toggleSidebar(false);
            }
        );
    };

    getCaptureChargeBtn = () => {
        let capturedAmount = 0;
        let component: any = null;

        if (this.state.order) {
            for (const payment of this.state.order.Payments || []) {
                capturedAmount += payment.capture_amount;
            }

            const grandTotal = this.state.order.grand_total || 0;

            if (capturedAmount < grandTotal) {
                component = (
                    <div className={"me-3"}>
                        <OwButton className={"nowrap btn-primary"} title={"capture_charge"} fn={this.captureChargeWithCardToUseDetail} />
                    </div>
                );
            } else {
                component = (
                    <div className={"charged-in-full me-3"}>
                        <OwLabel title={"charged"} />
                        <span>
                            <FormattedNumber
                                value={capturedAmount}
                                currency={"USD"}
                                minimumFractionDigits={2}
                                currencyDisplay={"symbol"}
                                currencySign={"standard"}
                            />
                        </span>
                    </div>
                );
            }
        }

        return component;
    };

    closeSidebar = () => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);
    };

    openTimelineSidebar = () => {
        if (this.state.order) {
            const component = <OrderTimelineSidebar close={this.closeSidebar} orderModel={this.state.order} />;

            this.props.setSidebarComponent(component);
            this.props.toggleSidebar(true);
        }
    };

    performRemake = (isReorder?: boolean) => {
        if (!this.state.order) {
            return null;
        }

        const payload: IRemakeOrderDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderGuid: this.state.order.guid,
        };

        if (!this.props.userModel?.isSupplierUser) {
            payload.vendorGuid = this.state.order.Vendor!.guid;
        }

        if (isReorder) {
            payload.isReorder = true;
        }

        this.props.socket.emit(EndpointsEnum.OrderRemake, payload);

        this.setState({
            orderStepBtnsActive: {
                remakeBtnActive: !isReorder,
                reorderBtnActive: !!isReorder,
            },
        });
    };

    onRemakeOrder = (data: IOnRemakeOrderDTO) => {
        this.setState({
            orderStepBtnsActive: {
                remakeBtnActive: false,
                reorderBtnActive: false,
            },
        });

        this.props.history(`/orders/change/${data.newOrderGuid}`);
    };

    approveDeclineDeal = (status: "APPROVE" | "DECLINE") => {
        if (this.state.order) {
            const payload: IUpdateOrderEntryDetailDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.state.order.Vendor!.guid,
                orderGuid: this.state.order.guid,
                approve_decline: status,
            };

            this.props.socket.emit(EndpointsEnum.OrderEntryUpdateOrderEntryDetail, payload);
        }
    };

    showPackingList = () => {
        if (this.state.order) {
            this.props.history(`/orders/packing_list?orders=${this.state.order.guid}`);
        }
    };

    showPickList = () => {
        if (this.state.order) {
            this.props.history(`/orders/pick_list?orders=${this.state.order.guid}`);
        }
    };

    orderStepButtonsFnCallbacks: IOrderStepButtonsFnCallbacks = {
        submitOrder: this.submitOrderFn,
        performRemake: this.performRemake,
        putOrderOnHoldFn: this.putOrderOnHold,
        cancelOrderFn: this.cancelOrderFn,
        approveDeclineDeal: this.approveDeclineDeal,
        updateOrderEntryFineDetailFn: this.updateOrderEntryFineDetail,

        editMetaData: this.editMetaData,

        resendSubmitEmailFn: this.resendSubmitEmail,
        resendOrderAutomationFn: this.resendOrderAutomation,
        performConvertQuoteToOrder: this.showConvertQuoteToOrderModal,

        openTimelineSidebar: this.openTimelineSidebar,

        toggleBackorderFn: this.toggleBackorder,
    };

    otherSectionsCallbacks: IOrderOtherSectionsButtonsCallbacks = {
        createPickListFn: this.createPickList,
        createShipmentFn: this.createShipment,
        startBackorder: this.startBackorder,
        startPurchaseOrder: this.startPurchaseOrder,
        startRma: this.startRma,
        showPackingList: this.showPackingList,
        showPickList: this.showPickList,
        quotePrintView: this.quotePrintView,
        emailQuote: this.openEmailQuote,
        downloadOrderPdf: this.downloadOrderPdf,
        downloadQuotePdf: this.downloadQuotePdf,
        downloadOrderPackingListPdf: this.downloadOrderPackingListPdf,
        fulfillBackorder: this.fulfillBackorder,
    };

    shouldShowQboCreateInvoiceButton = () => {
        let show = false;

        if (this.state.order) {
            if (this.state.order.order_state_id !== OrderStatesEnum.PRELIMINARY) {
                if (this.props.supplierModel.Supplier_Integration.has_qbo) {
                    if (this.props.userModel?.isSupplierUser) {
                        show = this.props.userModel?.userType?.id === UserTypesEnum.ADMIN || false;

                        if (this.props.supplierModel.guid === SupplierGuidEnum.DECORCABLE) {
                            show = true;
                        }
                    }
                }
            }
        }

        return show;
    };

    render() {
        if (!this.state.order || !this.props.userModel || !this.props.supplierModel) {
            return null;
        }

        const orderStateId = _.get(this.state.order, "order_state_id", null);

        const { profit, profitMargin, profitClassName } = this.getProfitAndMargin();

        const showInventoryDetails = UserService.showInventoryDetails(this.props.supplierModel, this.props.userModel);

        return (
            <div
                id={"orderEntryContainer"}
                className="order-entry OrderEntry position-relative"
                ref={(el) => {
                    this.orderEntryRef = el;
                }}>
                <Breadcrumbs navItems={this.state.navItems} />

                {this.state.order && this.state.order.order_state_id === OrderStatesEnum.PRELIMINARY ? this.showCommonItemsModal() : null}
                <div className="row mt-3">
                    <div className={"col-12 text-end"}>
                        {this.state.currentView === OrderEntryViewStateOptionsEnum.RMA ||
                        this.state.currentView === OrderEntryViewStateOptionsEnum.BACKORDER ||
                        this.state.currentView === OrderEntryViewStateOptionsEnum.PURCHASE_ORDER ||
                        this.props.userModel.supplierUserToken?.access_type_id === AccessTypesEnum.READ_ONLY ||
                        this.state.order.is_template ? null : (
                            <>
                                <OrderStepButtonsFn
                                    order={this.state.order}
                                    hasPendingDetailChanges={this.state.hasPendingDetailChanges}
                                    hasPendingFineDetailChanges={
                                        this.state.hasPendingFineDetailChanges || this.state.hasPendingCustomScheduleDetailChanges
                                    }
                                    hasRowsInEditMode={this.state.hasRowsInEditMode}
                                    isFineDetailsValid={this.state.isFineDetailsValid}
                                    hasEditMode={this.state.hasEditMode}
                                    callbacks={this.orderStepButtonsFnCallbacks}
                                    btnActive={this.state.stepBtnActive}
                                    orderStepBtnsActive={this.state.orderStepBtnsActive}
                                />
                            </>
                        )}
                    </div>
                </div>

                <div className="row mt-3">
                    <div className={"col-12 text-end"}>
                        {this.state.currentView === OrderEntryViewStateOptionsEnum.RMA ||
                        this.state.currentView === OrderEntryViewStateOptionsEnum.BACKORDER ||
                        this.state.currentView === OrderEntryViewStateOptionsEnum.PURCHASE_ORDER ||
                        this.props.userModel.supplierUserToken?.access_type_id === AccessTypesEnum.READ_ONLY ||
                        this.state.order.is_template ? null : (
                            <OrderOtherSectionsButtons
                                order={this.state.order}
                                callbacks={this.otherSectionsCallbacks}
                                btnActive={this.state.stepBtnActive}
                                currenView={this.state.currentView}
                            />
                        )}
                    </div>
                </div>

                <div className="row">
                    <div className={"col"}>
                        <OrderTitle order={this.state.order} currentView={this.state.currentView} />
                        {this.state.order &&
                        this.state.order.estimated_shipping_at &&
                        this.state.currentView !== OrderEntryViewStateOptionsEnum.BACKORDER ? (
                            <div>
                                <OwLabel isBold={true} title={"est_ship_date"} noBottomMargin={true} postText={":"} className={"me-1"} />
                                {UserService.parseDate(this.state.order.estimated_shipping_at)}
                            </div>
                        ) : null}
                        {this.state.order.order_batch_id && this.state.order?.Order_Batch ? (
                            <div>
                                <OwLabel title={"batch_hash"} postText={":"} className={"me-2"} />
                                {this.state.order.Order_Batch.batch_no || ""}
                            </div>
                        ) : null}
                        {(() => {
                            const fillValue = Number(this.state.order?.percentageFillable) || 0;
                            return this.state.currentView === OrderEntryViewStateOptionsEnum.ORDER_ENTRY &&
                                this.state.order &&
                                this.state.order.percentageFillable &&
                                this.props.userModel?.isSupplierUser &&
                                this.props.supplierModel.has_percent_fillable ? (
                                <div className={"mt-3 order-fill-status"}>
                                    <div className="d-flex align-items-center mb-1">
                                        <OwLabel title={"percentage_fillable"} postText={":"} className={"me-2"} isBold={true} />
                                        <NumericFormat
                                            value={this.state.order.percentageFillable}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            suffix={"%"}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                        />
                                    </div>
                                    <div className="order-fill-bar-track">
                                        <div
                                            className={`order-fill-bar-fill ${
                                                fillValue >= 80 ? "fill-green" : fillValue >= 50 ? "fill-yellow" : "fill-red"
                                            }`}
                                            style={{ width: `${Math.min(100, fillValue)}%` }}
                                        />
                                    </div>
                                </div>
                            ) : null;
                        })()}
                        {this.state.order &&
                        (this.state.order.Vendor?.freight_policy || this.props.supplierModel.default_freight_policy) ? (
                            <div className={"text-warning"}>
                                <OwLabel title={"freight_policy"} postText={":"} className={"me-1"} />
                                <OwLabel
                                    skipTranslate={true}
                                    leftIconClass={""}
                                    title={this.state.order.Vendor?.freight_policy || this.props.supplierModel.default_freight_policy}
                                />
                            </div>
                        ) : null}
                    </div>

                    <div className="col d-flex flex-column justify-content-end align-items-end no-wrap mt-3">
                        {this.state.isOnline && navigator.onLine ? (
                            <div>
                                {this.state.currentView === OrderEntryViewStateOptionsEnum.RMA ||
                                this.state.currentView === OrderEntryViewStateOptionsEnum.BACKORDER ||
                                this.state.currentView === OrderEntryViewStateOptionsEnum.PURCHASE_ORDER ||
                                this.props.userModel.supplierUserToken?.access_type_id === AccessTypesEnum.READ_ONLY ||
                                this.state.order.is_template ? null : this.props.supplierModel.Supplier_Integration.has_qbo &&
                                  this.state.order.order_state_id !== OrderStatesEnum.PRELIMINARY &&
                                  this.props.userModel?.isSupplierUser &&
                                  this.props.userModel?.userType?.id === UserTypesEnum.ADMIN ? (
                                    <div className={"mb-3 d-flex align-items-center justify-content-end"}>
                                        {this.props.supplierModel.Supplier_Integration.has_xero ? (
                                            <div className={"me-2"}>
                                                <OrderXeroInvoice orderModel={this.state.order} />
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}

                                {this.props.supplierModel.has_payments &&
                                this.props.supplierModel.default_payment_service_id === PaymentServiceTypeEnum.STRIPE &&
                                this.state.order.Payments &&
                                this.state.order.Payments.length > 0 ? (
                                    <StripePaymentCapture order={this.state.order} />
                                ) : null}

                                {this.shouldShowQboCreateInvoiceButton() ? (
                                    <div className={"mb-3 d-flex align-items-center justify-content-end"}>
                                        {this.props.supplierModel.Supplier_Integration.has_qbo_payments &&
                                        this.state.order.qbo_CardToUseDetail ? (
                                            <div>{this.getCaptureChargeBtn()}</div>
                                        ) : null}

                                        {this.state.order.Vendor?.Vendor_Integration?.qbo_CustomerId ? (
                                            this.state.currentView === OrderEntryViewStateOptionsEnum.RMA ||
                                            this.state.currentView === OrderEntryViewStateOptionsEnum.PURCHASE_ORDER ||
                                            this.state.currentView === OrderEntryViewStateOptionsEnum.BACKORDER ? null : (
                                                <OrderCreateQBOInvoice
                                                    order={this.state.order}
                                                    deleteQBOInvoice={this.deleteQBOInvoice}
                                                    viewQBOInvoice={this.viewQBOInvoice}
                                                    voidQBOInvoice={this.voidQBOInvoice}
                                                    createQBOInvoice={this.createQBOInvoice}
                                                    active={this.state.activeQboInvoice}
                                                    reloadOrderFn={() => {
                                                        this.getOrder("OrderCreateQBOInvoice", "order_entry");
                                                    }}
                                                />
                                            )
                                        ) : (
                                            <div className={"d-flex flex-column"}>
                                                <OwLabel className={"text-danger"} title={"unable_to_create_invoice"} />
                                                <OwLabel className={"text-danger"} title={"customer_not_connected_to_quickbooks"} />
                                            </div>
                                        )}
                                    </div>
                                ) : null}

                                {this.props.supplierModel.Supplier_Integration.has_qbo &&
                                this.state.order.is_quote &&
                                this.props.userModel?.isSupplierUser ? (
                                    <div>
                                        <QuoteCreateQBOEstimate
                                            order={this.state.order}
                                            createEstimateFn={this.createQBOEstimate}
                                            deleteEstimateFn={this.deleteQBOEstimate}
                                            viewEstimatePDFFn={this.viewQBOEstimatePDF}
                                            emailEstimateFn={this.emailQBOEstimate}
                                            getEstimateDataFromQboFn={this.getEstimateDataFromQbo}
                                            active={this.state.activeQboInvoice}
                                        />
                                    </div>
                                ) : null}

                                {this.state.order.order_state_id !== OrderStatesEnum.PRELIMINARY && this.props.userModel?.isSupplierUser ? (
                                    <div className={"d-flex justify-content-end me-3"}>{this.getMarkSpecReceivedButton()}</div>
                                ) : null}

                                {this.state.order?.Order_Detail?.spec_received_by_user_id ? (
                                    <div className={"mb-2"}>
                                        <OwLabel title={"spec_received_by"} postText={":"} className={"me-2"} />
                                        {this.state.order.Order_Detail?.Spec_Received_By_User?.name}
                                        <OwLabel title={"on"} className={"ms-2 me-2"} />
                                        {UserService.parseDate(this.state.order.Order_Detail?.spec_received_date)}
                                    </div>
                                ) : null}

                                {this.getCurrencyToggle()}

                                {this.props.userModel?.isSupplierUser &&
                                (this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN ||
                                    this.props.supplierModel.prompt_order_entry_create_po) ? (
                                    <div className={"d-flex me-3"}>
                                        {this.getBackorderButtons()}{" "}
                                        {
                                            <OrderEntryPurchaseOrderButtons
                                                cancelPurchaseOrders={this.cancelPurchaseOrders}
                                                createPurchaseOrders={this.createPurchaseOrders}
                                                hasOnePurchaseOrderRowChecked={this.hasOnePurchaseOrderRowChecked}
                                                currentView={this.state.currentView}
                                                startPurchaseOrder={this.startPurchaseOrder}
                                                order={this.state.order}
                                            />
                                        }{" "}
                                        {
                                            <OrderEntryRmaButtons
                                                cancelRma={this.cancelRma}
                                                createRma={this.createRma}
                                                hasOneRmaRowChecked={this.hasOneRmaRowChecked}
                                                currentView={this.state.currentView}
                                                order={this.state.order}
                                                isCreatingRma={this.state.isCreatingRma}
                                            />
                                        }{" "}
                                        {this.getAcknowledgeButtons()}
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <OwLabel leftIconClass={"fad fa-wifi-slash"} title={"offline"} className={"text-warning"} />
                        )}
                    </div>
                </div>
                <div
                    className={
                        "row justify-content-center mb-2 mb-md-0 " +
                        (this.state.order && (this.state.order.is_quote || this.state.order.is_template) ? "d-none" : "d-flex")
                    }>
                    {!this.state.isOfflineOrder && this.state.currentView === OrderEntryViewStateOptionsEnum.ORDER_ENTRY ? (
                        <OrderProgressTracker orderStateId={orderStateId} order={this.state.order} />
                    ) : null}
                </div>
                {this.state.currentView !== OrderEntryViewStateOptionsEnum.ORDER_ENTRY ? null : (
                    <div className="row mb-3">
                        <div className={"col-12"}>{this.getOrderDetailsPanel()}</div>
                    </div>
                )}
                {this.props.supplierModel.has_no_order_items ? null : (
                    <div
                        id={"orderInputPanel"}
                        className={
                            "row " +
                            (this.state.order.is_quote &&
                            this.props.supplierModel.disable_vendor_order_entry &&
                            !this.props.userModel?.isSupplierUser
                                ? "d-none"
                                : "")
                        }>
                        {this.isReadOnly() || this.state.currentView !== OrderEntryViewStateOptionsEnum.ORDER_ENTRY ? null : (
                            <div className="col-12 d-print-none">{this.getOrderInputPanel()}</div>
                        )}
                    </div>
                )}
                {this.props.supplierModel.has_no_order_items ? null : (
                    <div
                        className={
                            "mt-2 mb-2 d-flex " +
                            (this.props.supplierModel.has_cost_pricing && this.props.userModel?.isSupplierUser
                                ? "justify-content-between"
                                : "justify-content-end")
                        }>
                        <div className={"d-flex justify-content-start flex-grow d-print-none"}>
                            {this.state.currentView === OrderEntryViewStateOptionsEnum.BACKORDER ||
                            this.state.currentView === OrderEntryViewStateOptionsEnum.PURCHASE_ORDER
                                ? null
                                : this.renderOrderTotalProfitAndMargin(profitClassName, profit, profitMargin)}
                            {this.state.currentView === OrderEntryViewStateOptionsEnum.ORDER_ENTRY &&
                            showInventoryDetails &&
                            !this.props.supplierModel.hide_order_detail_info ? (
                                <OwToggle
                                    labelOnRight={true}
                                    name={"show_detail_info"}
                                    label={"show_detail_info"}
                                    fn={this.toggleDetailInfo}
                                    active={this.state.showRowDetailInfo}
                                />
                            ) : null}
                            {
                                <div className="ms-2 me-2 no-wrap">
                                    {this.state.currentView === OrderEntryViewStateOptionsEnum.ORDER_ENTRY &&
                                    this.state.order.Order_Items &&
                                    this.state.order.Order_Items.length > 1 &&
                                    !this.isReadOnly() ? (
                                        <OwButton
                                            title={this.state.isDragMode ? "exit_drag_mode" : "reorder_items"}
                                            fn={this.toggleDragMode}
                                            className={this.state.isDragMode ? "btn-success" : "btn-secondary"}
                                            disableWidthOnClick={true}
                                        />
                                    ) : null}
                                </div>
                            }
                        </div>

                        <div className={"d-print-none"}>
                            <OwToggleOrderEntryTableView
                                updateTableView={this.updateTableView}
                                hasPhotos={this.state.orderItemType === "NUTS"}
                                match={this.props.match}
                            />
                        </div>
                    </div>
                )}
                {this.props.supplierModel.has_no_order_items ? null : (
                    <div className={"table-responsive position-relative"}>
                        <ConfirmDeleteOverlayFn
                            nestedParentElem={"orderItemTable"}
                            targetElem={this.state.selectedRowId}
                            handleConfirm={this.commitDelete}
                            handleCancel={this.cancelDelete}
                            message={"are_you_sure_you_want_to_delete_this_item"}
                            skipMainView={true}
                        />

                        {this.state.isDragMode ? (
                            <DraggableSortableTable
                                orderItems={this.state.order.Order_Items}
                                columns={this.state.columns.filter((col) => !col.isActionsCol)}
                                tableType={this.state.tableType}
                                isDataFetching={this.state.isDataFetching}
                                isInitialData={this.state.isInitialData}
                                sortCol={this.state.sortCol}
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                onDragStart={this.handleDragStart}
                                onDragEnd={this.handleDragEnd}
                            />
                        ) : (
                            <OwTable
                                id={"orderItemTable"}
                                tableConfig={{
                                    tableSmall: this.state.tableType === TableTypeEnum.SMALL,
                                    tableHover: true,
                                    tableStriped: false,
                                    tableHasSort: true,
                                    alignHeadersMiddle: true,
                                    hasDetailView: true,
                                }}
                                tableClassName={""}
                                columns={this.state.columns}
                                dataSet={this.state.order.Order_Items}
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                dataFetch={this.state.isDataFetching}
                                initialData={this.state.isInitialData}
                                detailViewAlwaysVisible={this.state.tableType === TableTypeEnum.PHOTOS}
                                rowDetailViewFn={this.rowHasDetailView}
                                // detailViewColumns={this.state.detailTableCols}
                                detailViewComponent={this.renderDetailView}
                                detailViewColSpan={this.state.detailColSpan}
                                currentSortCol={this.state.sortCol}
                            />
                        )}
                    </div>
                )}
                <div className="mt-2 row justify-content-between">
                    {this.state.currentView !== OrderEntryViewStateOptionsEnum.ORDER_ENTRY ? null : (
                        <div className={"col-auto d-flex flex-column"}>
                            <div className="d-inline-block">{this.getTotalItemCount()}</div>
                            {this.getTotalOrderWeightDiv()}
                            {this.getCategoryTally()}
                        </div>
                    )}
                    {this.state.currentView !== OrderEntryViewStateOptionsEnum.ORDER_ENTRY ||
                    this.props.supplierModel.has_no_order_items ? null : (
                        <div className={"col-auto d-flex justify-content-end"}>
                            <OrderTotalsPanel
                                shouldHidePricingFn={this.shouldHidePricing}
                                order={this.state.order}
                                orderItemType={this.state.orderItemType}
                                orderTotalWeight={this.getTotalOrderWeight()}
                                doCurrencyConversion={this.state.doCurrencyConversion}
                            />
                        </div>
                    )}
                </div>

                <ReactModal
                    shouldCloseOnEsc={this.state.closeModalOnEsc}
                    shouldCloseOnOverlayClick={this.state.closeModalOnOverlayClick}
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal}
                    contentLabel="Modal"
                    style={this.state.modalStyle}
                    className={"modalClass"}
                    overlayClassName={"overlayClass"}
                    ariaHideApp={true}>
                    {this.state.modalComponent}
                </ReactModal>

                {this.state.currentView !== OrderEntryViewStateOptionsEnum.ORDER_ENTRY ||
                this.props.userModel.supplierUserToken?.access_type_id === AccessTypesEnum.READ_ONLY ? null : (
                    <OrderEntryFloatingSubmit
                        submitFn={this.submitOrderFn}
                        hideSubmitBtn={!!this.state.order.is_quote || !!this.state.order.is_template}
                        order={this.state.order}
                        hasPendingDetailChanges={this.state.hasPendingDetailChanges}
                        btnActive={this.state.stepBtnActive}
                        hasEditMode={this.state.hasEditMode}
                        isFineDetailsValid={this.state.isFineDetailsValid}
                        hasPendingFineDetailChanges={
                            this.state.hasPendingFineDetailChanges || this.state.hasPendingCustomScheduleDetailChanges
                        }
                        hasRowsInEditMode={this.state.hasRowsInEditMode}
                        convertQuoteToOrderActive={this.state.convertQuoteToOrderActive}
                    />
                )}
            </div>
        );
    }
}

export default OrderEntry;
